/* eslint-disable no-restricted-syntax */
/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
/*
Item: Satistics component
Name: Statistics
Format: Code/Frontend component
*/

import React, { Component } from 'react';
import { InputSwitch } from 'primereact/inputswitch';
import { Menubar } from 'primereact/menubar';
import update from 'immutability-helper';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Button } from 'primereact/button';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { OverlayPanel } from 'primereact/overlaypanel';
import { DataView } from 'primereact/dataview';
import { Tree } from 'primereact/tree';
import { TreeTable } from 'primereact/treetable';
import { RadioButton } from 'primereact/radiobutton';
import { ToggleButton } from 'primereact/togglebutton'
import '../styles/statistics.css';
import { Growl } from 'primereact/growl';
import { SelectButton } from 'primereact/selectbutton';
import Container from '../components/dragdrop/Container';
import ValueDialog from '../components/dialogue/ValueDialog';
import CalcDialog from '../components/dialogue/CalcDialog';
// import SelectOutputDialog from '../components/dialogue/deprecated SelectOutputDialog';
import SaveTableDialog from '../components/dialogue/SaveTableDialog';
import ExportTableDialog from '../components/dialogue/ExportTableDialog';
import JobTableDialog from '../components/dialogue/JobTableDialog';
import ClearTableDialog from '../components/dialogue/ClearTableDialog';
import MessageService from '../service/MessageService';
import Recycler from '../components/dragdrop/Recycler';
import ColContainer from '../components/dragdrop/ColContainer';
import DataContainer from '../components/dragdrop/DataContainer';
import HeadingsContainer from '../components/dragdrop/HeadingsContainer';
import { MultiLanguage } from '../utils/MultiLanguage';
import JsonHelper, {
  VariableTypeEnum, getEntryNum, maximizeTable,
  saveVariables, changeVariables,
} from '../utils/statisticsUtils';
import TreeSerializer from '../utils/TreeSerializer';
import templateTable from '../service/data/TemplateTable.json';
import { DropdownLabeled } from '../components/DropdownLabeled';
import { DestatisTableRenderer2 } from '../pocComponents/TableRenderers';
/* 
import {
  hasPermission, actions, returnUserRights,
} from '../utils/roleUtils';
*/
import ExtraContainer from '../components/dragdrop/ExtraContainer';

const ruleType = Object.freeze({
  ALGORITHM: 6,
  HIERARCHY: 7,
  REFERENCE: 8,
});

const { DEBUG_FLAG } = window;
const log = function consoleLog(...args) {
  // eslint-disable-next-line no-console
  if (DEBUG_FLAG) console.log(...args);
};
let numberOfLoads = 0;

function sortFunction(a, b) {
  let returnValue = 0;
  if (this.state[a] && this.state[b]) {
    if (this.state[a].length > 0 && this.state[b].length > 0) {
      returnValue = 0;
    } else if (this.state[a].length > 0 && this.state[b].length === 0) {
      returnValue = -1;
    } else if (this.state[a].length === 0 && this.state[b].length > 0) {
      returnValue = 1;
    } else {
      returnValue = 0;
    }
  }
  return returnValue;
}

function findLast(obj) {
  if (obj.children.length === 0) {
    return obj;
  } else {
    return findLast(obj.children[0]);
  }
}

export default class Statistics extends Component {
  constructor() {
    super();
    this.state = {
      regelStufen: [],
      activeIndex: 0,
      sepQual: true,
      valueEmptyLines: false,
      previewDeactivated: false,
      clearRules: true,
      mounted: false,
      jobObj: {},
      jobTableVisible: false,
      manualJobTableVisible: false,
      clearTableVisible: false,
      clearTableVisible: false,
      loadComplete: false,
      measureUnits: [],
      calcModeOn: false,
      calcModeOnById: {},
      visible: true,
      visibleRender: false,
      data_html: '',
      value: true,
      value1: 'Off',
      options: ['Off', 'On'],
      elements: {
        TIME_IDENTIFYING: [],
        TIME_CLASSIFYING: [],
        VALUE: [],
        REGION_CLASSIFYING: [],
        SUBJECT_CLASSIFYING: [],
        RULE: [],
      },
      elements1: { VALUE: [] },
      elements2: {
        TIME_CLASSIFYING: [],
        REGION_CLASSIFYING: [],
        REGION_CLASSIFYING_TOTAL: [],
        SUBJECT_CLASSIFYING: [],
        SUBJECT_CLASSIFYING_TOTAL: [],
      },
      elements3: { VALUE: [] },
      filter: [],
      filtered: 'default',
      filter_graph: [],
      precondition_graph: [],
      pureFilter_graph: [],
      merkmal1: [],
      headings: [],
      headings_graph: [],
      zeilen: [],
      zeilen_graph: [],
      spalte1: [],
      spalte1_graph: [],
      tableRendered: [],
      rulesMap: {},
      auspraegungenMap: {},
      selectedValues: '',
      // TODO: umbenennen
      // die folgenden arr-Variablen sind eigentl. obj-Variablen
      arrSelectedTreeNodes: {},
      outputEntry: {},
      isDialogOpen: false,
      hierarchySelection: {},
      isLoadingRule: false,
      arrFiltersById: {},
      arrRuleById: {},
      arrRuleCharById: {},
      arrRulesById: {},
      arrDisplayRulesById: {},
      arrRuleOutputById: {},
      arrSortingById: {},
      arrDisplayById: {},
      arrBMMById: {},
      arrNameById: {},
      arrDirectionById: {},
      arrSumUpById: {},
      sumUp: {},
      arrCalcUpById: {},
      prefixById: {},
      globalFilter: [],
      selectedSum: [], // deprecated?
      selectedId: '',
      checked1: true, // deprecated?
      checked2: true, // deprecated?
      table_html: {}, // deprecated?
      colHelperArray: [],
      rowHelperArray: [],
      hideRetrievalButton: false,
      overlayFilter: ['', '', '', '', '', ''],
      overlayHasFilter: [false, false, false, false, false, false],
      overlayId: 0,
      overlayFilteredList: [undefined, undefined, undefined, undefined, undefined, undefined],
      showAverage: {},
      showMedian: {},
      dataTemp: [
        {
          "key": "0",
          "label": "Documents",
          "data": "Documents Folder",
          "icon": "pi pi-fw pi-inbox",
          "children": [{
            "key": "0-0",
            "label": "Work",
            "data": "Work Folder",
            "icon": "pi pi-fw pi-cog",
            "children": [{ "key": "0-0-0", "label": "Expenses.doc", "icon": "pi pi-fw pi-file", "data": "Expenses Document" }, { "key": "0-0-1", "label": "Resume.doc", "icon": "pi pi-fw pi-file", "data": "Resume Document" }]
          },
          {
            "key": "0-1",
            "label": "Home",
            "data": "Home Folder",
            "icon": "pi pi-fw pi-home",
            "children": [{ "key": "0-1-0", "label": "Invoices.txt", "icon": "pi pi-fw pi-file", "data": "Invoices for this month" }]
          }]
        },
        {
          "key": "1",
          "label": "Events",
          "data": "Events Folder",
          "icon": "pi pi-fw pi-calendar",
          "children": [
            { "key": "1-0", "label": "Meeting", "icon": "pi pi-fw pi-calendar-plus", "data": "Meeting" },
            { "key": "1-1", "label": "Product Launch", "icon": "pi pi-fw pi-calendar-plus", "data": "Product Launch" },
            { "key": "1-2", "label": "Report Review", "icon": "pi pi-fw pi-calendar-plus", "data": "Report Review" }]
        },
        {
          "key": "2",
          "label": "Movies",
          "data": "Movies Folder",
          "icon": "pi pi-fw pi-star",
          "children": [{
            "key": "2-0",
            "icon": "pi pi-fw pi-star",
            "label": "Al Pacino",
            "data": "Pacino Movies",
            "children": [{ "key": "2-0-0", "label": "Scarface", "icon": "pi pi-fw pi-video", "data": "Scarface Movie" }, { "key": "2-0-1", "label": "Serpico", "icon": "pi pi-fw pi-video", "data": "Serpico Movie" }]
          },
          {
            "key": "2-1",
            "label": "Robert De Niro",
            "icon": "pi pi-fw pi-star",
            "data": "De Niro Movies",
            "children": [{ "key": "2-1-0", "label": "Goodfellas", "icon": "pi pi-fw pi-video", "data": "Goodfellas Movie" }, { "key": "2-1-1", "label": "Untouchables", "icon": "pi pi-fw pi-video", "data": "Untouchables Movie" }]
          }]
        }
      ],
      colArray: [[]],
      colGraphArray: [[]],
      rowArray: [[]],
      rowGraphArray: [[]],
      dataTempVal: null,
      dataTemp: [
        {
          "key": "0",
          "label": "Documents",
          "data": "Documents Folder",
          "icon": "pi pi-fw pi-inbox",
          "children": [{
            "key": "0-0",
            "label": "Work",
            "data": "Work Folder",
            "icon": "pi pi-fw pi-cog",
            "children": [{ "key": "0-0-0", "label": "Expenses.doc", "icon": "pi pi-fw pi-file", "data": "Expenses Document" }, { "key": "0-0-1", "label": "Resume.doc", "icon": "pi pi-fw pi-file", "data": "Resume Document" }]
          },
          {
            "key": "0-1",
            "label": "Home",
            "data": "Home Folder",
            "icon": "pi pi-fw pi-home",
            "children": [{ "key": "0-1-0", "label": "Invoices.txt", "icon": "pi pi-fw pi-file", "data": "Invoices for this month" }]
          }]
        },
        {
          "key": "1",
          "label": "Events",
          "data": "Events Folder",
          "icon": "pi pi-fw pi-calendar",
          "children": [
            { "key": "1-0", "label": "Meeting", "icon": "pi pi-fw pi-calendar-plus", "data": "Meeting" },
            { "key": "1-1", "label": "Product Launch", "icon": "pi pi-fw pi-calendar-plus", "data": "Product Launch" },
            { "key": "1-2", "label": "Report Review", "icon": "pi pi-fw pi-calendar-plus", "data": "Report Review" }]
        },
        {
          "key": "2",
          "label": "Movies",
          "data": "Movies Folder",
          "icon": "pi pi-fw pi-star",
          "children": [{
            "key": "2-0",
            "icon": "pi pi-fw pi-star",
            "label": "Al Pacino",
            "data": "Pacino Movies",
            "children": [{ "key": "2-0-0", "label": "Scarface", "icon": "pi pi-fw pi-video", "data": "Scarface Movie" }, { "key": "2-0-1", "label": "Serpico", "icon": "pi pi-fw pi-video", "data": "Serpico Movie" }]
          },
          {
            "key": "2-1",
            "label": "Robert De Niro",
            "icon": "pi pi-fw pi-star",
            "data": "De Niro Movies",
            "children": [{ "key": "2-1-0", "label": "Goodfellas", "icon": "pi pi-fw pi-video", "data": "Goodfellas Movie" }, { "key": "2-1-1", "label": "Untouchables", "icon": "pi pi-fw pi-video", "data": "Untouchables Movie" }]
          }]
        }
      ],
    };
    this.statistics = [
      { name: '21311' },
      { name: '21321' },
      { name: '21341' },
      { name: '21351' },
      { name: '21352' },
      { name: '21371' },
    ];
    this.display = [
      { label: 'Fachschlüssel', value: 'FS' },
      { label: 'Klarname', value: 'KN' },
      { label: 'Fachschlüssel und Klarname', value: 'FSKN' },
      { label: 'Klassifikationsschlüssel', value: 'KS' },
      { label: 'Klassifikationsschlüssel und Klarname', value: 'KSKN' },
      { label: 'Fachschlüssel und Klassifikationsschlüssel', value: 'FSKS' },
      // { label: 'Position', value: 'PS' },
    ];
    this.displayRulesEmpty = [
      { label: 'keine Regel', value: '' },
    ];
    this.sorting = [
      { label: 'Fachschlüssel', value: 'FS' },
      { label: 'Klarname', value: 'KN' },
      { label: 'Klassifikationsschlüssel', value: 'KS' },
      // { label: 'Position', value: 'PS' },
    ];
    this.direction = '';
    // bind for JSX
    this.selectedStatisticsTemplate = this.selectedStatisticsTemplate.bind(this);
    this.clearInput = this.clearInput.bind(this);
    this.showSearchOverlay = this.showSearchOverlay.bind(this);
    this.sortFunction = sortFunction.bind(this);
    // new
    this.messageService = new MessageService();
    this.multiLanguage = new MultiLanguage();
    // log('MultiLanguage#0', this.multiLanguage);
    // this.db = new PouchDB('http://genesis-test-web01-neu:5984/lookupFullElements');
    this.folders = {
      root:
        [
          {
            key: '0',
            data: {
              foldername: 'Persönlicher Ordner',
              rightArea: 'BEN',
            },
          },
          {
            key: '1',
            data: {
              foldername: 'Gruppenordner',
              rightArea: 'GRP',
            },
          },
          {
            key: '2',
            data: {
              foldername: 'Amtsinterner Ordner',
              rightArea: 'OFFICE',
            },
          },
          {
            key: '3',
            data: {
              foldername: 'Öffentlicher Ordner',
              rightArea: 'FREE',
            },
          },
        ],
    };
  }

  async onMountLoadData() {
    const { elements1, elements2, elements3 } = this.state;
    const selectedRegional = sessionStorage.getItem('evaluationRegional');
    const elementsDataNew = sessionStorage.getItem('evaluationStatistics').split(',');
    const selectedStatistics = elementsDataNew.map((entry) => ({ name: entry }));
    const strUNDEF = 'UNDEF';
    // time slice intersection
    const intersection = await this.returnIntersection(selectedStatistics);
    // darf keine gespeicherte Statistik laden, wenn es keine Schnittmenge gibt
    try {
      // ### getrennte Aufrufe für Nachladen 2586
      let elementsDataTmp;
      let entrys = [];
      zusatzfilter = 'ZI' // Zeitidentifizierend
      elementsDataTmp = await this.messageService.postDataStockProperties(selectedStatistics, 'structureElementsListFromStatistic', 'structure', this.returnLandString(), zusatzfilter);
      entrys = entrys.concat(elementsDataTmp.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys);
      let zusatzfilter = 'ZK' // Zeitklassifizierend
      elementsDataTmp = await this.messageService.postDataStockProperties(selectedStatistics, 'structureElementsListFromStatistic', 'structure', this.returnLandString(), zusatzfilter);
      entrys = entrys.concat(elementsDataTmp.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys);
      zusatzfilter = 'W' // Wertmerkmal
      elementsDataTmp = await this.messageService.postDataStockProperties(selectedStatistics, 'structureElementsListFromStatistic', 'structure', this.returnLandString(), zusatzfilter);
      entrys = entrys.concat(elementsDataTmp.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys);
      let elementsList = this.prepareElements(entrys);
      let merkmale = this.prepareMerkmale(entrys);
      const { elements } = this.state;
      // split axesList to vars
      // console.log('TYPE#', elementsList);
      for (let i = 0; i < elementsList.length; i += 1) {
        const { type, code } = elementsList[i];
        // console.log('TYPE#', code, type);
        if (type !== strUNDEF) {
          if (!(code.substr(0, 4) === 'SEED' && type === 'VALUE')) {
            elements[elementsList[i].type].push(elementsList[i]);
          }
        }
      }
      this.growl.show({
        closable: true,
        sticky: true,
        severity: 'info',
        summary: 'Hinweis',
        detail: 'Es werden noch weitere Merkmale geladen.',
      });
      // Frontend-Update
      this.setState({
        merkmale,
        elements, // ZIMM, ZKMM, WMM
        selectedStatistics,
        intersection,
        selectedRegional,
        visible: false,
      });
      // zweiter Teil
      entrys = [];
      zusatzfilter = 'RK' // Regionalklassifizierend
      elementsDataTmp = await this.messageService.postDataStockProperties(selectedStatistics, 'structureElementsListFromStatistic', 'structure', this.returnLandString(), zusatzfilter);
      entrys = entrys.concat(elementsDataTmp.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys);
      zusatzfilter = 'SK' // Sachlich Klassifizierend
      elementsDataTmp = await this.messageService.postDataStockProperties(selectedStatistics, 'structureElementsListFromStatistic', 'structure', this.returnLandString(), zusatzfilter);
      entrys = entrys.concat(elementsDataTmp.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys);
      const elementsListTwo = this.prepareElements(entrys);
      const merkmaleTwo = this.prepareMerkmale(entrys);
      merkmale = merkmale.concat(merkmaleTwo);
      // split axesList to vars
      for (let i = 0; i < elementsListTwo.length; i += 1) {
        const { type, code } = elementsListTwo[i];
        if (type !== strUNDEF) {
          if (!(code.substr(0, 4) === 'SEED' && type === 'VALUE')) {
            elements[elementsListTwo[i].type].push(elementsListTwo[i]);
          }
        }
      }

      const elementsData1 = await this.messageService.postDataStockProperties(selectedStatistics, 'algorithmruleStructureElementsListFromStatistic', 'structure', this.returnLandString());
      const elementsData2 = await this.messageService.postDataStockProperties(selectedStatistics, 'referenceruleStructureElementsListFromStatistic', 'structure', this.returnLandString());
      const elementsData3 = await this.messageService.postDataStockProperties(selectedStatistics, 'averageStructureElementsListFromStatistic', 'structure', this.returnLandString());
      if (elementsData1[1] !== 'error') {
        const elementsAr = elementsData1.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys;
        const elementsList1 = this.prepareElements(elementsAr);
        let merkmale1 = this.prepareMerkmale(elementsAr);
        for (let i = 0; i < elementsList1.length; i += 1) {
          if (elementsList1[i].type !== 'UNDEF') {
            if (!(elementsList1[i].code.substr(0, 4) === 'SEED' && elementsList1[i].type === 'VALUE')) {
              elements1[elementsList1[i].type].push(elementsList1[i]);
            }
          }
        }
        if (elements1) elements1.VALUE.sort(this.sortByPropertyValue('name')); // sort according to titel.langText[]/de
      } else {
        merkmale1 = [];
      }
      if (elementsData2[1] !== 'error') {
        const elementsRr = elementsData2.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys;
        // remove double from elementsRr
        const elementsRrUnique = [];
        const register = {};
        let r = 0;
        elementsRr.forEach(function (item) {
          if (!register[item.name]) {
            elementsRrUnique[r] = item;
            r += 1;
          }
          register[item.name] = true;
        });
        const elementsList2 = this.prepareElements(elementsRrUnique);
        let merkmale2 = this.prepareMerkmale(elementsRr);
        for (let i = 0; i < elementsList2.length; i += 1) {
          if (elementsList2[i].type !== 'UNDEF') {
            if (!(elementsList2[i].code.substr(0, 4) === 'SEED' && elementsList2[i].type === 'VALUE')) {
              elements2[elementsList2[i].type].push(elementsList2[i]);
            }
          }
        }
      } else {
        merkmale2 = [];
      }
      if (elementsData3[1] !== 'error') {
        const elementsAverageMedian = elementsData3.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys;
        const elementsList3 = this.prepareElements(elementsAverageMedian, true);
        let merkmale3 = this.prepareMerkmale(elementsAverageMedian);
        for (let i = 0; i < elementsList3.length; i += 1) {
          if (elementsList3[i].type !== 'UNDEF') {
            if (!(elementsList3[i].code.substr(0, 4) === 'SEED' && elementsList3[i].type === 'VALUE')) {
              elements3[elementsList3[i].type].push(elementsList3[i]);
            }
          }
        }
      } else {
        merkmale3 = []; // 448 bugfix
      }
      this.setState({
        merkmale,
        elements, // ZIMM, ZKMM, WMM, RM, SKMM
        merkmale1,
        elements1,
        merkmale2,
        elements2,
        merkmale3,
        elements3,
      });

      const loadTable = (sessionStorage.getItem('loadTable') !== 'false');
      const { location } = this.props;
      if (location.state) {
        const { wasSwitchedToLand } = location.state;
        if (wasSwitchedToLand) {
          await this.switchRegionals();
          if (loadTable) {
            await this.renderTable();
          }
        }
      }
    } catch (e) {
      log('Error in onMountLoadData', e);
    } finally {
      /*
      this.setState({
        visible: false,
        selectedStatistics,
      });
      */
      this.growl.clear();
      this.growl.show({
        severity: 'success',
        summary: 'Abgeschlossen',
        detail: 'Merkmale wurden vollständig geladen.',
      });
    }
  }

  getMeasureUnits = async () => {
    const right = 'ALL';
    const type = 'measureunit';
    const objectTyp = 'UNIT';
    const objectNumber = '2'; // UNIT='2'
    const typeString = 'Maßeinheit';
    const measureUnits = [];
    try {
      const elementsData = await this.messageService.postVariableDirectory('directory', type, right, objectNumber, objectTyp, typeString);
      const { entrys } = await elementsData.data.contents['genesis.container.content.GenesisTMContent'].transfermodel;
      for (let i = 0; i < entrys.length; i += 1) {
        measureUnits.push({ label: this.multiLanguage.returnInLanguage(entrys[i], 'de'), value: entrys[i].name });
      }
    } catch (err) {
      log('ERROR in getMeasureUnits', err);
    }
    return measureUnits;
  }

  // onLoad read current data
  componentDidMount = async () => {
    try {
      // const { elements1, elements2 } = this.state;
      const loadTable = (sessionStorage.getItem('loadTable') !== 'false');
      // const group = sessionStorage.getItem('group'); // ADBHSSTAT-1514
      this.createRecycler();
      this.createColContainers();
      this.createRowContainers();
      const measureUnits = await this.getMeasureUnits();
      this.setState({ measureUnits });
      const { location } = this.props;
      // saved table found
      if (location.state) {
        // const { arrRefItem, arrNewItem } = location.state;
        const deactivateSectetSelect = false;
        // if (group !== 'StBA') deactivateSectetSelect = true; // ADBHSSTAT-1514
        const {
          loadedTable,
          wasSwitchedToLand, // selection Land/Bund
        } = location.state;
        let loadedTableSt = loadedTable.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0];
        loadedTableSt = JsonHelper.deepCopy(loadedTableSt);
        // open standard tables as normal table #825
        if (loadedTableSt.typ === 'DEFAULT') {
          loadedTableSt.typ = 'STRUCTURE';
          /*
          loadedTableSt.ownerInfo.user = '';
          loadedTableSt.ownerInfo.userID = -1;
          loadedTableSt.ownerInfo.group = '';
          loadedTableSt.ownerInfo.groupID = -1;
          */
        }
        const tableTyp = loadedTableSt.typ;
        const loadedStructure = JSON.parse(loadedTableSt.jsonStructure);
        loadedStructure.tableTyp = tableTyp;
        delete loadedStructure.saveTableVisible;

        // Laden von Tabellen die vor der Umsetzung von ADBHSSTAT-2658 gespeichert wurden
        if (loadedStructure['spalte1'] !== undefined && loadedStructure['spalte1'].length > 0
        && (loadedStructure.colArray === undefined || loadedStructure.colArray?.length === 0)
        && (loadedStructure.colGraphArray === undefined || loadedStructure.colGraphArray?.length === 0)) {
          loadedStructure.colArray = [];
          loadedStructure.colGraphArray = [];

          for (let i = 1; i <= 40; i++) {
            if (loadedStructure[`spalte${i}`] && loadedStructure[`spalte${i}`].length > 0) {
              loadedStructure.colArray.push(loadedStructure[`spalte${i}`]);
              loadedStructure.colGraphArray.push(loadedStructure[`spalte${i}_graph`]);
            }
          }
        }

        if(loadedStructure['zeilen'] !== undefined && loadedStructure['zeilen'].length > 0
        && (loadedStructure.rowArray === undefined || loadedStructure.rowArray?.length === 0)
        && (loadedStructure.rowGraphArray === undefined || loadedStructure.rowGraphArray?.length === 0)) {
          loadedStructure.rowArray = [];
          loadedStructure.rowGraphArray = [];
          for (let i = 1; i <= 40; i++) {
            // Beim laden von alten Tabellen fehlen die properties "spalte1" und "spalte1_graph"
            // Die Werte davon scheinen in den properties "spalten" und spalten_graph zu stehen
            // Das laden hat bei der vorherigen Implementation aber scheinbar so funktioniert
            if (loadedStructure[`zeile${i > 1 ? i : 'n'}`] && loadedStructure[`zeile${i > 1 ? i : 'n'}`].length > 0) {
              loadedStructure.rowArray.push(loadedStructure[`zeile${i > 1 ? i : 'n'}`]);
              loadedStructure.rowGraphArray.push(loadedStructure[`zeile${i > 1 ? i : 'n'}_graph`]);
            }
          }
        }

        // Spaltengraph falls leer befüllen ADBHSSTAT-2826
        if (loadedStructure.colGraphArray?.length === 0 || loadedStructure.colGraphArray?.[0]?.length === 0){
          loadedStructure.colArray.forEach((col, i) => this.makeNestedListCol2(i, col))
          loadedStructure.colGraphArray = this.state.colGraphArray;
          if (loadedStructure.colGraphArray.length === 0) loadedStructure.colGraphArray.push([]);
        } 

         // Zeilengraph falls leer befüllen ADBHSSTAT-2826
        if (loadedStructure.rowGraphArray?.length === 0 || loadedStructure.rowGraphArray?.[0]?.length === 0){
          loadedStructure.rowArray.forEach((row, i) => this.makeNestedListRows2(i, row))
          loadedStructure.rowGraphArray = this.state.rowGraphArray;
          if (loadedStructure.rowGraphArray.length === 0) loadedStructure.rowGraphArray.push([]);
        }

        // Wenn Spalten oder Zeilen leer sind State vorbefüllen
        if (loadedStructure.colArray?.length === 0) loadedStructure.colArray.push([]);
        if (loadedStructure.rowArray?.length === 0) loadedStructure.rowArray.push([]);

        if (loadTable) { // false = Teil 1799
          // TODO eigentlich müsste das nicht gemacht werden, da es später geladen wird
          if (wasSwitchedToLand) {
            this.setState(loadedStructure, () => {
              this.renderTable(loadedStructure.valueEmptyLines, loadedStructure.value, loadedTable);
            });
          } else {
            this.setState(loadedStructure, () => {
              this.renderTable(loadedStructure.valueEmptyLines, undefined, undefined); // 1670
            });
          }
        } else {
          // ausgewählte MM setzen
          // dabei beachten, ob Land oder Bund
          // oder ggf. verhindern, dass geladen wird
          // dann ist dieses else nicht notwendig
          await this.fillVariables(loadedStructure);
        }
        this.setState({
          deactivateSectetSelect,
          visible: true,
          elements: {
            TIME_IDENTIFYING: [],
            TIME_CLASSIFYING: [],
            VALUE: [],
            REGION_CLASSIFYING: [],
            SUBJECT_CLASSIFYING: [],
            RULE: [],
          },
          elements1: { VALUE: [] },
          elements2: {
            TIME_CLASSIFYING: [],
            REGION_CLASSIFYING: [],
            REGION_CLASSIFYING_TOTAL: [],
            SUBJECT_CLASSIFYING: [],
            SUBJECT_CLASSIFYING_TOTAL: [],
          },
          merkmale1: [],
          merkmale2: [],
          merkmale3: [],
          disableCache: '',
        });
      }
      /*
      if ((location.state && sessionStorage.getItem('group') !== 'StBA') || !location.state) {
        // log('LOADEDTABLE# load MM');
      }
      */
      await this.onMountLoadData();
      await this.loadValues2();
    } catch (err) {
      log('error in componentDidMount:', err);
    } finally {
      this.setState({ mounted: true });
    }
  };

  pushedCardToFilterHint(targetContainer) {
    if (targetContainer === 'filter') {
      this.growl.show({
        life: 10000,
        severity: 'info',
        summary: 'Hinweis',
        detail: 'Bitte prüfen Sie nach der Ver- schiebung des Merkmals in den Bereich "Vorbedingungen/Filter" Ihre Auswahl an Ausprägungen.',
      });
    }
  }

  sortByProperty(property) {
    return function (a, b) {
      let ret = 0;  // TODO#BUG?
      // log('elements1#1', a)
      if (a[property] > b[property]) {
        ret = 1;
      } else if (a[property] < b[property]) {
        ret = -1;
      }
      return ret;
    };
  }

  sortByPropertyValue(property) {
    return function (a, b) {
      let ret = 0;
      const value1 = a.titel.langText[0].text;
      const value2 = b.titel.langText[0].text;
      if (value1 > value2) {
        ret = 1;
      } else if (value1 < value2) {
        ret = -1;
      }
      return ret;
    };
  }

  getUniqueId() {
    return "id" + Math.random().toString(16).slice(2) + "-" + (new Date()).getTime();
  }

  /**
   * Erzeugt eine neue Spaltendefinition mir dem übergebenen Merkmal
   * @param {*} nextCol Index der neuen Spaltendefinition
   * @param {*} incard Merkmal
   * @param {*} targetContainer 
   */
  async pushCardToExtraCol(nextCol, incard, targetContainer) {

    const card = {...incard}//JsonHelper.deepCopy(incard)
    const { showAverage, showMedian } = this.state;
    const { medianOnly, averageOnly } = card?.output[0]?.reference;
    const { name, type, ruleName } = card;

    if (card.uniqueId === '') { // diese Card ist neu
      card.uniqueId = this.getUniqueId(); // set ID for connection btw. card and Statistics.jsx

      showMedian[card.uniqueId] = medianOnly; // 781
      showAverage[card.uniqueId] = averageOnly;
      this.setState({ showMedian, showAverage });
    }

    this.setState(
      update(this.state, {
        colArray: {
          $splice: [[nextCol, 0, [card]]],
        },
      }),
      () => {
        const copyOfTargetContainer = JsonHelper.deepCopy(this.state.colArray[nextCol]);
        const nestedList = this.doNesting(copyOfTargetContainer.slice());
        const { colGraphArray } = this.state;
        colGraphArray.splice(nextCol, 0, nestedList)
        this.setState({ colGraphArray: colGraphArray.filter((graph) => graph.length > 0) });
      }
    );

 
    await this.loadValues2(card.uniqueId, card);
  }

  /**
   * Erzeugt eine neue Zeilendefinition mir dem übergebenen Merkmal
   * @param {number} nextRow Index der neuen Zeilendefinition
   * @param {object} incard Merkmal
   * @param {*} targetContainer 
   */
  async pushCardToExtraRow(nextRow, incard, targetContainer) {
    const card = {...incard}//JsonHelper.deepCopy(incard)
    const { showAverage, showMedian } = this.state;
    const { medianOnly, averageOnly } = card?.output[0]?.reference;
    const { name, type, ruleName } = card;

    if (card.uniqueId === '') { // diese Card ist neu
      card.uniqueId = this.getUniqueId(); // set ID for connection btw. card and Statistics.jsx
    
      showMedian[card.uniqueId] = medianOnly; // 781
      showAverage[card.uniqueId] = averageOnly;
      this.setState({ showMedian, showAverage });
    }

    this.setState(
      update(this.state, {
        rowArray: {
          $splice: [[nextRow, 0, [card]]],
        },
      }),
      () => {
        const copyOfTargetContainer = JsonHelper.deepCopy(this.state.rowArray[nextRow]);
        const nestedList = this.doNesting(copyOfTargetContainer.slice());
        const { rowGraphArray } = this.state;
        rowGraphArray.splice(nextRow, 0, nestedList)
        this.setState({ rowGraphArray: rowGraphArray.filter((graph) => graph.length > 0) });
      }
    );

    await this.loadValues2(card.uniqueId, card);
  }

  async pushCard(incard, targetContainer) { // onpush, ondrop
    // const { averageFrom, medianFrom } = incard?.output[0]?.reference;
    const card = {...incard}//JsonHelper.deepCopy(incard)
    const { showAverage, showMedian } = this.state;
    const { medianOnly, averageOnly } = incard?.output[0]?.reference;
    const { name, type, ruleName } = card;
    
    console.log("pushCard", card?.output[0]?.reference)

    if (card.uniqueId === '') { // diese Card ist neu
      card.uniqueId = this.getUniqueId(); // set ID for connection btw. card and Statistics.jsx

      showMedian[card.uniqueId] = medianOnly; // 781
      showAverage[card.uniqueId] = averageOnly;
      this.setState({ showMedian, showAverage });
    }
    if (type !== 'VALUE') {
      this.pushedCardToFilterHint(targetContainer); // für Cards, die in den Filter gezogen werden
    }
    let doFilterUpdate = false; // default
    if (targetContainer === 'filter') {
      if (type === 'TIME_IDENTIFYING' || type === 'TIME_CLASSIFYING') {
        // radio buttons
        doFilterUpdate = true;
      } else if (!card.filter) {
        doFilterUpdate = true;
      } else if (card.filter === []) {
        doFilterUpdate = true;
      }
    }
    const itemInList = card.code;

    const containerArray = this.state[targetContainer];
    let exchangeValueCardIndex = -1;
    if (type === 'VALUE') { // ist die neue Karte ein VALUE?
      // ist in der Zeile ein VALUE drin?
      for (let c = 0; c < containerArray.length; c += 1) {
        // wenn ja, VALUES austauschen
        if (containerArray[c].type === 'VALUE') {
          exchangeValueCardIndex = c;
        }
      }
    }
    if (exchangeValueCardIndex > -1) {
      containerArray[exchangeValueCardIndex] = card;
      this.growl.show({ severity: 'info', summary: 'Hinweis', detail: 'Wert-Merkmal wurde ausgetauscht' });
    } else {
      containerArray.push(card);
    }
    this.setState({
      [targetContainer]: containerArray,
    });
    this.makeNestedList(targetContainer);

    await this.loadValues2(card.uniqueId, card); // TODO: lade die Ausprägungen nochmal?
    const { auspraegungenMap, arrSelectedTreeNodes } = this.state;
    const showList = auspraegungenMap[itemInList];
    if (doFilterUpdate) {
      if (showList) {
        if (showList.length > 0) {
          // set filter to showList[0].code
          // and set activeFilter to true
          const { arrFiltersById } = this.state;
          if(arrFiltersById[card.uniqueId].length !== 1) { 
            if (type === 'TIME_IDENTIFYING') {
              showList.sort((x, y) => y.code - x.code); // 1552
              arrFiltersById[card.uniqueId] = [showList[0]];
              arrSelectedTreeNodes[card.uniqueId] = this.filtersToTreeSelectionKeys([showList[0]]) ;
            } else {
              arrFiltersById[card.uniqueId] = [showList[0]];
              arrSelectedTreeNodes[card.uniqueId] = this.filtersToTreeSelectionKeys([showList[0]]) ;
            }
          }
          // array in id benötigt
          this.setState({ arrFiltersById, arrSelectedTreeNodes });     
          const deepCopyTargetContainer = JsonHelper.deepCopy(this.state[targetContainer]);
          for (let i = 0; i < deepCopyTargetContainer.length; i += 1) {
            if (deepCopyTargetContainer[i].code === incard.code) {
              deepCopyTargetContainer[i].activeFilter = true;
              deepCopyTargetContainer[i].filter = arrFiltersById[card.uniqueId].map((filter) => filter.code);
              this.setState({ [targetContainer]: deepCopyTargetContainer });
            }
          }
        }
      }
      if (doFilterUpdate) this.makeNestedList(targetContainer);
    }
    // wenn es nur ein ZIM und nur ein ZKM gibt, ZKM immer hinzufügen
    // beim Verschieben auch ZKM entfernen in move card oder removeCard
    // const uniqueTimeClassifying = this.uniqueTime();
    const uniqueTimeClassifying = this.uniqueTime();
    if (!card.dontAddClassifying) { // nur, wenn es zum ersten Mal reingezogen wird
      if (type === 'TIME_IDENTIFYING' && uniqueTimeClassifying) {
        const last = this.state[targetContainer].length - 1;
        const cardCopy = this.state[targetContainer][last];
        const deepCopyTargetContainer2 = JsonHelper.deepCopy(this.state[targetContainer]);
        cardCopy.dontAddClassifying = true;
        deepCopyTargetContainer2[last] = cardCopy;
        this.setState({ [targetContainer]: deepCopyTargetContainer2 });
        this.pushCard(uniqueTimeClassifying[0], targetContainer);
      }
    }
  }

  /**
   * Setzt das Merkmal an der entsprechenden Spaltendefinition
   * @param {object} incard Merkmal
   * @param {number} targetContainer Index der Spaltendefinition 
   */
  async pushCardToCol(incard, targetContainer) { // onpush, ondrop
    const card = {...incard}
    const { showAverage, showMedian } = this.state;
    const { medianOnly, averageOnly } = card?.output[0]?.reference;
    const { name, type, ruleName } = card;

    // JsonHelper.deepCopy(incard);
    let newUniqueId;
    if (card.uniqueId === '') { // diese Card ist neu
      card.uniqueId = this.getUniqueId(); // set ID for connection btw. card and Statistics.jsx
      newUniqueId = card.uniqueId;

      showMedian[card.uniqueId] = medianOnly; // 781
      showAverage[card.uniqueId] = averageOnly;
      this.setState({ showMedian, showAverage });
    }
    this.pushedCardToFilterHint(targetContainer); // für Cards, die in den Filter gezogen werden
    let doFilterUpdate = false; // default
    if (targetContainer === 'filter') {
      if (type === 'TIME_IDENTIFYING' || type === 'TIME_CLASSIFYING') {
        // radio buttons
        doFilterUpdate = true;
      } else if (!incard.filter) {
        doFilterUpdate = true;
      } else if (incard.filter === []) {
        doFilterUpdate = true;
      }
    }
    const itemInList = card.code;
    const { colArray } = this.state;

    let exchangeValueCardIndex = -1;
    if (type === 'VALUE') { // ist die neue Karte ein VALUE?
      // ist in der Zeile ein VALUE drin?
      for (let c = 0; c < colArray[targetContainer].length; c += 1) {
        // wenn ja, VALUES austauschen
        if (colArray[targetContainer][c].type === 'VALUE') {
          // console.log('DROPVALUE#found', c);
          exchangeValueCardIndex = c;
        }
      }
    }
    if (exchangeValueCardIndex > -1) {
      colArray[targetContainer][exchangeValueCardIndex] = card;
      this.growl.show({ severity: 'info', summary: 'Hinweis', detail: 'Wert-Merkmal wurde ausgetauscht' });
    } else {
      colArray[targetContainer].push(card);
    }

    this.setState({
      colArray,
    });
    this.makeNestedListCol2(targetContainer);
    await this.loadValues2(card.uniqueId, card); // TODO: lade die Ausprägungen nochmal?
    const { auspraegungenMap, arrSelectedTreeNodes } = this.state;
    const showList = auspraegungenMap[itemInList];
    if (doFilterUpdate) {
      if (showList) {
        if (showList.length > 0) {
          // set filter to showList[0].code
          // and set activeFilter to true
          const { arrFiltersById } = this.state;
          if(arrFiltersById[card.uniqueId].length !== 1) { 
            if (type === 'TIME_IDENTIFYING') {
              showList.sort((x, y) => y.code - x.code); // 1552
              arrFiltersById[card.uniqueId] = [showList[0]];
              arrSelectedTreeNodes[card.uniqueId] = this.filtersToTreeSelectionKeys([showList[0]]) ;
            } else {
              arrFiltersById[card.uniqueId] = [showList[0]];
              arrSelectedTreeNodes[card.uniqueId] = this.filtersToTreeSelectionKeys([showList[0]]) ;
            }
          }
          // array in id benötigt
          this.setState({ arrFiltersById, arrSelectedTreeNodes });
          const deepCopyTargetContainer = JsonHelper.deepCopy(this.state.colArray[targetContainer]);
          for (let i = 0; i < deepCopyTargetContainer.length; i += 1) {
            if (deepCopyTargetContainer[i].code === incard.code) {
              deepCopyTargetContainer[i].activeFilter = true;
              deepCopyTargetContainer[i].filter = arrFiltersById[card.uniqueId].map((filter) => filter.code);
              this.setState({ [targetContainer]: deepCopyTargetContainer });
            }
          }
        }
      }
      if (doFilterUpdate) this.makeNestedListCol2(targetContainer);
    }
    // wenn es nur ein ZIM und nur ein ZKM gimbt, ZKM immer hinzufügen
    // beim Verschieben auch ZKM entfernen in move card oder removeCard
    // console.log('FIREPUSH#');
    const uniqueTimeClassifying = this.uniqueTime();
    if (type === 'TIME_IDENTIFYING' && uniqueTimeClassifying) {
      // console.log('FIREPUSH#do');
      this.pushCardToCol(uniqueTimeClassifying[0], targetContainer);
    }
    // Vorsicht: erzeugt ggf. noch Fehler
  }

  /**
   * Setzt das Merkmal an der entsprechenden Zeilendefinition
   * @param {object} incard Merkmal
   * @param {number} targetContainer Index der Zeilendefinition 
   */
  async pushCardToRow(incard, targetContainer) { // onpush, ondrop
    const card = {...incard}
    
    console.log("pushCardToRow", card?.output[0]?.reference)

    const { showAverage, showMedian } = this.state;
    const { medianOnly, averageOnly } = card?.output[0]?.reference;
     const { name, type, ruleName } = card;
    /*showMedian[name] = medianOnly; // 781
    showAverage[name] = averageOnly;
    this.setState({ showMedian, showAverage }); */
    //JsonHelper.deepCopy(incard);
    let newUniqueId;
    if (card.uniqueId === '') { // diese Card ist neu
      card.uniqueId = this.getUniqueId(); // set ID for connection btw. card and Statistics.jsx
      newUniqueId = card.uniqueId;

      showMedian[newUniqueId] = medianOnly; // 781
      showAverage[newUniqueId] = averageOnly;
      this.setState({ showMedian, showAverage });
    }
    // this.pushedCardToFilterHint(targetContainer); // für Cards, die in den Filter gezogen werden
    let doFilterUpdate = false; // default
    /*
    if (targetContainer === 'filter') {
      if (type === 'TIME_IDENTIFYING' || type === 'TIME_CLASSIFYING') {
        // radio buttons
        doFilterUpdate = true;
      } else if (!incard.filter) {
        doFilterUpdate = true;
      } else if (incard.filter === []) {
        doFilterUpdate = true;
      }
    }
    */
    const itemInList = card.code;
    const { rowArray } = this.state;
    let exchangeValueCardIndex = -1;
    if (type === 'VALUE') { // ist die neue Karte ein VALUE?
      // ist in der Zeile ein VALUE drin?
      for (let c = 0; c < rowArray[targetContainer].length; c += 1) {
        // wenn ja, VALUES austauschen
        if (rowArray[targetContainer][c].type === 'VALUE') {
          // console.log('DROPVALUE#found', c);
          exchangeValueCardIndex = c;
        }
      }
    }
    if (exchangeValueCardIndex > -1) {
      rowArray[targetContainer][exchangeValueCardIndex] = card;
      this.growl.show({ severity: 'info', summary: 'Hinweis', detail: 'Wert-Merkmal wurde ausgetauscht' });
    } else {
      rowArray[targetContainer].push(card);
    }

    this.setState({
      rowArray,
    });
    this.makeNestedListRows2(targetContainer);
    await this.loadValues2(newUniqueId, card); // TODO: lade die Ausprägungen nochmal?
    const { auspraegungenMap, arrSelectedTreeNodes } = this.state;
    const showList = auspraegungenMap[itemInList];
    if (doFilterUpdate) {
      if (showList) {
        if (showList.length > 0) {
          // set filter to showList[0].code
          // and set activeFilter to true
          const { arrFiltersById } = this.state;
          if(arrFiltersById[card.uniqueId].length !== 1) { 
            if (type === 'TIME_IDENTIFYING') {
              showList.sort((x, y) => y.code - x.code); // 1552
              arrFiltersById[card.uniqueId] = [showList[0]];
              arrSelectedTreeNodes[card.uniqueId] = this.filtersToTreeSelectionKeys([showList[0]]) ;
            } else {
              arrFiltersById[card.uniqueId] = [showList[0]];
              arrSelectedTreeNodes[card.uniqueId] = this.filtersToTreeSelectionKeys([showList[0]]) ;
            }
          }
          // array in id benötigt
          this.setState({ arrFiltersById, arrSelectedTreeNodes });
          const deepCopyTargetContainer = JsonHelper.deepCopy(this.state.rowArray[targetContainer]);
          for (let i = 0; i < deepCopyTargetContainer.length; i += 1) {
            if (deepCopyTargetContainer[i].code === incard.code) {
              deepCopyTargetContainer[i].activeFilter = true;
              deepCopyTargetContainer[i].filter = arrFiltersById[card.uniqueId].map((filter) => filter.code);
              this.setState({ [targetContainer]: deepCopyTargetContainer });
            }
          }
        }
      }
      if (doFilterUpdate) this.makeNestedListRows2(targetContainer);
    }
    // wenn es nur ein ZIM und nur ein ZKM gimbt, ZKM immer hinzufügen
    // beim Verschieben auch ZKM entfernen in move card oder removeCard
    // console.log('FIREPUSH#');
    const uniqueTimeClassifying = this.uniqueTime();
    if (type === 'TIME_IDENTIFYING' && uniqueTimeClassifying) {
      // console.log('FIREPUSH#do');
      this.pushCardToRow(uniqueTimeClassifying[0], targetContainer);
    }
    // Vorsicht: erzeugt ggf. noch Fehler
  }

  uniqueTime() { // genau ein ZIMM und ein ZKMM
    const { elements, selectedStatistics } = this.state;
    let ret;
    if (elements.TIME_IDENTIFYING.length === 1
      && elements.TIME_CLASSIFYING.length === 1
      && selectedStatistics.length === 1) {
      ret = elements.TIME_CLASSIFYING;
    }
    return ret;
  }

  removeCard(index, targetContainer) {
    const { type } = this.state[targetContainer][index];
    let spliceNumber = 1;
    // if (type === 'TIME_IDENTIFYING' && this.uniqueTime()) spliceNumber = 2;
//    this.hideOverlay();
    this.setState(
      update(this.state, {
        [targetContainer]: {
          $splice: [[index, spliceNumber]],
        },
      }),
      () => {
        this.makeNestedList(targetContainer);
      },
    );
    this.updateView();
  }

  /**
   * Löscht das Merkmal mit dem entsprechenden Index aus einer Spaltendefinition
   * @param {number} index Index des Merkmals
   * @param {number} targetContainer Index der Spaltendefinition
   */
  removeCardFromCol(index, targetContainer) {
    const { colArray, colGraphArray } = this.state;
    let spliceNumber = 1;
//    this.hideOverlay();
    if (colArray.length === 1 || colArray[targetContainer].length > 1) {
      colArray[targetContainer].splice(index, spliceNumber);
      this.makeNestedList2(targetContainer);
      this.setState(
        {
          colArray,
        },
      );
    } else {
      colArray.splice(targetContainer, spliceNumber);
      colGraphArray.splice(targetContainer, spliceNumber);
      this.setState(
        {
          colArray: colArray.filter((col) => col.length > 0),
          colGraphArray: colGraphArray.filter((graph) => graph.length > 0),
        },
      );
    }
    this.updateView();
  }

  /**
   * Kopiert alle Karten in einem Container
   * @param {number} colNumber Nummer der Spalte, aus der kopiert wurde oder -1
   * @param {number} rowNumber Nummer der Zeile, aus der kopiert wurde oder -1
   */
  copyAll(colNumber, rowNumber) {
    const {
      arrRulesById, arrSortingById,
      arrFiltersById, arrSumUpById,
      arrCalcUpById, arrDisplayById,
      arrBMMById, arrNameById,
      arrDirectionById, arrDisplayRulesById,
      arrRuleOutputById,
      arrRuleById, arrRuleCharById, arrSelectedTreeNodes,
      hierarchySelection, calcModeOnById, showAverage,
      showMedian,sumUp, prefixById
    } = this.state;
    let { colArray, rowArray } = this.state;
    let copyCards;
    if (colNumber > -1) {
      const deepCopyArr = JsonHelper.deepCopy(colArray);
      copyCards = [...colArray[colNumber]];
      console.log('ARRAY#col', colArray[colNumber]);
      for (let i = 0; i < copyCards.length; i += 1) {
        // Kopien der Karten neue uniqueIds zuweisen, ...
        const oldUniqueId = copyCards[i].uniqueId;
        const newUniqueId = this.getUniqueId();
        copyCards[i].uniqueId = newUniqueId;
        if (arrBMMById[oldUniqueId]) arrBMMById[newUniqueId] = arrBMMById[oldUniqueId];
        if (arrCalcUpById[oldUniqueId]) arrCalcUpById[newUniqueId] = arrCalcUpById[oldUniqueId];
        if (arrDirectionById[oldUniqueId]) arrDirectionById[newUniqueId] = arrDirectionById[oldUniqueId];
        if (arrDisplayById[oldUniqueId]) arrDisplayById[newUniqueId] = arrDisplayById[oldUniqueId];
        if (arrDisplayRulesById[oldUniqueId]) arrDisplayRulesById[newUniqueId] = arrDisplayRulesById[oldUniqueId];
        if (arrRuleOutputById[oldUniqueId]) arrRuleOutputById[newUniqueId] = arrRuleOutputById[oldUniqueId];
        if (arrFiltersById[oldUniqueId]) arrFiltersById[newUniqueId] = arrFiltersById[oldUniqueId];
        if (arrNameById[oldUniqueId]) arrNameById[newUniqueId] = arrNameById[oldUniqueId];
        if (arrRuleById[oldUniqueId]) arrRuleById[newUniqueId] = arrRuleById[oldUniqueId];
        if (arrRuleCharById[oldUniqueId]) arrRuleCharById[newUniqueId] = arrRuleCharById[oldUniqueId];
        if (arrRulesById[oldUniqueId]) arrRulesById[newUniqueId] = arrRulesById[oldUniqueId];
        if (arrSortingById[oldUniqueId]) arrSortingById[newUniqueId] = arrSortingById[oldUniqueId];
        if (arrSumUpById[oldUniqueId]) arrSumUpById[newUniqueId] = arrSumUpById[oldUniqueId];
        if (arrSelectedTreeNodes[oldUniqueId]) arrSelectedTreeNodes[newUniqueId] = arrSelectedTreeNodes[oldUniqueId];
        if (hierarchySelection[oldUniqueId]) hierarchySelection[newUniqueId] = hierarchySelection[oldUniqueId];
        if (calcModeOnById[oldUniqueId]) calcModeOnById[newUniqueId] = calcModeOnById[oldUniqueId];
        if (showAverage[oldUniqueId]) showAverage[newUniqueId] = showAverage[oldUniqueId];
        if (showMedian[oldUniqueId]) showMedian[newUniqueId] = showMedian[oldUniqueId];
        if (sumUp[oldUniqueId]) sumUp[newUniqueId] = sumUp[oldUniqueId];
        if (prefixById[oldUniqueId]) prefixById[newUniqueId] = prefixById[oldUniqueId];
      }
      // in arr... diesen die gleichen Werte zuweisen ...
      const newArr = deepCopyArr.concat([copyCards]);
      colArray = newArr;
      this.setState({ colArray }, () => {
        this.makeNestedListCol2(newArr.length - 1);
        this.updateView();
      });
    } else {
      const deepCopyArr = JsonHelper.deepCopy(rowArray);
      copyCards = [...rowArray[rowNumber]];
      for (let i = 0; i < copyCards.length; i += 1) {
        // Kopien der Karten neue uniqueIds zuweisen, ...
        const oldUniqueId = copyCards[i].uniqueId;
        const newUniqueId = this.getUniqueId();
        copyCards[i].uniqueId = newUniqueId;
        if (arrBMMById[oldUniqueId]) arrBMMById[newUniqueId] = arrBMMById[oldUniqueId];
        if (arrCalcUpById[oldUniqueId]) arrCalcUpById[newUniqueId] = arrCalcUpById[oldUniqueId];
        if (arrDirectionById[oldUniqueId]) arrDirectionById[newUniqueId] = arrDirectionById[oldUniqueId];
        if (arrDisplayById[oldUniqueId]) arrDisplayById[newUniqueId] = arrDisplayById[oldUniqueId];
        if (arrDisplayRulesById[oldUniqueId]) arrDisplayRulesById[newUniqueId] = arrDisplayRulesById[oldUniqueId];
        if (arrRuleOutputById[oldUniqueId]) arrRuleOutputById[newUniqueId] = arrRuleOutputById[oldUniqueId];
        if (arrFiltersById[oldUniqueId]) arrFiltersById[newUniqueId] = arrFiltersById[oldUniqueId];
        if (arrNameById[oldUniqueId]) arrNameById[newUniqueId] = arrNameById[oldUniqueId];
        if (arrRuleById[oldUniqueId]) arrRuleById[newUniqueId] = arrRuleById[oldUniqueId];
        if (arrRuleCharById[oldUniqueId]) arrRuleCharById[newUniqueId] = arrRuleCharById[oldUniqueId];
        if (arrRulesById[oldUniqueId]) arrRulesById[newUniqueId] = arrRulesById[oldUniqueId];
        if (arrSortingById[oldUniqueId]) arrSortingById[newUniqueId] = arrSortingById[oldUniqueId];
        if (arrSumUpById[oldUniqueId]) arrSumUpById[newUniqueId] = arrSumUpById[oldUniqueId];
        if (arrSelectedTreeNodes[oldUniqueId]) arrSelectedTreeNodes[newUniqueId] = arrSelectedTreeNodes[oldUniqueId];
        if (hierarchySelection[oldUniqueId]) hierarchySelection[newUniqueId] = hierarchySelection[oldUniqueId];
        if (calcModeOnById[oldUniqueId]) calcModeOnById[newUniqueId] = calcModeOnById[oldUniqueId];
        if (showAverage[oldUniqueId]) showAverage[newUniqueId] = showAverage[oldUniqueId];
        if (showMedian[oldUniqueId]) showMedian[newUniqueId] = showMedian[oldUniqueId];
        if (sumUp[oldUniqueId]) sumUp[newUniqueId] = sumUp[oldUniqueId];
        if (prefixById[oldUniqueId]) prefixById[newUniqueId] = prefixById[oldUniqueId];
      }
      // in arr... diesen die gleichen Werte zuweisen ...
      const newArr = deepCopyArr.concat([copyCards]);
      rowArray = newArr;
      console.log('ARRAY#', newArr, newArr.length - 1);
      this.setState({ rowArray }, () => {
        this.makeNestedListRows2(newArr.length - 1);
        this.updateView();
      });
    }
    if (copyCards) {
      this.growl.show({ severity: 'info', summary: 'Merkmale kopiert' });
    }
  }

  /**
   * Ändert die Reihenfolge der Merkmale innerhalb einer Spaltendefinition
   * @param {number} dragIndex Ursprünglicher Index des Merkmals
   * @param {number} hoverIndex Index über dem gehovert wird
   * @param {number} targetContainer Index der Spaltendefinition
   */
  moveCardInCol(dragIndex, hoverIndex, targetContainer) {
    const { colArray } = this.state;
    const item = colArray[targetContainer][dragIndex];
    colArray[targetContainer].splice(dragIndex, 1);
    colArray[targetContainer].splice(hoverIndex, 0, item);
    this.setState({ colArray });
    this.makeNestedList2(targetContainer);
    this.updateView();
  }

  /**
   * Löscht das Merkmal mit dem entsprechenden Index aus einer Zeilendefinition
   * @param {number} index Index des Merkmals
   * @param {number} targetContainer Index der Zeilendefinition
   */
  removeCardFromRow(index, targetContainer) {
    const { rowArray, rowGraphArray } = this.state;
    let spliceNumber = 1;
   // this.hideOverlay();

    if (rowArray.length === 1 || rowArray[targetContainer].length > 1) {
      rowArray[targetContainer].splice(index, spliceNumber);
      this.makeNestedListRows2(targetContainer);

      this.setState(
        {
          rowArray,
        },
      );
    } else {
      rowArray.splice(targetContainer, spliceNumber);
      rowGraphArray.splice(targetContainer, spliceNumber);

      this.setState(
        {
          rowArray: rowArray.filter((col) => col.length > 0),
          rowGraphArray: rowGraphArray.filter((graph) => graph.length > 0),
        },
      );
    }
    this.updateView();
  }

  /**
   * Ändert die Reihenfolge der Merkmale innerhalb einer Zeilendefinition
   * @param {number} dragIndex Ursprünglicher Index des Merkmals
   * @param {number} hoverIndex Index über dem gehovert wird
   * @param {number} targetContainer Index der Zeilendefinition
   */
  moveCardInRow(dragIndex, hoverIndex, targetContainer) {
    const { rowArray } = this.state;
    const item = rowArray[targetContainer][dragIndex];
    rowArray[targetContainer].splice(dragIndex, 1);
    rowArray[targetContainer].splice(hoverIndex, 0, item);

    this.setState({ rowArray });

    this.makeNestedListRows2(targetContainer);
    this.updateView();
  }

  moveCard(dragIndex, hoverIndex, targetContainer) {
    const item = this.state[targetContainer][dragIndex];
    this.setState(update(this.state, {
      [targetContainer]: {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, item],
        ],
      },
    }), () => { this.makeNestedList(targetContainer); });
    this.updateView();
  }

  // Zeilen
  createRowContainers(limit = 7) { // maximale Anzahl Zeilen, ADBHSSTAT-2665
    const newState = {};
    const rowHelperArray = [];
    for (let i = 2; i <= limit; i += 1) {
      newState[`zeile${i}`] = [];
      rowHelperArray.push(`zeile${i}`);
      newState[`zeile${i}_graph`] = [];
    }
    if (newState.length !== 0) {
      // this.setState(newState);
      // this.setState({ rowHelperArray });
      this.setState({ ...newState, rowHelperArray });
    }
  }

  renderRowContainers() {
    const { rowHelperArray } = this.state;
    rowHelperArray.sort(this.sortFunction);
    // let additionalContainers;
    const additionalContainers = rowHelperArray.map((rowHelper, i) => {
      if (this.state[rowHelper] && ((i === 0)
        || ((i - 1) >= 0 && this.state[rowHelperArray[i - 1]].length > 0))) {
        return (
          <div style={{ width: '240px' }}>
            <Container
              id={11 + i}
              list={this.state[rowHelper]}
              containerName={rowHelper}
              pushCard={this.pushCard.bind(this)}
              removeCard={this.removeCard.bind(this)}
              moveCard={this.moveCard.bind(this)}
              showOverlay={this.showOverlay.bind(this)}
              makeNestedList={this.makeNestedList.bind(this)}
              copyAll={this.copyAll.bind(this)}
              header={`Zeilendefinition ${2 + i}`}
            />
          </div>
        );
      }
      return undefined;
    });
    return additionalContainers;
  }
  // Ende Zeilen

  createColContainers(limit = 40) {
    const newState = {};
    const colHelperArray = [];
    for (let i = 2; i <= limit; i += 1) {
      newState[`spalte${i}`] = [];
      colHelperArray.push(`spalte${i}`);
      newState[`spalte${i}_graph`] = [];
    }
    if (newState.length !== 0) {
      // this.setState(...newState);
      this.setState({ ...newState, colHelperArray });
    }
  }

  createRecycler(limit = 1) {
    const newState = {};
    const recHelperArray = [];
    for (let i = 2; i <= limit; i += 1) {
      newState[`rec${i}`] = [];
      colHelperArray.push(`rec${i}`);
      newState[`rec${i}_graph`] = [];
    }
    if (newState.length !== 0) {
      // this.setState(newState);
      // this.setState({ recHelperArray });
      this.setState({ ...newState, recHelperArray });
    }
  }

  renderColContainers() {
    const { colHelperArray } = this.state;
    //const tmp = colHelperArray.sort(this.sortFunction);
    // let additionalContainers;
    // console.log('COLARRAY#1.1', colHelper);
    const additionalContainers = colHelperArray.map((colHelper, i) => {
      if (this.state[colHelper] && ((i === 0)
        || ((i - 1) >= 0 && this.state[colHelperArray[i - 1]].length > 0))) {
        // console.log('HELPER1', colHelper, this.state[colHelper]);
        return (
          <div style={{ width: '240px' }}>
            <ColContainer
              oldId={1000 + i}
              id={1000 + i}
              list={this.state[colHelper]}
              containerName={colHelper}
              pushCard={this.pushCard.bind(this)}
              removeCard={this.removeCard.bind(this)}
              moveCard={this.moveCard.bind(this)}
              showOverlay={this.showOverlay.bind(this)}
              makeNestedList={this.makeNestedList.bind(this)}
              copyAll={this.copyAll.bind(this)}
              header={`Spaltendefinition ${2 + i}`}
            />
          </div>
        );
      }
      return undefined;
    });
    return additionalContainers;
  }

  /**
   * Wandelt die Einträge in dem colArray in die entsprechenden Spaltendefinitionen um
   * @returns Spaltendefinitionen und Bereiche für das Einfügen von extra Spalten
   */
  renderColArray() {
    const { colArray } = this.state;
    const colContainer = colArray.map((cards, i) => (
      <>
        <div style={{ width: '240px', margin: '0 -30px 0 -30px' }}>
          <ColContainer
            oldId={1000 + i}
            id={1000 + i}
            list={cards}
            containerName={i}
            pushCard={this.pushCardToCol.bind(this)}
            removeCard={this.removeCardFromCol.bind(this)}
            moveCard={this.moveCardInCol.bind(this)}
            showOverlay={this.showOverlayCol.bind(this)}
            makeNestedList={this.makeNestedList2.bind(this)}
            copyAll={this.copyAll.bind(this)}
            header={`Spaltendefinition ${1 + i}`}
          />
        </div>
        {colArray[0].length > 0 && (
          <ExtraContainer
            style={{ padding: '0 20px 0 20px', height: "82px" }}
            pushCard={this.pushCardToExtraCol.bind(this)}
            nextCol={i + 1}
            checkIdDigitCount={4}
          />
        )}
      </>
    ));

    if (colArray[0].length > 0) {
      colContainer.splice(0, 0, <ExtraContainer
        style={{ padding: '0 20px 0 20px', height: "82px" }}
        pushCard={this.pushCardToExtraCol.bind(this)}
        nextCol={0}
        checkIdDigitCount={4}
      />);
    }

    return colContainer;
  }

  /**
   * Wandelt die Einträge in dem rowArray in die entsprechenden Zeilendefinitionen um
   * @returns Zeilendefinitionen und Bereiche für das Einfügen von extra Zeilen
   */
  renderRowArray() {
    const { rowArray } = this.state;

    const rowContainer = rowArray.map((cards, i) => (
      <>
        <div style={{ width: '240px', margin: rowArray[0].length > 0 ? '-30px 0px -30px 0px' : '0px 0px -30px 0px' }}>
          <Container
            id={100 + i}
            list={cards}
            containerName={i}
            pushCard={this.pushCardToRow.bind(this)}
            removeCard={this.removeCardFromRow.bind(this)}
            moveCard={this.moveCardInRow.bind(this)}
            showOverlay={this.showOverlayRow.bind(this)}
            makeNestedList={this.makeNestedListRows2.bind(this)}
            copyAll={this.copyAll.bind(this)}
            header={`Zeilendefinition ${1 + i}`}
            popup=""
          />
        </div>
        {rowArray[0].length > 0 && (
          <ExtraContainer
            style={{ minHeight: '1px', padding: '20px 0 20px 0' }}
            pushCard={this.pushCardToExtraRow.bind(this)}
            nextCol={i + 1}
            checkIdDigitCount={3}
          />
        )}
      </>
    ));

    if (rowArray[0].length > 0) {
      rowContainer.splice(0, 0, <ExtraContainer
        style={{ minHeight: '1px', padding: '20px 0 20px 0' }}
        pushCard={this.pushCardToExtraRow.bind(this)}
        nextCol={0}
        checkIdDigitCount={3}
      />)
    }

    return rowContainer;
  }

  selectedStatisticsTemplate = (option) => {
    if (option) {
      return (
        <div style={{
          color: 'white',
          background: '#757575 none repeat scroll 0% 0%',
          borderRadius: '4px',
          padding: '2px 4px',
          width: '3.5em',
          textAlign: 'center',
          margin: '1px',
        }}
        >
          {option.name}
        </div>
      );
    }
    return 'Statistik(en)';
  }

  returnUserRight = () => {
    const admin = true;
    const regional = sessionStorage.getItem('evaluationRegional');
    let isLandString = 'false';
    if (regional === 'Land') isLandString = 'true';
    const userRight = {
      admin,
      regional,
      isLandString,
    };
    return userRight;
  }

  returnLandString = () => {
    const regional = sessionStorage.getItem('evaluationRegional');
    let isLandString = 'false';
    if (regional === 'Land') isLandString = 'true';
    return isLandString;
  }

  clearInput(e, id) {
    let { overlayId } = this.state;
    const {
      overlayFilter, overlayHasFilter, overlayFilteredList,
    } = this.state;
    if (id) overlayId = id;
    overlayFilter[overlayId] = '';
    overlayHasFilter[overlayId] = false;
    overlayFilteredList[overlayId] = undefined;
    this.setState({
      overlayFilter,
      overlayHasFilter,
      overlayFilteredList,
    });
  }

  hideSearchOverlay(e) {
    // Overlay für Suche ausblenden
    this.overlaySearch.hide(e);
  }

  showSearchOverlay(e, overlayId) {
    this.setState({ overlayId });
    this.overlaySearch.toggle(e);
    document.getElementById('InputSearchOverlay').focus();
  }

  handleKeyDown(e) {
    const {
      overlayId,
      overlayFilteredList,
    } = this.state;
    if (event.keyCode === 13) {
      this.overlaySearch.hide(e);
      overlayFilteredList[overlayId] = this.filterItems();
    }
    this.setState({
      overlayFilteredList,
    });
  }

  filterItems() {
    const {
      elements,
      elements1,
      elements3,
      overlayFilter,
      overlayId,
    } = this.state;
    let data;
    switch (overlayId) {
      case 2:
        data = elements.VALUE;
        break;
      case 3:
        data = elements1.VALUE;
        break;
      case 4:
        data = this.mergeElements2();
        break;
      case 5:
        data = elements.SUBJECT_CLASSIFYING;
        data = data.sort((a, b) => ((a.text > b.text) ? 1 : -1));
        break;
      case 6:
        data = elements3.VALUE;
        break;
      case 7:
        data = elements.REGION_CLASSIFYING;
        data = data.sort((a, b) => ((a.text > b.text) ? 1 : -1));
        break;
      default:
        // nothing
        break;
    }
    const result = data.filter((d) => d.text.includes(overlayFilter[overlayId]));
    return result;
  }

  handleChange = (e) => {
    const {
      overlayFilter,
      overlayHasFilter,
      overlayId,
      overlayFilteredList,
    } = this.state;
    overlayFilter[overlayId] = e.target.value;
    overlayHasFilter[overlayId] = true;
    if (overlayFilter[overlayId].length > 2) {
      overlayFilteredList[overlayId] = this.filterItems();
    } else {
      overlayFilteredList[overlayId] = undefined;
    }
    this.setState({
      overlayFilter,
      overlayHasFilter,
      overlayFilteredList,
    });
  };

  showOverlayCol(e, sel, selectedId, type, containerName, instantReturn) {
    this.showOverlay(e, sel, selectedId, type, 'spalte' + containerName, instantReturn);
  }

  showOverlayRow(e, sel, selectedId, type, containerName, instantReturn) {
    this.showOverlay(e, sel, selectedId, type, 'zeile' + containerName, instantReturn);
  }

  showOverlay(e, sel, selectedId, type, containerName, instantReturn) {
    // Overlay für Äusprägungen anzeigen und vorbereiten für Eingabe
    // code, uniqueId, type
    if (instantReturn) return; // do not show
    const { arrFiltersById, isDialogOpen } = this.state;
    let canSumUp = true;
    this.setState({ hideRetrievalButton: true });
    let selectionMode = 'multiple';
    // 'TIME_IDENTIFYING' can use 'Zusammen'
    if (type === 'TIME_CLASSIFYING' || type === 'VALUE' || type === 'TIME_IDENTIFYING') {
      selectionMode = 'single';
      canSumUp = false;
    }
    const isTimeIdentifying = (type === 'TIME_IDENTIFYING');
    const isTimeClassifying = (type === 'TIME_CLASSIFYING');
    const isValue = (type === 'VALUE');
    if (containerName !== 'filter') {
      selectionMode = 'multiple';
    }
    if (containerName === 'filter') { canSumUp = false; }
    if (type === 'VALUE') { selectionMode = 'none'; }
    if (selectionMode === 'multiple') {
      const onlySelectedFilter = arrFiltersById[selectedId];
      if (onlySelectedFilter) {
        if (onlySelectedFilter.constructor !== Array) {
          const arrOnlySelectedFilter = [onlySelectedFilter];
          arrFiltersById[selectedId] = arrOnlySelectedFilter;
          this.setState({ arrFiltersById });
        }
      }
    }
    let showRuleSelection = 'true';
    if (containerName === 'headings' || containerName === 'filter' || isValue) {
      showRuleSelection = false;
    }
    this.setState({
      // itemInListType: type,
      itemInList: sel,
      globalFilter: '',
      showRuleSelection,
      selectedId,
      selectionMode,
      selectedContainer: containerName,
      canSumUp,
      isTimeIdentifying,
      isTimeClassifying,
      isValue,
      isDialogOpen: !isDialogOpen
    });
    //this.op.toggle(e);
  }

  hideOverlay(e) {
    // Overlay für Äusprägungen ausblenden
    this.op.hide(e);
  }

  makeNestedList(targetContainer, targetList = []) {
    const stateOfTargetContainer = this.state[targetContainer];
    const deepCopy_targetContainer = JsonHelper.deepCopy(stateOfTargetContainer);
    const deepCopy_targetList = JsonHelper.deepCopy(targetList);
    const list = deepCopy_targetList.length > 0
      ? deepCopy_targetList.slice()
      : deepCopy_targetContainer.slice();
    if (targetContainer === 'filter') {
      const listFilter = [];
      const listPrecondition = [];
      for (let i = 0; i <= list.length - 1; i += 1) {
        if (!list[i].filter) {
          // no filter selected yet
          listFilter.push(list[i]);
        } else if (list[i].filter.length === 1) {
          listFilter.push(list[i]);
        } else {
          listPrecondition.push(list[i]);
        }
      }
      let nestedFilter = [];
      let nestedPrecondition = [];
      if (listFilter.length > 0) {
        nestedFilter = this.doNesting(listFilter);
      }
      if (listPrecondition.length > 0) {
        nestedPrecondition = this.doNesting(listPrecondition);
      }
      this.setState({ pureFilter_graph: nestedFilter }, () => { log('pureFilter_graph: ', this.state.pureFilter_graph); });
      this.setState({ precondition_graph: nestedPrecondition }, () => { log('precondition_graph: ', this.state.precondition_graph); });
    }
    const nestedList = this.doNesting(list);
    this.setState({ [`${targetContainer}_graph`]: nestedList }, () => { log(`${targetContainer}_graph: `, this.state[`${targetContainer}_graph`]); });
  }

  makeNestedList2(targetContainer, targetList = []) {

    let stateOfTargetContainer;

    if (typeof targetContainer === 'string') {
      stateOfTargetContainer = this.state[targetContainer];
    }
    else {
      stateOfTargetContainer = this.state.colArray[targetContainer];
    }


    //const stateOfTargetContainer = this.state.colArray[targetContainer];
    const deepCopy_targetContainer = JsonHelper.deepCopy(stateOfTargetContainer);
    const deepCopy_targetList = JsonHelper.deepCopy(targetList);
    const list = deepCopy_targetList.length > 0
      ? deepCopy_targetList.slice()
      : deepCopy_targetContainer.slice();
    if (targetContainer === 'filter') {
      const listFilter = [];
      const listPrecondition = [];
      for (let i = 0; i <= list.length - 1; i += 1) {
        if (!list[i].filter) {
          // no filter selected yet
          listFilter.push(list[i]);
        } else if (list[i].filter.length === 1) {
          listFilter.push(list[i]);
        } else {
          listPrecondition.push(list[i]);
        }
      }
      let nestedFilter = [];
      let nestedPrecondition = [];
      if (listFilter.length > 0) {
        nestedFilter = this.doNesting(listFilter);
      }
      if (listPrecondition.length > 0) {
        nestedPrecondition = this.doNesting(listPrecondition);
      }
      this.setState({ pureFilter_graph: nestedFilter }, () => { log('pureFilter_graph: ', this.state.pureFilter_graph); });
      this.setState({ precondition_graph: nestedPrecondition }, () => { log('precondition_graph: ', this.state.precondition_graph); });
    }
    const nestedList = this.doNesting(list);

    if (typeof targetContainer === 'string') {
      this.setState({ [`${targetContainer}_graph`]: nestedList }, () => { log(`${targetContainer}_graph: `, this.state[`${targetContainer}_graph`]); });
    }
    else {
      const { colGraphArray } = this.state;
      colGraphArray[targetContainer] = nestedList;
      this.setState({ colGraphArray: colGraphArray.filter((graph) => graph.length > 0) });
    }
  }

  makeNestedListCol2(targetContainer, targetList = []) {
    const stateOfTargetContainer = this.state.colArray[targetContainer];
    const nestedList = this.makeNestedList3(stateOfTargetContainer, targetList);
    const { colGraphArray } = this.state;
    colGraphArray[targetContainer] = nestedList;
    this.setState({ colGraphArray: colGraphArray.filter((graph) => graph.length > 0) });
  }

  makeNestedListRows2(targetContainer, targetList = []) {
    const stateOfTargetContainer = this.state.rowArray[targetContainer];
    const nestedList = this.makeNestedList3(stateOfTargetContainer, targetList);
    const { rowGraphArray } = this.state;
    rowGraphArray[targetContainer] = nestedList;
    this.setState({ rowGraphArray: rowGraphArray.filter((graph) => graph.length > 0) });
  }

  makeNestedList3(stateOfTargetContainer, targetList) {
    const deepCopy_targetContainer = JsonHelper.deepCopy(stateOfTargetContainer);
    const deepCopy_targetList = JsonHelper.deepCopy(targetList);
    const list = deepCopy_targetList.length > 0
      ? deepCopy_targetList.slice()
      : deepCopy_targetContainer.slice();
    const nestedList = this.doNesting(list);
    return nestedList;
  }

  forceRenderer = () => {
    this.forceUpdate();
  }

  // erdemir-y 03-03-2021: Zum Überschreiben werden Tabellen-Ids gebraucht
  async getDirectory(type, right, objectNumber, objectTyp, prefix,
    typeString, onlyTable, linksArray) {
    const path = 'directory';
    const elementsData1 = await this.messageService.postVariableDirectory(
      path, type, right, objectNumber, objectTyp, typeString, onlyTable, linksArray,
    );
    let children = [];
    if (elementsData1[0]) {
      this.growl.show({ severity: elementsData1[1], summary: 'Hinweis zu Tabellensuche', detail: elementsData1[0] });
    } else {
      const entries = elementsData1.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys;
      children = entries;
    }
    return children;
  }

  doNesting = (list) => {
    // doNesting(list) {
    const nested_list = [];
    for (let i = list.length; i > 0; i -= 1) {
      if (i === list.length) {
        // nested_list[0] = { ...list[i - 1] };
        nested_list[0] = JsonHelper.deepCopy(list[i - 1]);
        nested_list[0].ruleReferenze = null //ADBHSSTAT-2779 Nacharbeit
      } else {
        // let parent = { ...list[i - 1] };
        const parent = JsonHelper.deepCopy(list[i - 1]);
        parent.ruleReferenze = null //ADBHSSTAT-2779 Nacharbeit
        // let child = { ...nested_list[0] };
        const child = JsonHelper.deepCopy(nested_list[0]);
        child.ruleReferenze = null //ADBHSSTAT-2779 Nacharbeit
        parent.children[0] = child;
        // log('PARENT: ', parent);
        nested_list[0] = parent;
      }
    }
    return nested_list;
  }

  async exportTable(option, name) {
    const { valueStartStructure, sepQual } = this.state;
    // valueStartStructure.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.path = ['c://Lokaler Datenbereich//'];
    valueStartStructure.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.filename = [name];
    valueStartStructure.contents['genesis.container.content.GenesisTMContent'].transfermodel.exportsettings.resulttablesettings.chosenFormat = option;
    valueStartStructure.contents['genesis.container.content.GenesisTMContent'].transfermodel.renderer[0].sepQual = sepQual; // ADBHSSTAT-2655
    valueStartStructure.contents['genesis.container.content.GenesisTMContent'].transfermodel.exportsettings.resulttablesettings.qualityviewer = sepQual;
    const tmp = JsonHelper.deepCopy(valueStartStructure);
    const returnMessage = await this.messageService.postTableExport('valueretrieval', tmp);
    if (returnMessage[1] === 'error') {
      this.growl.show({
        life: 12000, severity: returnMessage[1], summary: 'Fehler', detail: returnMessage[0][0].message,
      });
    } else {
      const returnMessageD = await this.messageService.postTableExportDownload('valueretrieval', tmp);
      this.growl.show({ severity: 'info', summary: 'Tabelle Exportieren', detail: 'Export erfolgreich, Download startet in Kürze.' });
      const element = document.createElement('a');
      let fileType = '';
      let mimeType = '';
      let data = [returnMessageD[1]];
      const BOM = '\ufeff'; // for charset encoding, there has to be a better way
      if (option === 'CSV_TABLE') {
        fileType = '.csv';
        mimeType = 'text/csv;charset=utf-8';
        data = [BOM, returnMessageD[1]];
      } else if (option === 'XLSX') {
        fileType = '.xlsx';
        mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      } else if (option === 'FLATFILECSV_TABLE') {
        fileType = '.csv';
        mimeType = 'flatfile/csv;charset=utf-8'; // TODO 1889
        data = [BOM, returnMessageD[1]];
      } else {
        fileType = '.csv';
        mimeType = 'text/csv;charset=utf-8';
      }
      const file = new Blob(data, { type: mimeType });
      element.href = URL.createObjectURL(file);
      element.download = name + fileType;
      document.body.appendChild(element); // Required for this to work in FireFox
      element.click();
      this.onHideExportTable();
    }
  }


  async saveTable(tableName, inputRightArea, standardTable,
    orderCriterionId, orderCriterionReference, tableDescription, folder = null) {
    // log('STANDARD#', tableName, inputRightArea, standardTable,
    //  orderCriterionId, orderCriterionReference);
    let rightArea = inputRightArea;
    if (!rightArea) rightArea = 'BEN'; // Default
    this.setState({ testTableName: tableName });
    if (standardTable === 'DEFAULT') {
      this.setState({ tableTyp: standardTable });
    } else {
      this.setState({ tableTyp: undefined });
    }
    // const tableData = { ...this.state };

    const tableData = {};
    for (let i = 0; i < saveVariables.length; i += 1) {
      tableData[saveVariables[i]] = this.state[saveVariables[i]];
    }

    let removeOwner = false;
    if (inputRightArea !== 'BEN') removeOwner = true;
    removeOwner = true;
    delete tableData.savedStructureDTO;
    delete tableData.valueStartStructure;
    delete tableData.saveTableVisible;
    delete tableData.data_html;
    const fileData = JSON.stringify(tableData);
    let { savedStructureDTO } = this.state;
    if (!savedStructureDTO) {
      savedStructureDTO = await this.messageService.postStructureInit();
      if(!savedStructureDTO) {
        this.growl.show({
          life: 12000, severity: "error", summary: 'Fehler', detail: 'Es ist ein Fehler aufgetreten. Die Tabelle konnte nicht gespeichert werden.',
        });
        return;
      }
    }
    // check savedStructureDTO, change to avoid secret values?
    if (savedStructureDTO.contents['genesis.container.content.GenesisTMContent'].transfermodel['@class'] === 'genesis.transfer.model.dto.directory.DirectoryDTO') {
      // DEFAULT for tables, will be overwritten if standard table
      savedStructureDTO.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].typ = 'STRUCTURE';
      savedStructureDTO.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].orderCriterionId = null;
      savedStructureDTO.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].orderCriterionReference = null;
      savedStructureDTO.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].jsonStructure = fileData;
      savedStructureDTO.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].name = tableName;
      savedStructureDTO.contents['genesis.container.content.GenesisTMContent'].transfermodel.caption = {
        '@type': 'MehrsprachigerText',
        langText: [
          {
            '@type': 'Text',
            sprachKennzeichen: 'de',
            text: tableDescription,
            approved: true,
            format: 'text_plain',
          },
          {
            '@type': 'Text',
            sprachKennzeichen: 'en',
            text: null,
            approved: false,
            format: 'text_plain',
          },
        ],
      };
      savedStructureDTO.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].ownerInfo.rightArea = rightArea;
      if (standardTable === 'DEFAULT') {
        savedStructureDTO.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].typ = 'DEFAULT';
        savedStructureDTO.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].orderCriterionId = orderCriterionId;
        savedStructureDTO.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].orderCriterionReference = orderCriterionReference.data.reference;
      }
    } else {
      // DEFAULT for tables, will be overwritten if standard table
      savedStructureDTO.contents['genesis.container.content.GenesisTMContent'].transfermodel.typ = 'STRUCTURE';
      savedStructureDTO.contents['genesis.container.content.GenesisTMContent'].transfermodel.orderCriterionId = null;
      savedStructureDTO.contents['genesis.container.content.GenesisTMContent'].transfermodel.orderCriterionReference = null;
      savedStructureDTO.contents['genesis.container.content.GenesisTMContent'].transfermodel.jsonStructure = fileData;
      savedStructureDTO.contents['genesis.container.content.GenesisTMContent'].transfermodel.name = tableName;
      savedStructureDTO.contents['genesis.container.content.GenesisTMContent'].transfermodel.caption = {
        '@type': 'MehrsprachigerText',
        langText: [
          {
            '@type': 'Text',
            sprachKennzeichen: 'de',
            text: tableDescription,
            approved: true,
            format: 'text_plain',
          },
          {
            '@type': 'Text',
            sprachKennzeichen: 'en',
            text: null,
            approved: false,
            format: 'text_plain',
          },
        ],
      };
      savedStructureDTO.contents['genesis.container.content.GenesisTMContent'].transfermodel.ownerInfo.rightArea = rightArea;
      if (standardTable === 'DEFAULT') {
        savedStructureDTO.contents['genesis.container.content.GenesisTMContent'].transfermodel.typ = 'DEFAULT';
        savedStructureDTO.contents['genesis.container.content.GenesisTMContent'].transfermodel.orderCriterionId = orderCriterionId;
        savedStructureDTO.contents['genesis.container.content.GenesisTMContent'].transfermodel.orderCriterionReference = orderCriterionReference.data.reference;
      }
    }
    // savedStructureDTO.contents['genesis.container.content.GenesisTMContent'].transfermodel.jsonStructure = null;
    let returnMessage;
    try {
      this.setState({ visible1: true, visible: true });
      returnMessage = await this.messageService.postTableInsert('structure', savedStructureDTO, removeOwner);
    } catch (err) {
      log('ERROR in saveTable', err);
    } finally {
      this.setState({ visible1: false, visible: false });
    }
    if (returnMessage[1] === 'error') {
      if (returnMessage[0][0].number === 8083) {
        this.setState({
          saveTableOverrideMessage: returnMessage[0][0].message,
          overrideStructure: { contents: { 'genesis.container.content.GenesisTMContent': returnMessage[2].contents['genesis.container.content.GenesisTMContent'] } },
        });
      } else if (returnMessage[0][0].number === 9001) {
        this.setState({
          saveTableOverrideMessage: `${returnMessage[0][0].message} Möchten Sie das bestehende Objekt ersetzen? (J/N)`,
          overrideStructure: { contents: { 'genesis.container.content.GenesisTMContent': returnMessage[2].contents['genesis.container.content.GenesisTMContent'] } },
        });
      } else {
        this.growl.show({
          life: 12000, severity: returnMessage[1], summary: 'Fehler', detail: returnMessage[0][0].message,
        });
      }
    } else {

      if(folder?.type === 'folder') {
        const folderAssociationInit = {...(await this.messageService.postFolderAssociationInitInit())};
        folderAssociationInit.contents['genesis.container.content.GenesisTMContent'].transfermodel.folderIdent = folder.data.id
        folderAssociationInit.contents['genesis.container.content.GenesisTMContent'].transfermodel.folderName = folder.data.name
        folderAssociationInit.contents['genesis.container.content.GenesisTMContent'].transfermodel.structureIdent = returnMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].id
        folderAssociationInit.contents['genesis.container.content.GenesisTMContent'].transfermodel.structureName = tableName
        this.messageService.postFolderAssociationInsert(folderAssociationInit, { rightArea })
      }



      this.onHideSaveTable();
      this.growl.show({ severity: 'info', summary: 'Tabelle speichern', detail: 'Die Tabelle wurde erfolgreich gespeichert.' });
      const { valueStartStructure } = this.state;
      if (valueStartStructure) {
        valueStartStructure.contents['genesis.container.content.GenesisTMContent'].transfermodel.renderer[0].name = tableName;
        valueStartStructure.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.selektion = [returnMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].id.toString()];
        valueStartStructure.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.possibleTimes = ['2017'];
        valueStartStructure.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.kriterium = [''];
        valueStartStructure.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.userRole = ['GROUP_ADMIN'];
        valueStartStructure.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.defaultTableCheck = ['false'];
        valueStartStructure.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.changeRights = ['true'];
        valueStartStructure.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.object = ['108'];
        this.setState({ valueStartStructure });
      }
    }
  }

  async overrideTable(tableName, rightArea, standardTable,
    orderCriterionId, orderCriterionReference) {
    if (standardTable) this.setState({ tableTyp: 'DEFAULT' });
    const { overrideStructure } = this.state;
    const name = tableName;
    const right = rightArea;
    const type = 'structure';
    const objectTyp = 'STRUCTURE';
    const objectNumber = '108';
    const prefix = '1';
    const existingTables = await this.getDirectory(
      type, right, objectNumber, objectTyp, prefix,
    );
    // const loadedTables = JsonHelper.deepCopy(existingTables);
    const existingId = existingTables.find((entry) => entry.name === name);
    overrideStructure.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].id = existingId.id;
    // overrideStructure.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].ownerInfo.rightArea = rightArea;
    if (standardTable === 'DEFAULT') {
      overrideStructure.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].typ = 'DEFAULT';
      overrideStructure.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].orderCriterionId = orderCriterionId;
      overrideStructure.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].orderCriterionReference = orderCriterionReference.data.reference;
    } else {
      overrideStructure.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].typ = 'STRUCTURE';
      overrideStructure.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].orderCriterionId = null;
      overrideStructure.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].orderCriterionReference = null;
    }
    let returnMessage;
    try {
      this.setState({ visible: true });
      returnMessage = await this.messageService.postTableUpdate('structure', overrideStructure);
    } catch (err) {
      log('ERROR in overrideTable', err);
    } finally {
      this.setState({ visible: false });
    }

    if (returnMessage[1] === 'error') {
      if (returnMessage[0][0].number === 9001) {
        this.setState({ saveTableOverrideMessage: returnMessage[0][0].message });
      } else {
        this.growl.show({
          life: 12000, severity: returnMessage[1], summary: 'Fehler', detail: returnMessage[0][0].message,
        });
      }
    } else {
      this.onHideSaveTable();
      this.growl.show({ severity: 'info', summary: 'Tabelle überschrieben', detail: 'Die Tabelle wurde überschrieben.' });
      this.setState({ overrideStructure: '', saveTableOverrideMessage: '' });
    }
  }

  tableSyntax() {
    const severity = 'info';
    const summary = 'Tabellensyntax';
    const detail = 'Funktion noch nicht implementiert';
    this.growl.show({ severity, summary, detail });
  }

  createClassification() {
    const severity = 'info';
    const summary = 'Klassifikation bilden';
    const detail = 'Funktion noch nicht implementiert';
    this.growl.show({ severity, summary, detail });
  }

  showDialogue() {
    this.setState({ dialogueVisible: true });
  }

  showCalcDialogue() {
    this.setState({ calcDialogueVisible: true });
  }

  showClearDialogue() {
    this.setState({ clearTableVisible: true });
  }

  async closeDialogue(wasSaved) {
    this.setState({ dialogueVisible: false, calcDialogueVisible: false });
    if (wasSaved) {
      const elements1 = { VALUE: [] };
      const elements2 = {
        TIME_CLASSIFYING: [],
        REGION_CLASSIFYING: [],
        SUBJECT_CLASSIFYING: [],
        SUBJECT_CLASSIFYING_TOTAL: [],
      };
      // ... and then reload the classifications
      const { selectedStatistics } = this.state;
      try {
        const elementsData1 = await this.messageService.postDataStockProperties(selectedStatistics, 'algorithmruleStructureElementsListFromStatistic', 'structure', this.returnLandString());
        const elementsData2 = await this.messageService.postDataStockProperties(selectedStatistics, 'referenceruleStructureElementsListFromStatistic', 'structure', this.returnLandString());
        if (elementsData1[1] !== 'error') {
          const elementsAr = elementsData1.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys;
          const elementsList1 = this.prepareElements(elementsAr);
          const merkmale1 = this.prepareMerkmale(elementsAr);
          for (let i = 0; i < elementsList1.length; i += 1) {
            if (elementsList1[i].type !== 'UNDEF') {
              if (!(elementsList1[i].code.substr(0, 4) === 'SEED' && elementsList1[i].type === 'VALUE')) {
                elements1[elementsList1[i].type].push(elementsList1[i]);
              }
            }
          }
          this.setState({
            merkmale1,
            elements1,
          });
        } else {
          this.setState({ merkmale1: [] });
        }
        // log('ELEMENTS#finalPre');
        if (elementsData2[1] !== 'error') {
          const elementsRr = elementsData2.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys;
          // log('ELEMENTS#finalRr', elementsRr);
          const elementsList2 = this.prepareElements(elementsRr);
          const merkmale2 = this.prepareMerkmale(elementsRr);
          for (let i = 0; i < elementsList2.length; i += 1) {
            if (elementsList2[i].type !== 'UNDEF') {
              if (!(elementsList2[i].code.substr(0, 4) === 'SEED' && elementsList2[i].type === 'VALUE')) {
                elements2[elementsList2[i].type].push(elementsList2[i]);
              }
            }
          }
          this.setState({
            merkmale2,
            elements2,
          });
        } else {
          this.setState({ merkmale2: [] });
        }
      } catch (e) {
        log('Error in closeDialogue (ruleStructureElementsListFromStatistic)', e);
      }
    }
  }

  clearTable() {
    this.props.location.state = undefined;
    this.setState({
      testTableName: undefined,
      clearTableVisible: false,
      arrRulesById: {},
      arrFiltersById: {},
      arrSumUpById: {},
      arrCalcUpById: {},
      arrDisplayById: {},
      arrBMMById: {},
      arrNameById: {},
      filter: [],
      filter_graph: [],
      headings: [],
      headings_graph: [],
      merkmal1: [],
      pureFilter_graph: [],
      precondition_graph: [],
      selectedId: '',
      spalte1: [],
      spalte1_graph: [],
      tableRendered: [],
      zeilen: [],
      zeile2: [],
      zeile3: [],
      zeile4: [],
      zeile5: [],
      zeilen_graph: [],
      zeilen1_graph: [],
      zeilen2_graph: [],
      zeilen3_graph: [],
      zeilen4_graph: [],
      zeilen5_graph: [],
      colArray: [[]],
      colGraphArray: [[]],
      rowArray: [[]],
      rowGraphArray: [[]],
      arrSelectedTreeNodes: {},
      hierarchySelection: {},
      outputEntry: {}
    });
    this.createColContainers(); // remove spalteN etc. values
    this.growl.show({
      life: 5000, severity: 'info', summary: 'Hinweis', detail: 'Die Tabellenauswahl wurde zurückgesetzt.',
    });
  }

  updateView() {
    // const rulesMap = JsonHelper.deepCopy(this.state.rulesMap);
    const auspraegungenMap = JsonHelper.deepCopy(this.state.auspraegungenMap);
    templateTable.val_graph = JsonHelper.deepCopy(this.state.filter_graph);
    // log('#DEBUG#', this.state.filter_graph)
    // templateTable.filter_graph = JsonHelper.deepCopy(this.state.filter_graph);
    templateTable.row_graph = this.mergeGraphsRows2();
    templateTable.col_graph = this.mergeGraphs2();
    templateTable.title_graph = JsonHelper.deepCopy(this.state.headings_graph);
    // templateTable.merkmale = JsonHelper.deepCopy(this.state.merkmale);
    // templateTable.rulesMap = rulesMap; // später
    templateTable.auspraegungenMap = auspraegungenMap;
    templateTable.arrDisplayById = JsonHelper.deepCopy(this.state.arrDisplayById);
    templateTable.arrBMMById = JsonHelper.deepCopy(this.state.arrBMMById);
    templateTable.arrNameById = JsonHelper.deepCopy(this.state.arrNameById);
    templateTable.arrSumUpById = JsonHelper.deepCopy(this.state.arrSumUpById);
    templateTable.arrCalcUpById = JsonHelper.deepCopy(this.state.arrCalcUpById);
    this.setState({ tableRendered: templateTable, data_html: '' }, () => { log('callback:', this.state.tableRendered); });
  }

  mergeGraphs() {
    const mergedArray = [...JsonHelper.deepCopy(this.state.spalte1_graph)];
    const helperArray = this.state.colHelperArray;
    helperArray.sort(this.sortFunction);
    this.state.colHelperArray.forEach((container) => {
      if (this.state[container].length > 0) {
        mergedArray.push(...JsonHelper.deepCopy(this.state[`${container}_graph`]));
      }
    });
    return mergedArray;
  }

  mergeGraphs2() {
    const mergedArray = [];//[...JsonHelper.deepCopy(this.state.spalte1_graph)];

    const { colArray, colGraphArray } = this.state;
    colArray.forEach((container, index) => {
      if (container.length > 0) {
        mergedArray.push(...JsonHelper.deepCopy(colGraphArray[index]));
      }
    });
    return mergedArray;
  }

  mergeGraphsRows2() {
    const mergedArray = [];
    const { rowArray, rowGraphArray } = this.state;
    rowArray.forEach((container, index) => {
      if (container.length > 0) {
        mergedArray.push(...JsonHelper.deepCopy(rowGraphArray[index]));
      }
    });
    return mergedArray;
  }

  mergeGraphsRows() {
    const mergedArray = [...JsonHelper.deepCopy(this.state.zeilen_graph)];
    const helperArray = this.state.rowHelperArray;
    helperArray.sort(this.sortFunction);
    this.state.rowHelperArray.forEach((container) => {
      if (this.state[container].length > 0) {
        mergedArray.push(...JsonHelper.deepCopy(this.state[`${container}_graph`]));
      }
    });
    // log('STAT#0mgraph', mergedArray);
    return mergedArray;
  }

  mergeRows() {
    const mergedArray = [...JsonHelper.deepCopy(this.state.zeilen)];
    const helperArray = this.state.rowHelperArray;
    helperArray.sort(this.sortFunction);
    this.state.rowHelperArray.forEach((container) => {
      if (this.state[container].length > 0) {
        mergedArray.push(...JsonHelper.deepCopy(this.state[container]));
      }
    });
    return mergedArray;
  }

  mergeRows2() {
    const mergedArray = [];
    const { rowArray } = this.state;

    rowArray.map((row) => {
      mergedArray.push(...JsonHelper.deepCopy(row));
    });
    return mergedArray;
  }

  mergeCols() {
    const mergedArray = [...JsonHelper.deepCopy(this.state.spalte1)];
    const helperArray = this.state.colHelperArray;
    helperArray.sort(this.sortFunction);
    this.state.colHelperArray.forEach((container) => {
      if (this.state[container].length > 0) {
        mergedArray.push(...JsonHelper.deepCopy(this.state[container]));
      }
    });
    return mergedArray;
  }


  mergeCols2() {
    const mergedArray = [];
    const { colArray } = this.state;

    colArray.map((column) => {
      mergedArray.push(...JsonHelper.deepCopy(column));
    });
    return mergedArray;
  }

  async loadValues2(uniqueID, card) {
    const { previewDeactivated } = this.state;
    const reducer = (accumulator, currentValue) => {
      if (!accumulator.find((obj) => obj.name === currentValue.name)) {
        accumulator.push(currentValue);
      }
      return accumulator;
    };
    // copy to disassociate
    const deepCopy_arrFiltersById = JsonHelper.deepCopy(this.state.arrFiltersById);
    const deepCopy_arrRulesById = JsonHelper.deepCopy(this.state.arrRulesById);
    // remove data_html table
    //  this.setState({ data_html: '' });
    // log('LOADVAL#0', this.state.selectedStatistics[0].name);
    const loadStatistic = this.state.selectedStatistics[0].name;
    const table = document.getElementById('ET');
    const rulesMap = JsonHelper.deepCopy(this.state.rulesMap);
    const auspraegungenMap = JsonHelper.deepCopy(this.state.auspraegungenMap);
    let merkmaleCodes = [];
    if (!previewDeactivated) {
      if (table) {
        // console.log('TABLE#', table);
        table.setAttribute(
          'style',
          'border-collapse: collapse;',
        );
      }
    }

    const target = ['filter', 'headings'];
    let timeIdentifying = '';

    for (let i = 0; i < target.length; i += 1) {
      const tmp = JsonHelper.deepCopy(this.state[target[i]]);
      for (let j = 0; j < tmp.length; j += 1) {
        if (tmp[j].code !== 'type') {
          if (tmp[j].type === 'TIME_IDENTIFYING') timeIdentifying = tmp[j].code;
          merkmaleCodes = update(merkmaleCodes, { $push: [tmp[j].code] });
        }
      }
    }

    const cols = this.state.colArray;

    for (let i = 0; i < cols.length; i += 1) {
      const tmp = JsonHelper.deepCopy(cols[i]);
      for (let j = 0; j < tmp.length; j += 1) {
        if (tmp[j].code !== 'type') {
          if (tmp[j].type === 'TIME_IDENTIFYING') timeIdentifying = tmp[j].code;
          merkmaleCodes = update(merkmaleCodes, { $push: [tmp[j].code] });
        }
      }
    }

    const rows = this.state.rowArray;

    for (let i = 0; i < rows.length; i += 1) {
      const tmp = JsonHelper.deepCopy(rows[i]);
      for (let j = 0; j < tmp.length; j += 1) {
        if (tmp[j].code !== 'type') {
          if (tmp[j].type === 'TIME_IDENTIFYING') timeIdentifying = tmp[j].code;
          merkmaleCodes = update(merkmaleCodes, { $push: [tmp[j].code] });
        }
      }
    }

    merkmaleCodes = merkmaleCodes.filter((elem, index, self) => index === self.indexOf(elem));

    try {
      if (card?.type !== 'VALUE') {
        this.setState({ visible: true });
        for (let n = 0; n < merkmaleCodes.length; n++) {
          // gibt es den Wert für merkmaleCodes[n] schon? Wenn nein laden, sonst nichts
            let tmp = '';
            if (timeIdentifying === merkmaleCodes[n]) {
              const { intersection } = this.state;
              tmp = intersection;
              // log('CARDTYPE#2i', tmp)
            } else {
              const isSecondOption = false;
              const typeR = 'rule';
              let ttypeR;
              ttypeR = 'VARIABLE'; // was 'BASE_VARIABLE'; 1671
              // Only for rules from Statistik-Ergebnismerkmale
              if (card?.ruleName) {
                ttypeR = 'TARGET_VARIABLE';
              }
              const objtypeR = 'RULE';
              if(!rulesMap[merkmaleCodes[n]]) {
              const elementsDataRule = await this.messageService.postRecordStructureDirectory(
                merkmaleCodes[n], isSecondOption, typeR, ttypeR, objtypeR,
              );
              let tmp1;
              // const arr = {};
              if (elementsDataRule[1] !== 'error') {
                // map smaller and as array for selection
                tmp1 = elementsDataRule.map((entry) => {
                  const inhalt = this.multiLanguage.returnInLanguage(entry, 'de');
                  return (
                    {
                      label: inhalt,
                      value: entry,
                      // value: entry.id,
                      // structureElement: entry, // Structue element for JSON message
                    }
                  );
                });
              } else {
                // log('Hint: ', elementsDataRule[0]);
                tmp1 = '';
              }
              let { arrRulesById } = this.state;
              if (!arrRulesById) arrRulesById = [];
              if (typeof (tmp1) !== 'undefined') {
                if (tmp1 !== '') {
                  // log('RULESMAP#0.6', tmp1);
                  rulesMap[merkmaleCodes[n]] = tmp1.sort((a, b) => ((a.id > b.id) ? 1 : -1));
                  if(card) arrRulesById[card.uniqueId] = tmp1.sort((a, b) => ((a.id > b.id) ? 1 : -1));
                } else {
                  rulesMap[merkmaleCodes[n]] = {};
                  if(card) arrRulesById[card.uniqueId] = [];
                }
              } else {
                rulesMap[merkmaleCodes[n]] = {};
                if(card) arrRulesById[card.uniqueId] = [];
              }
              this.setState({arrRulesById})
              }
              const type = 'valueassociation';
              const ttype = 'VARIABLE';
              const objtype = 'ASSOCIATIONVALUETOCLASSIFYINGVARIABLE';
              // log('RULESMAP#0.0', merkmaleCodes[n], isSecondOption);
              const elementsData = await this.messageService.postRecordStructureDirectory(
                merkmaleCodes[n], isSecondOption, type, ttype, objtype,
              );
              // log('AUS#2', elementsData);
              if (elementsData[1] !== 'error') {
                // map smaller
                tmp = elementsData.map((entry) => ({
                  name: entry.name,
                  id: entry.id,
                  classificationKey: entry.classificationKey,
                  code: entry.name,
                  inhalt: this.multiLanguage.returnInLanguage(entry, 'de'),
                  links: '',
                  merkmale: entry.variableCount,
                }));
              } else {
                log('card. error', elementsData);
              }
            }
            // log('CARDTYPE#2', tmp)
            if (tmp !== '') auspraegungenMap[merkmaleCodes[n]] = tmp.sort((a, b) => ((a.id > b.id) ? 1 : -1));
            // log('CARDTYPE#3', tmp)
            this.setState({ rulesMap, auspraegungenMap });
          // bei pushCard setzte passenden Wert für uniqueID aus auspraegungenMap als Filter ein
          if (!deepCopy_arrFiltersById[uniqueID]) {
            if(card) {
              const { code } = card;
              const allAuspraegungen = this.state.auspraegungenMap[code];
              const allRules = this.state.rulesMap[code];
              deepCopy_arrFiltersById[uniqueID] = allAuspraegungen;
              deepCopy_arrRulesById[uniqueID] = allRules;
              this.setState({
                arrFiltersById: deepCopy_arrFiltersById,
                arrRulesById: deepCopy_arrRulesById,
              });
            }
          }
        }
      }
    } catch (e) {
      this.setState({
        visible: false,
      });
      log('ERROR loadValues: ', e);
      this.growl.show({
        life: 3000,
        severity: 'error',
        summary: 'Warnung',
        detail: 'Fehler beim Laden der Merkmalsdaten',
      });
      // this.setState({ visible: false });
    } finally {
      this.setState({ visible: false });
      // log('RULESMAP#0.5 end')
    }

    templateTable.val_graph = this.state.filter_graph;
    templateTable.row_graph = this.mergeGraphsRows2();
    templateTable.col_graph = this.mergeGraphs2();
    templateTable.title_graph = this.state.headings_graph;
    // TODO: nicht sicher, ob die folgende Zeile ausreicht
    templateTable.merkmale = this.state.merkmale.concat(this.state.merkmale1).concat(this.state.merkmale3);
    templateTable.rulesMap = rulesMap;
    templateTable.auspraegungenMap = auspraegungenMap;
    templateTable.arrDisplayById = this.state.arrDisplayById;
    templateTable.arrBMMById = this.state.arrBMMById;
    templateTable.arrNameById = this.state.arrNameById;
    templateTable.arrSumUpById = this.state.arrSumUpById;
    templateTable.arrCalcUpById = this.state.arrCalcUpById;
    this.setState({ tableRendered: templateTable }, () => { log('callback:', this.state.tableRendered); });
    // this.setValuesOnHide()
  }

  hasTableLoaded() {
    const { data_html } = this.state;
    let returnValue = false;
    if (data_html) {
      returnValue = true;
    }
    return returnValue;
  }

  showDeleteButton() {
    const { headings, filter } = this.state;
    const mergedCols = this.mergeCols2();
    const mergedRows = this.mergeRows2();
    const hasCard = mergedCols.length > 0
      || mergedRows.length > 0
      || headings.length > 0
      || filter.length > 0;
    return hasCard;
  }

  // countOccurences(string, word) {
  countOccurences = (string, word) => (string.split(word).length - 1) / 3

  checkMaxTwoRKMM(filter, headings, zeilen, spalten) {
    let countOk = true;
    if (filter && JsonHelper.objectContains(filter, 'REGION_CLASSIFYING')) {
      countOk = this.countOccurences(filter, 'REGION_CLASSIFYING') < 3;
    }
    if (headings && JsonHelper.objectContains(headings, 'REGION_CLASSIFYING')) {
      countOk = countOk && this.countOccurences(headings, 'REGION_CLASSIFYING') < 3;
    }
    if (zeilen && JsonHelper.objectContains(zeilen, 'REGION_CLASSIFYING')) {
      countOk = countOk && this.countOccurences(zeilen, 'REGION_CLASSIFYING') < 3;
    }
    if (spalten && JsonHelper.objectContains(spalten, 'REGION_CLASSIFYING')) {
      countOk = countOk && this.countOccurences(spalten, 'REGION_CLASSIFYING') < 3;
    }
    return countOk;
  }

  showRetrievalButton() {
    const { filter, headings, clearRules } = this.state;
    const spalten = this.mergeCols2();
    const zeilen = this.mergeRows2();

    const countValue = [];
    countValue[1] = this.count('VALUE', filter);
    countValue[2] = this.count('VALUE', headings);
    countValue[3] = this.count('VALUE', zeilen);
    countValue[0] = this.count('VALUE', spalten);
    const numberOfValue = this.count(0, countValue);

    const countTimeIdentifying = [];
    countTimeIdentifying[1] = this.count('TIME_IDENTIFYING', filter);
    countTimeIdentifying[2] = this.count('TIME_IDENTIFYING', headings);
    countTimeIdentifying[3] = this.count('TIME_IDENTIFYING', zeilen);
    countTimeIdentifying[0] = this.count('TIME_IDENTIFYING', spalten);
    const numberOfTimeIdentifying = this.count(0, countTimeIdentifying);

    const countRegionClassifying = [];
    countRegionClassifying[1] = this.count('REGION_CLASSIFYING', filter);
    countRegionClassifying[2] = this.count('REGION_CLASSIFYING', headings);
    countRegionClassifying[3] = this.count('REGION_CLASSIFYING', zeilen);
    countRegionClassifying[0] = this.count('REGION_CLASSIFYING', spalten);
    const numberOfRegionClassifying = this.count(0, countRegionClassifying);

    // RKMM nur einmal in Tabelle
    const uniqueRKMM = numberOfRegionClassifying === 3;
    // ZKMM nur einmal in Tabelle
    const uniqueZKMM = numberOfTimeIdentifying === 3;
    // weniger als 2 WMM in Zeilen
    // const lessThanTwoWMMinRows = countValue[3] < 2;
    // ein Werterkmal irgendwo (oneWMMsomewhere)
    const oneWMMsomewhere = numberOfValue < 4;
    // nur Werterkmal im selben Container (nebengeordnet)
    const onlyWMMInSameContainer = numberOfValue > 2;
    // ein zeitidentifizierendes Merkmal irgendwo
    const oneZIMMsomewhere = numberOfTimeIdentifying < 4;
    // nur zeitidentifizierendes Merkmal im selben Container (nebengeordnet)
    const onlyZIMMInSameContainer = numberOfTimeIdentifying > 2;
    // ein regional-klassifizierendes Merkmal irgendwo
    const oneRKMMsomewhere = JsonHelper.objectContains(filter, 'REGION_CLASSIFYING')
      || JsonHelper.objectContains(headings, 'REGION_CLASSIFYING')
      || JsonHelper.objectContains(zeilen, 'REGION_CLASSIFYING')
      || JsonHelper.objectContains(spalten, 'REGION_CLASSIFYING');
    // höchstens zwei regional-klassifizierendes Merkmale
    const maxTwoRKMM = this.checkMaxTwoRKMM(
      JSON.stringify(filter),
      JSON.stringify(headings),
      JSON.stringify(zeilen),
      JSON.stringify(spalten),
    );
    // ein Merkmal im Vorspalten und Kopfspalte
    const rowHasMM = zeilen.length > 0;
    const columnHasMM = spalten.length > 0;
    // identische Merkmale im gleichem Container
    const identicalOnlyInContainer = true;
    // Gesamt
    const resultPlausi = uniqueZKMM
      && oneWMMsomewhere && onlyWMMInSameContainer
      && oneZIMMsomewhere && onlyZIMMInSameContainer
      && oneRKMMsomewhere
      && rowHasMM && columnHasMM && identicalOnlyInContainer
    // && clearRules;
    return resultPlausi;
  }

  count = (kind, array) => {
    // count(kind, array) {
    let count = 0;
    for (let i = 0; i < array.length; i += 1) {
      if (array[i].type === kind || array[i] === kind) count += 1;
    }
    return count;
  }

  returnTable(ret) {
    let returnValue;
    if (ret[1]) {
      this.growl.show({
        life: 12000, severity: ret[1], summary: 'Fehler', detail: ret[0],
      });
      // return null
    } else {
      const str = ret.data.contents['genesis.container.content.GenesisTMContent'].transfermodel;
      const start_position = str.indexOf('<body>');
      // eslint-disable-next-line
      const end_position = str.indexOf("<\/body>");
      const table = str.substring(start_position, end_position + 7);
      returnValue = (table);
    }
    return returnValue;
  }

  async setValuesOnHide() {
    // TODO: 1715 hier muss selectedRule und id gesetzt werden
    const shortDescription = {
      '@type': 'MehrsprachigerText',
      langText: [
        {
          '@type': 'Text',
          sprachKennzeichen: 'de',
          text: 'text',
          approved: true,
          format: 'text_plain',
        },
        {
          '@type': 'Text',
          sprachKennzeichen: 'en',
          text: null,
          approved: false,
          format: 'text_plain',
        },
      ],
    };
    const {
      selectedContainer, direction, display, sumUp, sorting, selectedId,
      arrCalcUpById, arrBMMById, arrNameById, calcModeOn, arrRuleCharById, arrRuleById,
      arrDisplayRulesById, arrRuleOutputById, calcModeOnById
    } = this.state;
    let { displayRules } = this.state;
    const uniqueId = selectedId;
    // ADBHSSTAT-1715
    // setRule, so Etwas wie { ruled } = this.state;
    // arrRuleById
    // dann wird selectionReference.rule eingetragem und selectionReference.ruleReference gesetzt
    // die Filter müssen getauscht werden, damit die nachgeladenen filter eingetragen werden
    // wahrscheinlich müssen die neuen Filter (newArray) als Objekt durchgeschleift werden
    let name = '';
    let ruleName = '';
    let ruleObject = {};
    let classificationKey = null;
    if (arrRuleById[selectedId]) { // 1715 nullPointer 05.09.23
      name = arrRuleById[selectedId].name;
      displayRules = arrRuleById[selectedId];
    }
    // if (arrRuleById[selectedId]) name = arrRuleById[selectedId].name;
    let { filtered } = this.state;
    if (filtered !== this.state.arrFiltersById[uniqueId]) {
      filtered = this.state.arrFiltersById[uniqueId];
    }
    const isV = (arrCalcUpById[selectedId] === 'v')
    if (filtered || display || sumUp[selectedId] || sorting || direction || displayRules || calcModeOn[selectedId] || isV) {
      if (filtered) {
        if (filtered.constructor.name !== 'Array') filtered = [filtered]; // selection from radio buttons cast to an array
      } else {
        filtered = 'default';
      }
      const newArray = [];
      if (arrRuleCharById[uniqueId]) {
        for (let i = 0; i < filtered.length; i += 1) {
          // log('FILTERED#1', filtered[i], arrRuleCharById.length);
          for (let k = 0; k < arrRuleCharById[uniqueId].length; k += 1) {
            if (filtered[i].name === arrRuleCharById[uniqueId][k].name) {
              // log('FILTERED#1.1', filtered[i], arrRuleCharById[uniqueId][k]);
              newArray.push(arrRuleCharById[uniqueId][k]);
            }
            // more statements
          }
        }
        // log('FILTERED#2', newArray);
        // filtered = newArray; // steht da unten etwas zu filtered?
        // name der Regel wurde schon oben definiert
      }
      // log('FILTERED#2.0', newArray);
      // log('FILTERED#2.1', filtered);
      const obj = this.state.colArray[selectedContainer];
      // log('CLASSKEY#', obj);
      const strSel = JSON.stringify(this.state.colArray[selectedContainer]);
      if (filtered && (filtered !== 'default')) {
        if (strSel.indexOf(uniqueId) > -1) {
          const preparedFilter = filtered.map((entry) => entry.name);
          const preparedFilterLangtext = filtered.map((entry) => entry.inhalt);
          const preparedClassificationKey = filtered.map((entry) => entry.classificationKey);
          this.traverse(
            obj,
            uniqueId,
            preparedFilter,
            preparedFilterLangtext, // neuer wert für 1763 preparedFilterLangtext
            preparedClassificationKey, // neuer wert für 2166
            ruleName, // Name der Regel
            ruleObject, // ges. Regel-Objekt
          ); // traverse over each element in the array
        }
      }
      let entry;
      // console.log('CALC#0', arrCalcUpById[selectedId]);
      if (calcModeOn[selectedId] || isV) { // s. disabled
        // console.log('CALC#1', arrCalcUpById[selectedId]);
        const obj = this.state.colArray[selectedContainer];
        entry = obj.find((o) => o.uniqueId === uniqueId);
        if (arrBMMById[selectedId] === undefined && arrCalcUpById[selectedId] === 'am') {
          this.growl.show({
            life: 5000,
            severity: 'warn',
            summary: 'Hinweis',
            detail: 'Sie haben kein Bezugsmerkmal zur Berechnung des Arithmetischen Mittels gewählt. Die Option wurde für Sie automatisch deaktiviert.',
          });
          arrNameById[selectedId] = undefined;
          calcModeOnById[selectedId] = false;
          this.setState({
            calcModeOn: false,
            calcModeOnById,
            arrCalcUpById: {},
            arrNameById,
          });
          // log('NAME#ENTRY9', this.state.arrNameById);
        } else if (arrBMMById[selectedId] === undefined && arrCalcUpById[selectedId] === 'm') {
          this.growl.show({
            life: 5000,
            severity: 'warn',
            summary: 'Hinweis',
            detail: 'Sie haben kein Bezugsmerkmal zur Berechnung des Medians gewählt. Die Option wurde für Sie automatisch deaktiviert.',
          });
          arrNameById[selectedId] = undefined;
          calcModeOnById[selectedId] = false;
          this.setState({
            calcModeOn: false,
            calcModeOnById,
            arrCalcUpById: {},
            arrNameById,
          });
          // log('NAME#ENTRY9', this.state.arrNameById);
        } else {
          // BMM#
          // console.log('arrCalcUpById#', arrCalcUpById[selectedId]);
          if (arrCalcUpById[selectedId] === 'm') { // MEDIAN
            // const ret = await this.messageService.getMedianobject();
            const ret = await this.messageService.getObject('medianobject');
            ret.data.variable = arrBMMById[selectedId];
            entry.output[0].reference = ret.data;
            entry.output[0].name = ret.data.name;
            entry.output[0].reference.decimals = 1;
            entry.output[0].type = 'FUNCTION';
            entry.output[0].visible = true;
            log('SHORT#', shortDescription);
            if (arrNameById[selectedId] && arrNameById[selectedId] !== '') {
              shortDescription.langText[0].text = arrNameById[selectedId];
              entry.output[0].reference.shortDescription = shortDescription;
            }
          }
          if (arrCalcUpById[selectedId] === 'am') { // AVERAGE
            // const ret = await this.messageService.getAverageobject();
            const ret = await this.messageService.getObject('averageobject');
            ret.data.variable = arrBMMById[selectedId];
            entry.output[0].reference = ret.data;
            entry.output[0].name = ret.data.name;
            entry.output[0].reference.decimals = 1;
            entry.output[0].type = 'FUNCTION';
            entry.output[0].visible = true;
            if (arrNameById[selectedId] && arrNameById[selectedId] !== '') {
              shortDescription.langText[0].text = arrNameById[selectedId];
              entry.output[0].reference.shortDescription = shortDescription;
            }
          }
          if (arrCalcUpById[selectedId] === 'v') { // VZE 2646
            // console.log('arrCalcUpById#c', arrCalcUpById[selectedId]);
            // const ret = await this.messageService.getVZEobject();
            const ret = await this.messageService.getObject('fulltimeequivalentobject');
            ret.data.variable = arrBMMById[selectedId];
            entry.output[0].reference = ret.data;
            entry.output[0].name = ret.data.name;
            entry.output[0].reference.decimals = 1;
            entry.output[0].type = 'FUNCTION';
            entry.output[0].visible = true;
            if (arrNameById[selectedId] && arrNameById[selectedId] !== '') {
              shortDescription.langText[0].text = arrNameById[selectedId];
              entry.output[0].reference.shortDescription = shortDescription;
            }
          }
        }
      }
      if (displayRules) {
        const obj = this.state[selectedContainer];
        entry = obj.find((o) => o.uniqueId === uniqueId);
        entry.activeRule = true;
        entry.ruleName = displayRules.name;
        entry.ruleReferenze = displayRules;
        // Werte für 1715 werden hier gesetzt
      } else {
        const obj = this.state[selectedContainer];
        entry = obj.find((o) => o.uniqueId === uniqueId);
        entry.activeRule = false;
      }
      if (display) {
        const obj = this.state[selectedContainer];
        entry = obj.find((o) => o.uniqueId === uniqueId);
        entry.display = this.state.arrDisplayById[uniqueId];
        if (entry.display === 'FS') {
          entry.labelStructure.contentMap.KEY = true;
          entry.labelStructure.contentMap.SHORT_DESCRIPTION = false;
          entry.labelStructure.contentMap.CLASSIFICATION_KEY = false;
        } else if (entry.display === 'KS') {
          entry.labelStructure.contentMap.KEY = false;
          entry.labelStructure.contentMap.SHORT_DESCRIPTION = false;
          entry.labelStructure.contentMap.CLASSIFICATION_KEY = true;
        } else if (entry.display === 'PS') {
          entry.labelStructure.contentMap.KEY = false;
          entry.labelStructure.contentMap.SHORT_DESCRIPTION = false;
          entry.labelStructure.contentMap.CLASSIFICATION_KEY = true;
        } else if (entry.display === 'KN') {
          entry.labelStructure.contentMap.KEY = false;
          entry.labelStructure.contentMap.SHORT_DESCRIPTION = true;
          entry.labelStructure.contentMap.CLASSIFICATION_KEY = false;
        } else if (entry.display === 'FSKN') {
          entry.labelStructure.contentMap.KEY = true;
          entry.labelStructure.contentMap.SHORT_DESCRIPTION = true;
          entry.labelStructure.contentMap.CLASSIFICATION_KEY = false;
        } else if (entry.display === 'KSKN') {
          entry.labelStructure.contentMap.KEY = false;
          entry.labelStructure.contentMap.SHORT_DESCRIPTION = true;
          entry.labelStructure.contentMap.CLASSIFICATION_KEY = true;
        } else if (entry.display === 'FSKS') {
          entry.labelStructure.contentMap.KEY = true;
          entry.labelStructure.contentMap.SHORT_DESCRIPTION = false;
          entry.labelStructure.contentMap.CLASSIFICATION_KEY = true;
        }
      }
      if (sumUp[selectedId]) {
        const obj = this.state[selectedContainer];
        entry = obj.find((o) => o.uniqueId === uniqueId);
        // console.log('INSGESAMT#0', sumUp);
        // Insgesamt
        if (sumUp[selectedId].indexOf('i') > -1) {
          if (sumUp[selectedId].indexOf('o') > -1) {
            entry.firstSumTotal = true;
            entry.lastSumTotal = false;
          } else {
            entry.firstSumTotal = false;
            entry.lastSumTotal = true;
          }
        } else {
          entry.firstSumTotal = false;
          entry.lastSumTotal = false;
        }
        // Zusammen
        if (sumUp[selectedId].indexOf('z') > -1) {
          entry.sumTogether = true;
        } else {
          entry.sumTogether = false;
        }
      }
      if (sorting) {
        const obj = this.state[selectedContainer];
        let entry = obj.find((o) => o.uniqueId === uniqueId);
        const sortDirection = this.state.arrSortingById[uniqueId];
        if (sortDirection === 'FS') {
          entry.labelStructure.sortCriterion = 'KEY';
        } else if (sortDirection === 'KN') {
          entry.labelStructure.sortCriterion = 'DESCRIPTION'; // Enum KTX ist das gleiche
        } else if (sortDirection === 'KS') {
          entry.labelStructure.sortCriterion = 'CLASSIFICATION_KEY'; // 2166, war CATEGORY; classification key
        } else if (sortDirection === 'PS') {
          entry.labelStructure.sortCriterion = 'POSITION'; // 2166, neu
        }
      }
      if (uniqueId in this.state.arrDirectionById) {
        const obj = this.state[selectedContainer];
        const entry = obj.find((o) => o.uniqueId === uniqueId);
        entry.labelStructure.sortDirection = this.state.arrDirectionById[uniqueId] === 'up' ? 'ASC' : 'DESC';
      }
      log('FILTER#6.0', this.state[this.state.selectedContainer]);
      this.makeNestedList(this.state.selectedContainer, this.state[this.state.selectedContainer]);
      this.updateView();
    }
    const filteredState = this.state.filtered;
    if (filteredState) {
      if (filteredState.constructor !== Array) {
        // log('FILTER#6', arrFiltered);
        const arrFiltered = [this.state.filtered];
        this.setState({ filtered: arrFiltered });
      }
    }
    // const displayRuleName = displayRules.name;
    // cleanup
    this.setState({
      // ruleName: displayRuleName,
      displayRules: '',
      data_html: '',
      display: '',
      //sumUp: '',
      sorting: '',
      direction: '',
      hideRetrievalButton: false,
    });
  }
  /*
  setValues(e) {
    const arr = e.value;
    console.log('SELECTION#-1', selectedId, arrFiltersById);
    const { selectedId, arrFiltersById } = this.state;
    arrFiltersById[selectedId] = Object.keys(arr).map((element) => arr[element].item);
    console.log('SELECTION#', selectedId, arrFiltersById);
    this.setState({
      arrFiltersById,
      filtered: e.value,
    });
  }
  */
  setValuesNew(e) {
    const { value } = e;
    // console.log('SETVALUES#', value);
    this.setState({ dataTempVal: value })
  }

  variableSelectionToFilter(obj) {
    return {name: obj.name, nextSelection: obj.childvalues, nextSelectionForTableRenderer: obj.childvalues?.map((child) => this.variableSelectionToFilter(child)) || [],  variableName: obj.variableName, inhalt: this.multiLanguage.returnInLanguage(obj, 'de'), id: obj.id}
  } 

  filtersToRuleHierarchyFilters(arr, result, level) {
    const {arrSelectedTreeNodes, selectedId, itemInList} = this.state;
    arr.forEach((obj) => {
      if(arrSelectedTreeNodes[selectedId][obj.name]?.checked || arrSelectedTreeNodes[selectedId][obj.name]?.partialChecked) {
        if(!result[level]) result[level] =  [];
          result[level] = [...result[level], 
        //{name: obj.name, nextSelection: obj.childvalues, variableName: obj.variableName, inhalt: this.multiLanguage.returnInLanguage(obj, 'de')}
        this.variableSelectionToFilter(obj)
        ]
        //if(obj.variableName !== itemInList) {
          if(obj.childvalues) this.filtersToRuleHierarchyFilters(obj.childvalues, result, level+1)
        //}
      }
    })
  }

  async setValuesOnHide2() {
    // TODO: 1715 hier muss selectedRule und id gesetzt werden
    const shortDescription = {
      '@type': 'MehrsprachigerText',
      langText: [
        {
          '@type': 'Text',
          sprachKennzeichen: 'de',
          text: 'text',
          approved: true,
          format: 'text_plain',
        },
        {
          '@type': 'Text',
          sprachKennzeichen: 'en',
          text: null,
          approved: false,
          format: 'text_plain',
        },
      ],
    };
    const {
      selectedContainer, direction, display, sumUp, sorting, selectedId,
      arrCalcUpById, arrBMMById, arrNameById, calcModeOn, arrRuleCharById, arrRuleById,
      arrDisplayRulesById, arrRuleOutputById, arrFiltersById, calcModeOnById, arrSumUpById,
      prefixById
    } = this.state;
    let { displayRules } = this.state;
    const uniqueId = selectedId;
    console.log('SEL#1', arrRuleOutputById?.[selectedId]);
    const objMap = new Map();
    const target = ['filter', 'headings', 'zeilen'];

    target.map((tar) => {
      const tmp = JsonHelper.deepCopy(this.state[tar]);
      objMap.set(tar, tmp);
    });

    const cols = this.state.colArray;

    for (let i = 0; i < cols.length; i += 1) {
      const tmp = JsonHelper.deepCopy(cols[i]);
      objMap.set('spalte' + i, tmp);
    }

    const rows = this.state.rowArray;

    for (let i = 0; i < rows.length; i += 1) {
      const tmp = JsonHelper.deepCopy(rows[i]);
      objMap.set('zeile' + i, tmp);
    }

    // ADBHSSTAT-1715
    // setRule, so Etwas wie { ruled } = this.state;
    // arrRuleById
    // dann wird selectionReference.rule eingetragem und selectionReference.ruleReference gesetzt
    // die Filter müssen getauscht werden, damit die nachgeladenen filter eingetragen werden
    // wahrscheinlich müssen die neuen Filter (newArray) als Objekt durchgeschleift werden
    let name = '';
    let ruleName = '';
    let ruleObject = {};
    let regelStufenElemente = [];
    let classificationKey = null;
    if (arrRuleById?.[selectedId]) { // 1715 nullPointer 05.09.23
      name = arrRuleById?.[selectedId].name;
      displayRules = arrRuleById?.[selectedId];
    }
    // if (arrRuleById[selectedId]) name = arrRuleById[selectedId].name;
    let { filtered } = this.state;
    if (filtered !== this.state.arrFiltersById?.[uniqueId]) {
      filtered = this.state.arrFiltersById?.[uniqueId];
    }
    const isV = (arrCalcUpById?.[selectedId] === 'v')
    if (filtered || display || sumUp[selectedId] || sorting || direction || displayRules || calcModeOn?.[selectedId] || isV) {
      if (filtered) {
        if (filtered.constructor.name !== 'Array') filtered = [filtered]; // selection from radio buttons cast to an array
      } else {
        filtered = 'default';
      }
      const newArray = [];
      /* if (arrRuleCharById[uniqueId]) {
        for (let i = 0; i < filtered.length; i += 1) {
           log('FILTERED#1', filtered[i], arrRuleCharById.length);
          for (let k = 0; k < arrRuleCharById[uniqueId].length; k += 1) {
            if (filtered[i].name === arrRuleCharById[uniqueId][k].name) {
               log('FILTERED#1.1', filtered[i], arrRuleCharById[uniqueId][k]);
              newArray.push(arrRuleCharById[uniqueId][k]);
            }
            // more statements
          }
        }
      } */


      let preparedFilter = [];
      let preparedFilterLangtext = [];
      const {outputEntry, hierarchySelection} = this.state
      const hierarchyLevels = outputEntry?.[selectedId]?.hierarchyLevels || [];
      if(outputEntry?.[selectedId]?.type === "REFERENCE") hierarchyLevels.push(outputEntry?.[selectedId])
      if(filtered !== 'default') {
        if (arrRuleCharById?.[uniqueId]) {
          
          const tmp = [];        
          this.filtersToRuleHierarchyFilters(arrFiltersById[uniqueId], tmp, 0)
          preparedFilter = tmp.reverse();
          /* arrFiltersById[uniqueId].map((f) => {
            preparedFilterLangtext.push(this.multiLanguage.returnInLanguage(f, 'de'))
          }) */
        }
        else {
          preparedFilter = filtered.map((entry) => entry.name);
          preparedFilterLangtext = filtered.map((entry) => entry.inhalt);
        }
      }
      const obj = objMap.get(selectedContainer);
      const strSel = JSON.stringify(obj);
      if (filtered && (filtered !== 'default')) {
        if (strSel.indexOf(uniqueId) > -1) {
          //const preparedFilter = filtered.map((entry) => entry.name);
          //const preparedFilterLangtext = filtered.map((entry) => entry.inhalt);
          const preparedClassificationKey = filtered.map((entry) => entry.classificationKey);
          const preparedHierarchyLevels = hierarchyLevels?.reduce((prev, curr) => {
                                            Object.assign(prev, {[curr.targetVariable]: curr.referenceRule ? curr.referenceRule : curr.name});
                                            return prev;
                                          }, {}); //.map((level) =>{return {[level.targetVariable]: level.referenceRule}}))
          //if (arrRuleOutputById[selectedId]) regelStufenElemente = arrRuleOutputById[selectedId];

          if (hierarchySelection?.[selectedId]) Object.entries(hierarchySelection?.[selectedId]).forEach((hs) => {
            regelStufenElemente.push( ...hs[1].map((type) =>{
              return {
                visible: true,
                name: preparedHierarchyLevels[hs[0]] !== undefined ? hs[0] : obj[0].name,
                type: type
              }
            }))
          })
          this.traverse(
            obj,
            uniqueId,
            preparedFilter,
            preparedFilterLangtext, // neuer wert für 1763 preparedFilterLangtext
            preparedClassificationKey, // neuer wert für 2166
            ruleName, // Name der Regel
            ruleObject, // ges. Regel-Objekt
            regelStufenElemente, // Ausgabe 2606
            preparedHierarchyLevels
          ); // traverse over each element in the array
        }
      }
      let entry;
      // console.log('CALC#0', arrCalcUpById[selectedId]);
      if (calcModeOnById?.[selectedId] || isV) { // s. disabled
        // console.log('CALC#1', arrCalcUpById[selectedId]);
        const obj = objMap.get(selectedContainer);
        
        entry = obj.find((o) => o.uniqueId === uniqueId);
        if (arrBMMById?.[selectedId] === undefined && arrCalcUpById?.[selectedId] === 'am') {
          this.growl.show({
            life: 5000,
            severity: 'warn',
            summary: 'Hinweis',
            detail: 'Sie haben kein Bezugsmerkmal zur Berechnung des Arithmetischen Mittels gewählt. Die Option wurde für Sie automatisch deaktiviert.',
          });
          arrNameById[selectedId] = undefined;
          calcModeOnById[selectedId] = false;
          this.setState({
            calcModeOn: false,
            calcModeOnById,
            arrCalcUpById: {},
            arrNameById,
          });
          // log('NAME#ENTRY9', this.state.arrNameById);
        } else if (arrBMMById?.[selectedId] === undefined && arrCalcUpById?.[selectedId] === 'm') {
          this.growl.show({
            life: 5000,
            severity: 'warn',
            summary: 'Hinweis',
            detail: 'Sie haben kein Bezugsmerkmal zur Berechnung des Medians gewählt. Die Option wurde für Sie automatisch deaktiviert.',
          });
          arrNameById[selectedId] = undefined;
          calcModeOnById[selectedId] = false;
          this.setState({
            calcModeOn: false,
            calcModeOnById,
            arrCalcUpById: {},
            arrNameById,
          });
        } else {
          // BMM#
          if (arrCalcUpById?.[selectedId] === 'm') { // MEDIAN
            const ret = await this.messageService.getObject('medianobject');
            ret.data.variable = arrBMMById?.[selectedId];
            entry.output[0].reference = ret.data;
            entry.output[0].name = ret.data.name;
            entry.output[0].reference.decimals = 1;
            entry.output[0].type = 'FUNCTION';
            entry.output[0].visible = true;
            log('SHORT#', shortDescription);
            if (arrNameById?.[selectedId] && arrNameById?.[selectedId] !== '') {
              shortDescription.langText[0].text = prefixById[selectedId].trim() + " " + arrNameById?.[selectedId];
              entry.output[0].reference.shortDescription = shortDescription;
            }
          }
          if (arrCalcUpById?.[selectedId] === 'am') { // AVERAGE
            // const ret = await this.messageService.getAverageobject();
            const ret = await this.messageService.getObject('averageobject');
            ret.data.variable = arrBMMById?.[selectedId];
            entry.output[0].reference = ret.data;
            entry.output[0].name = ret.data.name;
            entry.output[0].reference.decimals = 1;
            entry.output[0].type = 'FUNCTION';
            entry.output[0].visible = true;
            if (arrNameById?.[selectedId] && arrNameById?.[selectedId] !== '') {
              shortDescription.langText[0].text = prefixById[selectedId].trim() + " " + arrNameById?.[selectedId];
              entry.output[0].reference.shortDescription = shortDescription;
            }
          }
          if (arrCalcUpById[selectedId] === 'v') { // VZE 2646
            // console.log('arrCalcUpById#c', arrCalcUpById[selectedId]);
            // const ret = await this.messageService.getVZEobject();
            const ret = await this.messageService.getObject('fulltimeequivalentobject');
            ret.data.variable = arrBMMById[selectedId];
            entry.output[0].reference = ret.data;
            entry.output[0].name = ret.data.name;
            entry.output[0].reference.decimals = 1;
            entry.output[0].type = 'FUNCTION';
            entry.output[0].visible = true;
            if (arrNameById?.[selectedId] && arrNameById?.[selectedId] !== '') {
              shortDescription.langText[0].text = prefixById[selectedId].trim() + " " + arrNameById?.[selectedId];
              entry.output[0].reference.shortDescription = shortDescription;
            }
          }
        }
      }

      if (displayRules) {
        const obj = objMap.get(selectedContainer);
        entry = obj.find((o) => o.uniqueId === uniqueId);
        entry.activeRule = true;
        entry.ruleName = displayRules.name;
        entry.ruleReferenze = displayRules;
        // Werte für 1715 werden hier gesetzt
      } else {
        const obj = objMap.get(selectedContainer);
        entry = obj.find((o) => o.uniqueId === uniqueId);
        entry.activeRule = false;
      }
      if (display) {
        const obj = objMap.get(selectedContainer);
        entry = obj.find((o) => o.uniqueId === uniqueId);
        entry.display = this.state.arrDisplayById[uniqueId];
        if (entry.display === 'FS') {
          entry.labelStructure.contentMap.KEY = true;
          entry.labelStructure.contentMap.SHORT_DESCRIPTION = false;
          entry.labelStructure.contentMap.CLASSIFICATION_KEY = false;
        } else if (entry.display === 'KS') {
          entry.labelStructure.contentMap.KEY = false;
          entry.labelStructure.contentMap.SHORT_DESCRIPTION = false;
          entry.labelStructure.contentMap.CLASSIFICATION_KEY = true;
        } else if (entry.display === 'PS') {
          entry.labelStructure.contentMap.KEY = false;
          entry.labelStructure.contentMap.SHORT_DESCRIPTION = false;
          entry.labelStructure.contentMap.CLASSIFICATION_KEY = true;
        } else if (entry.display === 'KN') {
          entry.labelStructure.contentMap.KEY = false;
          entry.labelStructure.contentMap.SHORT_DESCRIPTION = true;
          entry.labelStructure.contentMap.CLASSIFICATION_KEY = false;
        } else if (entry.display === 'FSKN') {
          entry.labelStructure.contentMap.KEY = true;
          entry.labelStructure.contentMap.SHORT_DESCRIPTION = true;
          entry.labelStructure.contentMap.CLASSIFICATION_KEY = false;
        } else if (entry.display === 'KSKN') {
          entry.labelStructure.contentMap.KEY = false;
          entry.labelStructure.contentMap.SHORT_DESCRIPTION = true;
          entry.labelStructure.contentMap.CLASSIFICATION_KEY = true;
        } else if (entry.display === 'FSKS') {
          entry.labelStructure.contentMap.KEY = true;
          entry.labelStructure.contentMap.SHORT_DESCRIPTION = false;
          entry.labelStructure.contentMap.CLASSIFICATION_KEY = true;
        }
      }
      if (sumUp[selectedId]) {
        const obj = objMap.get(selectedContainer);
        entry = obj.find((o) => o.uniqueId === uniqueId);
        // console.log('INSGESAMT#0', sumUp);
        // Insgesamt
        if (sumUp[selectedId].indexOf('i') > -1) {
          if (sumUp[selectedId].indexOf('o') > -1) {
            entry.firstSumTotal = true;
            entry.lastSumTotal = false;
          } else {
            entry.firstSumTotal = false;
            entry.lastSumTotal = true;
          }
        } else {
          entry.firstSumTotal = false;
          entry.lastSumTotal = false;
        }
        // Zusammen
        if (sumUp[selectedId].indexOf('z') > -1) {
          entry.sumTogether = true;
        } else {
          entry.sumTogether = false;
        }
      }
      if (sorting) {
        const obj = objMap.get(selectedContainer);
        let entry = obj.find((o) => o.uniqueId === uniqueId);
        const sortDirection = this.state.arrSortingById[uniqueId];
        if (sortDirection === 'FS') {
          entry.labelStructure.sortCriterion = 'KEY';
        } else if (sortDirection === 'KN') {
          entry.labelStructure.sortCriterion = 'DESCRIPTION'; // Enum KTX ist das gleiche
        } else if (sortDirection === 'KS') {
          entry.labelStructure.sortCriterion = 'CLASSIFICATION_KEY'; // 2166, war CATEGORY; classification key
        } else if (sortDirection === 'PS') {
          entry.labelStructure.sortCriterion = 'POSITION'; // 2166, neu
        }
      }
      if (uniqueId in this.state.arrDirectionById) {
        const obj = objMap.get(selectedContainer);
        const entry = obj.find((o) => o.uniqueId === uniqueId);
        entry.labelStructure.sortDirection = this.state.arrDirectionById[uniqueId] === 'up' ? 'ASC' : 'DESC';
      }
      log('FILTER#6.0', this.state[this.state.selectedContainer]);
      if (selectedContainer.includes("zeile")) {
        this.makeNestedListRows2(selectedContainer.replace("zeile", ""), objMap.get(selectedContainer))
        //ADBHSSTAT-2731
        rows[selectedContainer.replace("zeile", "")] = objMap.get(selectedContainer);
        this.setState({ rowArray: rows }, () => this.updateView())
      }
      else {
        if (selectedContainer.includes("spalte")) {
          this.makeNestedListCol2(selectedContainer.replace("spalte", ""), objMap.get(selectedContainer))
          //ADBHSSTAT-2731
          cols[selectedContainer.replace("spalte", "")] = objMap.get(selectedContainer);
          this.setState({ colArray: cols }, () => this.updateView())
        }
        else {
          this.makeNestedList2(selectedContainer, objMap.get(selectedContainer));
          //ADBHSSTAT-2731
          this.setState({ [selectedContainer]: objMap.get(selectedContainer) }, () => this.updateView())
        }
      }
    }
    const filteredState = this.state.filtered;
    if (filteredState) {
      if (filteredState.constructor !== Array) {
        // log('FILTER#6', arrFiltered);
        const arrFiltered = [this.state.filtered];
        this.setState({ filtered: arrFiltered });
      }
    }
    // const displayRuleName = displayRules.name;
    // cleanup
    this.setState({
      // ruleName: displayRuleName,
      displayRules: '',
      data_html: '',
      display: '',
     // sumUp: '',
      sorting: '',
      direction: '',
      hideRetrievalButton: false,
      isDialogOpen: false
    });
  }

  treeSelectionToFilters(obj, arr) {
    let result = []
    arr.forEach((entry) => {
      if(obj[entry.name]){
        //entry.childvalues = selectedChildvalues
        result.push(entry)

       /*  if(entry.childvalues) {
          if(entry.variableName === itemInList) {
            addAllChildren = true;
          }
          if(addAllChildren) obj = {...obj, ...this.filtersToTreeSelectionKeys(entry.childvalues)}
          result.push(...this.treeSelectionToFilters(obj, entry.childvalues, addAllChildren))
        } */
         
      }
    })
    return result;
  }

  treeSelectiontoTreeNodes(selection, arr, addAllChildren = false) {
    const {itemInList} = this.state;
    let newSelection = {...selection}
    arr.forEach((entry) => {
      if(selection[entry.name]){
        if(entry.variableName === itemInList) addAllChildren = true
        if(entry.childvalues) {
          if(addAllChildren) newSelection = {...newSelection, ...this.filtersToTreeSelectionKeys(entry?.childvalues || [])}
          newSelection = {...newSelection, ...this.treeSelectiontoTreeNodes(newSelection, entry.childvalues, addAllChildren)}
        }
      }
    })

    return newSelection;
  }

  setValues(e) {
    const { selectedId, arrFiltersById, arrRuleCharById, itemInList, auspraegungenMap, arrSelectedTreeNodes } = this.state;
    let arr = e.value;
    if (arr) {
      if(typeof arr === "string"){
        arr = this.filtersToTreeSelectionKeys([auspraegungenMap[itemInList].find((aus) => aus.code === arr)])
      }
      /* if (arr.value != null) {
        if (arr.constructor !== Array) {
          arr = [e.value];
        }
      } */
      
      /* const filters = []
      auspraegungenMap[itemInList].forEach((item) => {
        if(Object.keys(arr).includes(item.code))
          filters.push(item)
      })//this.checkedTreeItemsToFilters(arrRuleCharById[selectedId], arr);
      arrFiltersById[selectedId] = filters;
      console.log("setValue", arr)
      arrSelectedRuleNodes[selectedId] = arr
      console.log("setValues arrFiltersById", arrFiltersById[selectedId]) */
      //console.log("setValues before", arrFiltersById[selectedId], arr)
      arrSelectedTreeNodes[selectedId] = this.treeSelectiontoTreeNodes(arr, arrRuleCharById[selectedId] ? arrRuleCharById[selectedId] : auspraegungenMap[itemInList])//arr
      //console.log("setValues states", arrRuleCharById?.[selectedId], auspraegungenMap[itemInList])
      arrFiltersById[selectedId] = this.treeSelectionToFilters(arr, arrRuleCharById[selectedId] ? arrRuleCharById[selectedId] : auspraegungenMap[itemInList])
     /*  if(typeof arr === "string" && arrFiltersById[selectedId].length === 0) {
        arrFiltersById[selectedId] = this.filtersToTreeSelectionKeys([auspraegungenMap[itemInList].find((aus) => aus.code === arr)])
        arrSelectedTreeNodes[selectedId] = arr
      } */
        
      //console.log("setValues after", arrFiltersById[selectedId], arrSelectedTreeNodes[selectedId])
      this.setState({
       arrFiltersById,
        filtered: e.value,
        arrSelectedTreeNodes
      });
    }
  }


  setDisplay(e) {
    const { selectedId, arrDisplayById } = this.state;
    arrDisplayById[selectedId] = e.value;
    this.setState({
      arrDisplayById,
      display: e.value,
    });
  }

  setBMM(e) {
    const {
      elements, selectedId, arrBMMById,
      arrNameById, arrCalcUpById,
    } = this.state;
    arrBMMById[selectedId] = e.value;
    if (!arrCalcUpById[selectedId] && arrBMMById[selectedId] !== '') {
      arrCalcUpById[selectedId] = 'v'; // VZE 2646
    }
    for (let i = 0; i < elements.VALUE.length; i += 1) {
      if (elements.VALUE[i].name === e.value) {
        arrNameById[selectedId] = this.multiLanguage.returnInLanguage(elements.VALUE[i], 'de');
      }
    }
    this.setState({
      arrCalcUpById,
      arrBMMById,
      arrNameById,
      wertmerkmale: e.value,
    });
  }

  async setRule(e) {
    const {
      selectedId, arrRuleCharById,
      arrRuleById, arrFiltersById,
      hierarchySelection, arrSelectedTreeNodes,
      isLoadingRule, outputEntry, itemInList,
      auspraegungenMap
    } = this.state;
    let { clearRules } = this.state;
    if(arrSelectedTreeNodes)
      delete arrSelectedTreeNodes[selectedId]
    else
      arrSelectedTreeNodes = {}
    this.setState({arrSelectedTreeNodes, isLoadingRule: true})    

    if(!e.value) {
      delete arrRuleById[selectedId];
      delete arrRuleCharById[selectedId];
      delete outputEntry[selectedId];
      delete hierarchySelection[selectedId];
      
      arrFiltersById[selectedId] = auspraegungenMap[itemInList]
      arrSelectedTreeNodes[selectedId] = this.filtersToTreeSelectionKeys(auspraegungenMap[itemInList] || []),

      this.setState({
        arrRuleById,
        outputEntry,
        hierarchySelection,
        isLoadingRule: false,
        arrRuleCharById,
        arrFiltersById,
        arrSelectedTreeNodes,
        displayRules: ''
      })
      return;
    }

    const oldRule = arrRuleById;
    console.log(" e.value",  e.value)
    arrRuleById[selectedId] = e.value;
    this.setState({
      arrRuleById,
      displayRules: e.value,
    });
    // reload Ausprägungen
    const right = 'ALL'; // rightArea;
    const fullType = 'value';
    const objectTyp = 'VALUE';
    const objectNumber = '6'; // VALUE=6
    const prefix = '1';
    const onlyTable = true;
    const { name } = e.value;
    const type = 'RULE';
    const statisticLink = [
      {
        '@class': 'genesis.transfer.model.dto.directory.view.SimpleDirectoryLinkInfo',
        type,
        name,
        reference: null,
        id: -1,
        shortDescription: '',
        idList: [],
      },
    ];
    let reloaded;
    let strAntworten = 'Antworten';

const path = 'properties';
const inputType = 'rule';

    try {
      numberOfLoads += 1;
      clearRules = false;
      this.setState({
        clearRules,
      });
      if (numberOfLoads < 2) strAntworten = 'Antwort';
      const detail = `Warte auf ${numberOfLoads} ${strAntworten}`;
      this.growl.show({
        sticky: true, closable: false, severity: 'hint', summary: 'Lade Regeln...', detail,
      });
      reloaded = await this.getDirectory(fullType, right, objectNumber, objectTyp,
        prefix, undefined, onlyTable, statisticLink);



      const elementsData = await this.messageService.postRuleProperties(path, inputType, arrRuleById[selectedId].name, arrRuleById[selectedId].id);
      if (elementsData[0]) {
        const message = elementsData[0].replace('java.lang.Exception:', '');
        this.growl.show({ severity: elementsData[1], summary: 'Hinweis', detail: message });
      } else {
        const { entrys } = elementsData.data.contents['genesis.container.content.GenesisTMContent'].transfermodel;
        if(!outputEntry) outputEntry = {}
        outputEntry[selectedId] = entrys[0];
        /* const hierarchyLevels = new Set();
        outputEntry.hierarchyLevels.forEach((hl) => {
          hierarchyLevels.add(hl.baseVariable);
          hierarchyLevels.add(hl.targetVariable);
        })*/
        const hierarchyLevels = [];
        if(outputEntry[selectedId].type === "REFERENCE") {
          if(outputEntry[selectedId].baseVariables.includes(itemInList)) {
            hierarchyLevels.push(...outputEntry[selectedId].baseVariables)
          }
          hierarchyLevels.push(outputEntry[selectedId].targetVariable)
        }
        else {
          hierarchyLevels.push(outputEntry[selectedId].name);
          hierarchyLevels.push(...(outputEntry[selectedId]?.hierarchyLevels?.map((hl) => hl.targetVariable) || [] ));
        }
        const { hierarchySelection } = this.state;
        if(!hierarchySelection) hierarchySelection = {}
        hierarchySelection[selectedId] = Object.assign({}, ...hierarchyLevels.map((level) => {return {[level]: ["DOCUMENTARY", "VALUES"]}}));
        console.log("hierarchySelection", hierarchySelection)
        const { type } = outputEntry[selectedId];
        const kind = ruleType[type];
        //console.log("hierarchySelection", hierarchySelection)
        // this.openDialog(node, kind, outputEntry);
        // console.log('NODE#', kind, outputEntry);
        this.setState({
          outputEntry,
          hierarchySelection,
        
        });
      }
      /*
      const originalObject = reloaded;
    // kleine Regression:
    const reduceChildren = (obj, counter) => {
      const { name } = obj;
      const langText = this.multiLanguage.returnInLanguage(obj, 'de')
      const childvalues = obj.childvalues.map((child, index) =>
        reduceChildren(child, `${counter}-${index}`));
      if (childvalues.length > 0) {
        return {
          key: counter,
          label: langText,
          data: name,
          icon: '',
          children: childvalues,
        };
      } else {
        return {
          key: counter,
          label: langText,
          data: name,
          icon: '',
          checked: true,
          partialChecked: false,
        };
      }
    };
    // Einstieg in Regression
    const reducedObject = originalObject.map((obj, index) =>
      reduceChildren(obj, `${index}`));
    console.log('RULE#101', reducedObject);
    console.log('RULE#101', this.state.dataTemp);
    this.setState({ dataTemp: reducedObject });
      */
    } catch (err) {
      log('error in setRule', err);
      this.setState({
        arrRuleById: oldRule,
       // displayRules,
      });
    } finally {
      // ruleReference wird mit der gewählten rule befüllt
      // rule erhält den Namen von der Regel
      // Ausprägungen erhält alle gewählten Ausprägungen aus reloaded
      if(!arrRuleCharById) arrRuleCharById = {}
      arrRuleCharById[selectedId] = reloaded;
      /* const tmpArrFilters = [];
      this.ruleAuspraegungenToFlatList(reloaded, tmpArrFilters) */
      if(!arrFiltersById) arrFiltersById = {}
      arrFiltersById[selectedId] = reloaded;
      if(!arrSelectedTreeNodes[selectedId]) arrSelectedTreeNodes[selectedId] = this.filtersToTreeSelectionKeys(arrFiltersById[selectedId] || []);
      numberOfLoads -= 1;
      if (numberOfLoads === 0) {
        this.growl.clear();
        clearRules = true;
      }
      this.setState({
        arrRuleCharById,
        clearRules,
        isLoadingRule: false,
        arrFiltersById,
        arrSelectedTreeNodes
      });
    }
  }

  setSorting(e) {
    const { selectedId, arrSortingById } = this.state;
    arrSortingById[selectedId] = e.value;
    this.setState({
      arrSortingById,
      sorting: e.value,
    });
  }

  async setOutput(e, node) {
    this.setState({ activeIndex: e.index })
    /* if (e.index === 1) {
      // console.log('NODE#', node);
      // lade Eigenschaften der Regel
      const { name, id } = node;
      const path = 'properties';
      const inputType = 'rule';
      // Eingenschaften abrufen
      this.setState({
        visible: true,
      });
      try {
        const elementsData = await this.messageService.postRuleProperties(path, inputType, name, id);
        if (elementsData[0]) {
          const message = elementsData[0].replace('java.lang.Exception:', '');
          this.growl.show({ severity: elementsData[1], summary: 'Hinweis', detail: message });
        } else {
          const { entrys } = elementsData.data.contents['genesis.container.content.GenesisTMContent'].transfermodel;
          const outputEntry = entrys[0];
          const { type } = outputEntry;
          const kind = ruleType[type];
          // this.openDialog(node, kind, outputEntry);
          // console.log('NODE#', kind, outputEntry);
          this.setState({
            outputEntry,
          });
        }
      } catch (err) {
        console.log('error in setOutput:', err);
      } finally {
        this.setState({
          visible: false,
        });
      }
    } */
  }

  setDirection() {
    const { selectedId, arrDirectionById } = this.state;
    let currentDirection = arrDirectionById[selectedId];
    if (!currentDirection) currentDirection = 'up';
    if (currentDirection === 'up') {
      currentDirection = 'down';
    } else {
      currentDirection = 'up';
    }
    arrDirectionById[selectedId] = currentDirection;
    this.setState({
      arrDirectionById,
      direction: selectedId,
    });
  }

  setSumUp(e) {
    const { selectedId, arrSumUpById, sumUp } = this.state;
    const { value } = e;
    // console.log('INSGESAMT#4', value, value.indexOf('o'));
    if (value.indexOf('o') > -1) {
      if (value.indexOf('i') === -1) {
        value[value.length] = 'i';
      }
    }
    arrSumUpById[selectedId] = value;
    sumUp[selectedId] = e.value;
    this.setState({
      arrSumUpById,
      sumUp//: e.value,
    });
  }

  setCalcUp(e) {
    const { selectedId, arrCalcUpById, arrBMMById, arrNameById, calcModeOnById, sumUp, prefixById } = this.state;
    // console.log('arrCalcUpById#1', e, selectedId);
    arrCalcUpById[selectedId] = e.value;
    let calcModeOn;
    if (arrCalcUpById[selectedId] === null) {
      calcModeOn = false;
      calcModeOnById[selectedId] = false;
    } else {
      calcModeOn = true;
      calcModeOnById[selectedId] = true;
    }
    sumUp[selectedId] = e.value;

    const prefix = arrCalcUpById[selectedId];
    let text;
    switch (prefix) { // VZE 2649
      case 'm':
        text = 'Median';
        break;
      case 'am':
        text = 'Arith. Mittel';
        break;
      case 'v':
        text = '';
        break;
      default:
        text = '';
    }
    prefixById[selectedId] = text

    this.setState({
      arrNameById,
      calcModeOn,
      calcModeOnById,
      arrCalcUpById,
      prefixById,
      sumUp
    });
  }

  // called with every property and its value recursively
  traverse(
    o, uniqueId, preparedFilter, preparedFilterLangtext,
    preparedClassificationKey, ruleName, ruleObject, regelStufenElemente, hierarchyLevels
  ) {
    for (const i in o) {
      if ({}.hasOwnProperty.call(o, i)) {
        if (!!o[i] && typeof (o[i]) === 'object') {
          if (typeof (o[i]) === 'object') {
            if (o[i].uniqueId) {
              if (o[i].uniqueId === uniqueId) {
                o[i].filter = preparedFilter;
                o[i].filterIds = this.state.auspraegungenMap[o[i].code].filter((auspraegung) => preparedFilter.includes(auspraegung.name)).map((filter) => filter.id)
                o[i].langText = preparedFilterLangtext;
                o[i].classificationKey = preparedClassificationKey;
                o[i].activeFilter = true;
                o[i].ruleName = ruleName; // 1715
                o[i].ruleObject = ruleObject; // 1715 
                o[i].regelStufenElemente = regelStufenElemente;
                o[i].hierarchyLevels = hierarchyLevels;
                return o;
              }
            }
          }
          this.traverse(o[i], uniqueId, preparedFilter);
        }
      }
    }
  }

  // itemTemplate(item) {
  itemTemplate = (item) => (
    <div className="p-col-12 p-md-4">
      <div style={{
        color: 'white',
        background: '#757575 none repeat scroll 0% 0%',
        borderRadius: '4px',
        padding: '2px 4px',
        width: '3.5em',
        textAlign: 'center',
        margin: '1px',
      }}
      >
        {item.name}
      </div>
    </div>
  )

  checkSeletion = (selection) => {
    // checkSeletion(selection) {
    const ret = [];
    for (let i = 0; i < selection.length; i += 1) {
      if (selection[i].filter) {
        if (selection[i].filter.length === 0) {
          ret.push(selection[i].name);
        }
      }
    }
    return ret;
  }

  selectionsHasEmpty() {
    const { headings, filter } = this.state;
    const spalten = this.mergeCols2();
    const zeilen = this.mergeRows2();
    const headingsResult = this.checkSeletion(headings);
    const filterResult = this.checkSeletion(filter);
    const zeilenResult = this.checkSeletion(zeilen);
    const spaltenResult = this.checkSeletion(spalten);
    const ret = headingsResult.concat(zeilenResult).concat(spaltenResult).concat(filterResult);
    return ret;
  }

  async renderTable(valueEmptyLines, valueInput, loadedTable) {
    //const previewDeactivated = false;
    //const previewDeactivatedRadio = false;
//    this.setState({ previewDeactivated, previewDeactivatedRadio });
    let value = valueInput;
    let jobTableVisible = false;
    const selectionsHasEmpty = this.selectionsHasEmpty().join(', ');
    if (selectionsHasEmpty !== '') {
      this.growl.show({
        life: 12000,
        severity: 'warn',
        summary: 'Fehlende Auswahl',
        detail: `Bitte prüfen Sie die Auswahl der Ausprägungen für ${selectionsHasEmpty}`,
      });
    } else {
      this.setState({ visible: true });
      while (numberOfLoads > 0) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }
      let tree;
      let returnMessage;
      // return; // verhindert Lade, ggf weiter unten fehlt dann noch Code
      if (loadedTable) {
        if (typeof value === 'undefined') value = this.state.value;
        const retrievalObj = {
          link: 'valueretrieval',
          tree,
          loadedTable,
          notShowSecretValues: value,
        };
        returnMessage = await this.messageService.postValueRetrievalStart(retrievalObj);
      } else {
        if (typeof valueEmptyLines === 'undefined') valueEmptyLines = this.state.valueEmptyLines;
        if (typeof value === 'undefined') value = this.state.value;
        const zeilen_graph = this.mergeGraphsRows2();
        const spalte1_graph = this.mergeGraphs2();
        const {
          headings_graph, pureFilter_graph,
          precondition_graph,
        } = this.state;
        const graphen = {
          spalte1_graph: JsonHelper.deepCopy(spalte1_graph),
          headings_graph: JsonHelper.deepCopy(headings_graph),
          zeilen_graph: JsonHelper.deepCopy(zeilen_graph),
          pureFilter_graph: JsonHelper.deepCopy(pureFilter_graph),
          precondition_graph: JsonHelper.deepCopy(precondition_graph),
        };
        tree = TreeSerializer.build_directory_dto(graphen);
        const retrievalObj = {
          link: 'valueretrieval',
          tree,
          loadedTable,
          notShowSecretValues: value,
        };
        returnMessage = await this.messageService.postValueRetrievalStart(retrievalObj);
      }
      // return;
      // log('STAT#retm', returnMessage);
      let firstDataSuccess = false;
      if (returnMessage[1] === 'error') {
        const checkError = returnMessage[0];
        let displayError = 'Ein unbekannter Fehler ist aufgetreten.';
        if (checkError === 'javax.ejb.EJBTransactionRolledbackException: genesis.transfer.model.dto.RetrievalJobDTO cannot be cast to genesis.transfer.model.gom.GOMContainer') {
          // displayError = 'Die Anfrage liefert zu viele Werte zurück.';
          displayError = checkError;
        } else {
          displayError = checkError;
        }
        this.growl.show({
          life: 12000,
          severity: returnMessage[1],
          summary: 'Fehler',
          detail: displayError,
        });
      } else {
        if (returnMessage[0].contents['genesis.container.content.GenesisTMContent'].transfermodel['@class'] !== 'genesis.transfer.model.gom.GOMContainer') {
          // Dialog zum Erstellen eines Batchwerteabrufs
          const jobObj = returnMessage[0] //.contents['genesis.container.content.GenesisTMContent'].transfermodel;
          jobTableVisible = true;
        } else {
          firstDataSuccess = true;
        }
      }

      if (firstDataSuccess) {
        const deepCopy_returnMessage = JsonHelper.deepCopy(returnMessage[0]);
        log('EMPTY#', deepCopy_returnMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.renderer[0]);
        if (valueEmptyLines) {
          log('EMPTY#', deepCopy_returnMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.renderer[0]);
          deepCopy_returnMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.renderer[0].blankcolumns = valueEmptyLines;
          deepCopy_returnMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.renderer[0].blankrows = valueEmptyLines;
          deepCopy_returnMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.exportsettings.resulttablesettings.ignorBlankRows = valueEmptyLines;
        }
        const elementsData = await this.messageService.postValueRetrievalHtml('valueretrieval', deepCopy_returnMessage); // valueretrieval/htmltable Message 2 i.e. request for GOM container a HTML
        const htmlTable = this.returnTable(elementsData); // extracted <table> from elementsDate
        log('html#', htmlTable);
        const savedStructureDTO = returnMessage[1];
        this.setState({
          loadComplete: true,
          data_html: { data_html: htmlTable },
          savedStructureDTO,
          valueStartStructure: deepCopy_returnMessage,
        });
      }
      // return;
      this.setState({
        visible: false,
        jobObj,
        jobTableVisible,
      });
    }
  }

  hideEmptyLines(inputValue) {
    this.setState({ valueEmptyLines: inputValue });
  }

  toggleQuality(inputValue) {
    this.setState({ sepQual: inputValue });
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  hidePreview(inputValue) {
    const previewDeactivatedRadio = inputValue;
    const previewDeactivated = inputValue;
    if (!inputValue) {
      this.setState({ previewDeactivatedRadio });
      // rendere den Radio-Button vor der Tabelle:
      this.sleep(100).then(() => { this.setState({ previewDeactivated }); });
    } else {
      this.setState({ previewDeactivatedRadio, previewDeactivated });
    }
  }

  checkSecretValues(value) {
    this.setState({ value });
  }

  // saveTableFooter() {
  saveTableFooter = () => (
    <div>
      <Button
        label="Ja"
        id="yes"
        type="button"
        icon="pi pi-check"
        onClick
      />
      <Button
        label="Nein"
        id="no"
        type="button"
        icon="pi pi-times"
        onClick
        className="p-button-danger"
      />
    </div>
  )

  async fillVariables(jsonStructure) {
    const obj = {};
    for (let i = 0; i < saveVariables.length; i += 1) {
      if(jsonStructure[saveVariables[i]] !== undefined) obj[saveVariables[i]] = jsonStructure[saveVariables[i]];
    }
    this.setState((prevState) => ({ ...prevState, ...obj }));
  }

  prepareMerkmale(elements) {
    const merkmale = elements.map((entry) => {
      const variableType = VariableTypeEnum[entry.variableType];
      return {
        auspraegungen: '',
        code: entry.name,
        inhalt: this.multiLanguage.returnInLanguage(entry, 'de'),
        links: '',
        typ: variableType,
      };
    });
    return merkmale;
  }

  prepareElements(elementsInput, isAverageMedian) {
    const elements = elementsInput;
    for (let ii = 0; ii < elements.length; ii += 1) {
      if (isAverageMedian) elements[ii].isAverageMedian = isAverageMedian; // disable twisty
      elements[ii].uniqueId = '';
      elements[ii].activeRule = false;
      elements[ii].activeFilter = false;
      elements[ii].showRules = false;
      elements[ii].id = ii;
      elements[ii].text = `${this.multiLanguage.returnInLanguage(elements[ii], 'de')} [${elements[ii].name}]`;
      elements[ii].title = `${this.multiLanguage.returnInLanguage(elements[ii], 'de')} [${elements[ii].name}]`;
      elements[ii].code = elements[ii].name;
      elements[ii].children = [];
      elements[ii].expanded = true;
      elements[ii].type = elements[ii].variableType;
      elements[ii].inhalt = this.multiLanguage.returnInLanguage(elements[ii], 'de');
    }
    return elements;
  }

  async returnIntersection(statisticNumbers) {
    const templateLink = {
      '@class': 'genesis.transfer.model.dto.directory.view.SimpleDirectoryLinkInfo',
      type: 'STATISTIC',
      name: '',
      reference: null,
      id: -1,
      shortDescription: '',
      idList: [],
    };
    let intersection = {};
    const link = [];
    const selection = sessionStorage.getItem('evaluationRegional');
    const region = getEntryNum[sessionStorage.getItem('group').split(' ')[1]];
    const isLand = (selection === 'Land');
    for (let i = 0; i < statisticNumbers.length; i += 1) {
      // log('LOADEDTABLE#01', statisticNumbers.name, statisticNumbers);
      const templateCopy = JsonHelper.deepCopy(templateLink);
      templateCopy.name = statisticNumbers[i].name;
      link[i] = templateCopy;
    }
    // log('LOADEDTABLE#02', link);
    const fast = true;
    const elementsDataNew = await this.messageService.postDataStockProperties1(undefined, 'properties', 'cubefromfile', isLand, link, fast);
    // log('LOADEDTABLE#03', elementsDataNew);
    if (elementsDataNew[1] && elementsDataNew[1] === 'error') {
      this.growl.show({ severity: elementsDataNew[1], summary: 'Hinweis für Statistik', detail: elementsDataNew[0] });
    } else {
      // Verarbeitung der Statisiken
      const { entrys } = elementsDataNew.data.contents['genesis.container.content.GenesisTMContent'].transfermodel;
      // log('ENRTYS#', entrys.length);
      if (entrys.length > 0) {
        let { timeSlices } = entrys[0];
        const { rightArea } = entrys[0].ownerInfo;
        const semester = {};
        for (let j = 0; j < timeSlices.length; j += 1) {
          let hasAktiveSlice = true;
          for (let k = 0; k < timeSlices[j].regionalTimeSlices.length; k += 1) {
            // log('UNIQUE#1 rcn', timeSlices[j].regionalTimeSlices[k].regionalClassifyingValueName)
            // log('UNIQUE#1 rts', timeSlices[j].name, timeSlices[j].regionalTimeSlices[k].tmpLock);
            if (selection === 'Land') {
              // check only for own region
              const { regionalClassifyingValueName } = timeSlices[j].regionalTimeSlices[k];
              if (region === regionalClassifyingValueName) {
                // hasAktiveSlice = hasAktiveSlice || !timeSlices[j].regionalTimeSlices[k].tmpLock;
              }
            } else {
              // hasAktiveSlice = hasAktiveSlice || !timeSlices[j].regionalTimeSlices[k].tmpLock;
            }
            // log('UNIQUE#1.1 rts', timeSlices[j].name, hasAktiveSlice);
            if (hasAktiveSlice) {
              if (!semester[timeSlices[j].name]) {
                if (intersection[timeSlices[j].name]) {
                  // log('UNIQUE#if');
                  intersection[timeSlices[j].name] += 1;
                } else {
                  // log('UNIQUE#0else');
                  intersection[timeSlices[j].name] = 1;
                }
                semester[timeSlices[j].name] = true;
              }
            }
          }
        }
      } else {
        this.growl.show({ severity: 'error', summary: 'Auswertungen', detail: 'Es konnten keine Zeitscheiben gefunden werden' });
        intersection = [];
      }
    }
    // log('UNIQUE#2 intersection', intersection);
    const collection = [];
    let n = 0;
    for (let name in intersection) {
      if (intersection.hasOwnProperty(name)) {
        // log('UNIQUE#2.1', name);
        if (intersection[name] === statisticNumbers.length || true) {
          // log('UNIQUE#2.2', collection);
          const item = {
            classificationKey: undefined,
            code: name,
            id: n,
            inhalt: name,
            links: '',
            merkmale: 0,
            name,
          };
          collection.push(item);
          n += 1;
        }
      }
    }
    // log('UNIQUE#3', collection);
    intersection = collection;

    // log('#####', intersection);
    return intersection;
  }

  async returnIntersectionOld(statisticNumbers) {
    // log('LOADEDTABLE#00', statisticNumbers);
    // für die Studentenstatistik kann es bis zu 2 Zeitscheiben je Jahr geben
    let intersection = {};
    const selection = sessionStorage.getItem('evaluationRegional');
    const region = getEntryNum[sessionStorage.getItem('group').split(' ')[1]];
    const isLand = (selection === 'Land');
    for (let i = 0; i < statisticNumbers.length; i += 1) {
      // log('INTER#0', statisticNumbers[i]);
      let elementsDataNew = await this.messageService.postDataStockProperties1(statisticNumbers[i].name, 'properties', 'cubefromfile', isLand);
      // log('INTER#1', elementsDataNew);
      if (elementsDataNew[1] && elementsDataNew[1] === 'error') {
        this.growl.show({
          severity: elementsDataNew[1],
          summary: 'Hinweis',
          detail: elementsDataNew[0],
          life: 20000,
        });
      } else {
        elementsDataNew = elementsDataNew.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys;
        // get all unique names
        // this.growl.show({ severity: 'success', summary: 'Hinweis für Statistik '+statisticNumbers[i].name, detail: 'Daten wurde geladen' });
        let { timeSlices } = elementsDataNew[0];
        const { rightArea } = elementsDataNew[0].ownerInfo;
        // log('UNIQUE#0 rightArea:', rightArea);
        // log('UNIQUE#0 timeSlices:', timeSlices);
        const semester = {};
        for (let j = 0; j < timeSlices.length; j += 1) {
          let hasAktiveSlice = false;
          for (let k = 0; k < timeSlices[j].regionalTimeSlices.length; k += 1) {
            // log('UNIQUE#1 rcn', timeSlices[j].regionalTimeSlices[k].regionalClassifyingValueName)
            // log('UNIQUE#1 rts', timeSlices[j].name, timeSlices[j].regionalTimeSlices[k].tmpLock);
            if (selection === 'Land') {
              // check only for own region
              const { regionalClassifyingValueName } = timeSlices[j].regionalTimeSlices[k];
              if (region === regionalClassifyingValueName) {
                hasAktiveSlice = hasAktiveSlice || !timeSlices[j].regionalTimeSlices[k].tmpLock;
              }
            } else {
              hasAktiveSlice = hasAktiveSlice || !timeSlices[j].regionalTimeSlices[k].tmpLock;
            }
          }
          // log('UNIQUE#1.1 rts', timeSlices[j].name, hasAktiveSlice);
          if (hasAktiveSlice) {
            if (!semester[timeSlices[j].name]) {
              if (intersection[timeSlices[j].name]) {
                // log('UNIQUE#if');
                intersection[timeSlices[j].name] += 1;
              } else {
                // log('UNIQUE#0else');
                intersection[timeSlices[j].name] = 1;
              }
              semester[timeSlices[j].name] = true;
            }
          }
        }
      }
    }
    // log('UNIQUE#2 intersection', intersection);
    const collection = [];
    let n = 0;
    for (let name in intersection) {
      if (intersection.hasOwnProperty(name)) {
        // log('UNIQUE#2.1', name);
        if (intersection[name] === statisticNumbers.length) {
          // log('UNIQUE#2.2', collection);
          const item = {
            classificationKey: undefined,
            code: name,
            id: n,
            inhalt: name,
            links: '',
            merkmale: 0,
            name,
          };
          collection.push(item);
          n += 1;
        }
      }
    }
    // log('UNIQUE#3', collection);
    intersection = collection;
    if (intersection.length === 0) {
      let ret;
      if (statisticNumbers.length > 1) {
        ret = 'Für die ausgewählten Statistiken stehen keine statistikübergrei- fenden Daten zur Verfügung. Unter dem Menüpunkt Daten- bestände sind die derzeitig verfügbaren Daten einsehbar.';
      } else {
        ret = 'Für die ausgewählte Statistik stehen keine Daten zur Verfü- gung. Unter dem Menüpunkt Datenbestände sind die derzeitig verfügbaren Daten einsehbar.';
      }
      this.growl.show({
        severity: 'info', summary: 'Hinweis', detail: ret, life: 20000,
      });
    }
    // log('#####', intersection);
    return intersection;
  }

  async showSaveTable() {
    const tableData1 = [];
    for (let i = 0; i < saveVariables.length; i += 1) {
      tableData1[saveVariables[i]] = this.state[saveVariables[i]];
    }
    // log('VARIABLES#', tableData1);
    const tableLoaded = this.hasTableLoaded();
    if (tableLoaded) {
      // await this.renderTable(); // refresh table before save 1756, aus 2565
    } else {
      // await this.loadTemplate();
      // sollte man hier das Template Laden oder erst im saveTable()
    }
    this.setState({ saveTableVisible: true });
  }

  onHideSaveTable() {
    this.setState({
      saveTableVisible: false,
      saveTableOverrideMessage: '',
    });
  }

  abortOverride() {
    this.setState({ saveTableOverrideMessage: '' });
  }

  showExportTable() {
    this.setState({ exportTableVisible: true });
  }

  onHideExportTable() {
    this.setState({ exportTableVisible: false });
  }

  async jobTable(resultTableName) {
    const { valueEmptyLines, sepQual, value } = this.state;
    this.setState({ visible: true });
    // erstelle Job mit /valueretrieval/insertRetrievalJob
    const { jobObj } = this.state;
    jobObj.contents['genesis.container.content.GenesisTMContent'].transfermodel.resultTableName = resultTableName;
    jobObj.contents['genesis.container.content.GenesisTMContent'].transfermodel.blankRows = valueEmptyLines;
    jobObj.contents['genesis.container.content.GenesisTMContent'].transfermodel.blankColumns = valueEmptyLines;
    jobObj.contents['genesis.container.content.GenesisTMContent'].transfermodel.sepQual = sepQual; // ADBHSSTAT-2728 ADBHSSTAT-2735
    jobObj.contents['genesis.container.content.GenesisTMContent'].transfermodel.showSecretValues = !value; // ADBHSSTAT-2833
    jobObj.contents['genesis.container.content.GenesisTMContent'].transfermodel.unsecretValuesFlag = !value;
    //jobObj.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.showSecretValues = [!value];
    const obj = {
      tableStructure: jobObj,
      doReturn: true,
    };
    const returnMessage = await this.messageService.postFreeInput('valueretrieval', 'insertRetrievalJob', obj);
    this.setState({
      visible: false,
    });
    if (returnMessage) {
      const severity = (returnMessage[0][0].number === 1079) ? 'hint' : 'error';
      this.growl.show({
        life: 12000, severity, summary: 'Hinweis', detail: returnMessage[0][0].message,
      });
      if (returnMessage[0][0].number === 1079) {
        this.setState({ jobTableVisible: false });
      }
    }
  }

  onHideJobTable() {
    this.setState({ jobTableVisible: false });
  }

  onHideManualJobTable() {
    this.setState({ manualJobTableVisible: false });
  }

  async manualJobTable(resultTableName) {
    const { valueEmptyLines, sepQual, value } = this.state;
    this.setState({ visible: true });
    // erstelle Job mit /valueretrieval/insertRetrievalJob
    //const { jobObj } = this.state;
    let structure = await this.messageService.postStructureInit();

    if(structure) { 
      const zeilen_graph = this.mergeGraphsRows2();
      const spalte1_graph = this.mergeGraphs2();
      const {
        headings_graph, pureFilter_graph,
        precondition_graph,
      } = this.state;
      const graphen = {
        spalte1_graph: JsonHelper.deepCopy(spalte1_graph),
        headings_graph: JsonHelper.deepCopy(headings_graph),
        zeilen_graph: JsonHelper.deepCopy(zeilen_graph),
        pureFilter_graph: JsonHelper.deepCopy(pureFilter_graph),
        precondition_graph: JsonHelper.deepCopy(precondition_graph),
      };
      const tree = TreeSerializer.build_directory_dto(graphen);

      structure = JSON.stringify(structure);
      // eslint-disable-next-line
      structure = structure.replace(/\"DATASET\"/, JSON.stringify("FILE"));
      structure = JSON.parse(structure);

      structure.contents['genesis.container.content.GenesisTMContent'].transfermodel.structureAxis = tree.structureAxis;

      const jobObj = await this.messageService.postRetrievalJobInit(structure.contents['genesis.container.content.GenesisTMContent'].transfermodel); 

      jobObj.contents['genesis.container.content.GenesisTMContent'].transfermodel.resultTableName = resultTableName;
      jobObj.contents['genesis.container.content.GenesisTMContent'].transfermodel.blankRows = valueEmptyLines;
      jobObj.contents['genesis.container.content.GenesisTMContent'].transfermodel.blankColumns = valueEmptyLines;
      jobObj.contents['genesis.container.content.GenesisTMContent'].transfermodel.sepQual = sepQual; // ADBHSSTAT-2728 ADBHSSTAT-2735
      jobObj.contents['genesis.container.content.GenesisTMContent'].transfermodel.showSecretValues = !value; // ADBHSSTAT-2833
      jobObj.contents['genesis.container.content.GenesisTMContent'].transfermodel.unsecretValuesFlag = !value;
      //jobObj.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.showSecretValues = [!value];
      const obj = {
        tableStructure: jobObj,
        doReturn: true,
      };
      const returnMessage = await this.messageService.postFreeInput('retrievaljob', 'insert', obj);
/*       this.setState({
        visible: false,
      }); */
      if (returnMessage) {
        const severity = (returnMessage[0][0].number === 1079) ? 'hint' : 'error';
        this.growl.show({
          life: 12000, severity, summary: 'Hinweis', detail: returnMessage[0][0].message,
        });
      }
    }
    else{
      this.growl.show({
        life: 12000, severity: 'error', summary: 'Fehler', detail: 'Es ist ein Fehler aufgetreten. Der Batch-Werteabruf konnte nicht gestartet werden.',
      });
    }
    this.setState({ manualJobTableVisible: false, visible: false });
  }

  onHideClearTable() {
    this.setState({ clearTableVisible: false });
  }

  mergeElements2() {
    const { elements2 } = this.state;
    let elements2Merged = elements2.TIME_CLASSIFYING.concat(
      elements2.REGION_CLASSIFYING,
    );
    elements2Merged = elements2Merged.concat(
      elements2.REGION_CLASSIFYING_TOTAL,
    );
    elements2Merged = elements2Merged.concat(
      elements2.SUBJECT_CLASSIFYING,
    );
    elements2Merged = elements2Merged.concat(
      elements2.SUBJECT_CLASSIFYING_TOTAL,
    );
    elements2Merged = elements2Merged.sort((a, b) => ((a.text > b.text) ? 1 : -1));
    return elements2Merged;
  }

  ruleVariablesToshowListItems(arr) {

    /* ?.map((item) => ({
      key: item.code,
      label: item.inhalt,
      childS: item.childS
    })) */
    const {outputEntry, selectedId, itemInList} = this.state;
    const result = [];
    for(let i = 0; i < arr?.length || 0; i++) {
      if(!outputEntry?.[selectedId]?.baseVariables?.includes(arr[i]?.variableName) || arr[i]?.variableName === itemInList ) {
        result.push(
          {
            /* name: arr[i].name,
            id: arr[i].id,
            classificationKey: arr[i].classificationKey, */
            key: arr[i].name,
            label: arr[i].inhalt ?  arr[i].inhalt : this.multiLanguage.returnInLanguage(arr[i], 'de'),
            /* links: '',
            merkmale: arr[i].variableCount, */
            children:  arr[i]?.variableName !== itemInList ? this.ruleVariablesToshowListItems(arr[i].childvalues) : []
          }
        )
      }
    }
    return result
  }

reduceShowList(list, parentKey) {
  let arr = {};
  list.forEach((item) => {
    //arr.push({key: item.key, checked: true})
    arr[item.key] = {checked: true, partialChecked: false, key: item.key, label: item.label, children: item.children}
    arr = {...arr, ...this.reduceShowList(item?.children || [], item.key)}
  })
  return arr
}

filtersToTreeSelectionKeys(list) {
  let arr = {};
  list.forEach((item) => {
    //arr.push({key: item.key, checked: true})
    arr[item.name] = {checked: true, partialChecked: false, label: item.label, key: item.key}
    arr = {...arr, ...this.filtersToTreeSelectionKeys(item?.childvalues || [])}
  })
  return arr
}

ruleAuspraegungenToFlatList(input, target) {
  input.forEach((item) => {
    target.push(item)
    if(item.childvalues) {
      this.ruleAuspraegungenToFlatList(item.childvalues, target)
    }
  })
}

/* filtersToCheckedTreeItems(setFilter) {
  const obj = {}
  for(let i = 0; i < setFilter.length; i++) {
    arr[item.name] = {checked: true, partialChecked: false}
  }

  return obj
} */

checkedTreeItemsToFilters(possibleFilter, checkedElements) {
const items = [];
 for(let i = 0; i < possibleFilter.length; i++) {
  if( checkedElements[possibleFilter[i].name]?.checked || checkedElements[possibleFilter[i].name]?.partialChecked  ) {
    if(possibleFilter[i].childvalues?.length > 0) {
      possibleFilter[i].childvalues = this.checkedTreeItemsToFilters(possibleFilter[i].childvalues, checkedElements)
    }
    items.push(possibleFilter[i])
  }
 }
 return items
}

  async switchRegionals() { // onpush, ondrop
    let incard;
    let targetContainer;
    const { location } = this.props;
    const {
      namesToChange,
      landPrefix,
    } = location.state;
    const newName = landPrefix + namesToChange[0];
    const regionals = this.state.elements.REGION_CLASSIFYING;
    // über alle namesToChange
    for (let mm = 0; mm < changeVariables.length; mm += 1) {
      targetContainer = changeVariables[mm];
      if (targetContainer.substr(targetContainer.length - 6) !== '_graph') {
        const contLength = this.state[targetContainer].length;
        if (contLength > 0) {
          // finde neue Card landPrefix+namesToChange[t] zu incard
          for (let pp = 0; pp < regionals.length; pp += 1) {
            const regional = regionals[pp];
            if (regional.name === newName) {
              incard = regional;
              // Hier kommt das Hinzufügen/Tauschen hin
              for (let ii = 0; ii < contLength; ii += 1) {
                if (this.state[targetContainer][ii].name === namesToChange[0]) {
                  const { showAverage, showMedian, selectedId } = this.state;
                  const { medianOnly, averageOnly } = incard?.output[0]?.reference;
                  const { name, type, ruleName } = incard;
                  // console.log('MEDIAN#', name)
                  let doFilterUpdate = false; // default
                  const card = JsonHelper.deepCopy(incard);
                  let newUniqueId;
                  if (targetContainer === 'filter') {
                    if (type === 'TIME_IDENTIFYING' || type === 'TIME_CLASSIFYING') {
                      // radio buttons
                      doFilterUpdate = true;
                    } else if (!incard.filter) {
                      doFilterUpdate = true;
                    } else if (incard.filter === []) {
                      doFilterUpdate = true;
                    }
                  }
                  if (card.uniqueId === '') { // diese Card ist neu
                    card.uniqueId = this.getUniqueId(); // set ID for connection btw. card and Statistics.jsx
                    newUniqueId = card.uniqueId;

                    showMedian[newUniqueId] = medianOnly; // 781
                    showAverage[newUniqueId] = averageOnly;
                    this.setState({ showMedian, showAverage });
                  }
                  const itemInList = card.code;
                  const tmp = JsonHelper.deepCopy(this.state[targetContainer][ii]);
                  // remeber formatting
                  incard.labelStructure = tmp.labelStructure;
                  incard.firstSumTotal = tmp.firstSumTotal;
                  incard.lastSumTotal = tmp.lastSumTotal;
                  incard.sumTogether = tmp.sumTogether;
                  this.state[targetContainer][ii] = incard; // this is the switch
                  this.makeNestedList(targetContainer);
                  await this.loadValues2(newUniqueId, card);
                  const { auspraegungenMap } = this.state;
                  const showList = auspraegungenMap[itemInList];
                  if (doFilterUpdate) {
                    if (showList) {
                      if (showList.length > 0) {
                        // set filter to showList[0].code
                        // and set activeFilter to true
                        const { arrFiltersById } = this.state;
                        if (type === 'TIME_IDENTIFYING') {
                          arrFiltersById[card.uniqueId] = [showList[showList.length - 1]];
                        } else {
                          arrFiltersById[card.uniqueId] = [showList[0]];
                        }
                        // array in id benötigt
                        this.setState({ arrFiltersById });
                        const deepCopyTargetContainer = JsonHelper.deepCopy(this.state[targetContainer]);
                        for (let i = 0; i < deepCopyTargetContainer.length; i += 1) {
                          if (deepCopyTargetContainer[i].code === incard.code) {
                            deepCopyTargetContainer[i].activeFilter = true;
                            deepCopyTargetContainer[i].filter = [showList[0].code];
                            this.setState({ [targetContainer]: deepCopyTargetContainer });
                          }
                        }
                      }
                    }
                    this.makeNestedList(targetContainer);
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  handleNameChange(e) {
    const { selectedId, arrNameById } = this.state;
    arrNameById[selectedId] = e.target.value;
    this.setState({
      arrNameById,
      // wertmerkmale: e.value,
    });
  }

  handleNameKeyDown(e) {
    const { selectedId, arrNameById } = this.state;
    arrNameById[selectedId] = e.target.value;
    this.setState({
      arrNameById,
      // wertmerkmale: e.value,
    });
  }

  handlePrefixChange(e) {
    const {prefixById, selectedId} = this.state;
    prefixById[selectedId] = e.target.value;
    this.setState({prefixById})
  }

  setRadio(e, orderData) {
    const { arrSelection, position, regelStufen,
      arrRuleOutputById, selectedId, regelStufenElemente } = this.state;
    console.log('ARRRULE#1', arrRuleOutputById, selectedId)
    const { value } = e;
    arrSelection[position].data.outputType = value;
    regelStufen[position].type = value;
    arrRuleOutputById[selectedId] = regelStufen;
    this.setState({ arrSelection, regelStufen, arrRuleOutputById });
  }

  setValuesForRules(e, orderData) {
    const templateObj = {
      type: 'DOCUMENTARY',
      name: '',
      visible: true,
    };
    const madeSelection = true;
    let { arrSelection, regelStufen, regelStufenElemente,
      arrRuleOutputById, selectedId } = this.state;
    if (!arrSelection) arrSelection = [{}];
    const { value } = e;
    if (value) {
      const countArr = value.split('-');
      const position = countArr.length - 1;
      let current = orderData.root[0];
      for (let k = 1; k < countArr.length; k += 1) {
        current = current.children[0];
      }
      let data;
      if (arrSelection[position]) {
        if (arrSelection[position].data) {
          data = arrSelection[position].data;
        } else {
          data = current.data;
        }
      } else {
        data = current.data;
      }
      arrSelection[position] = {
        data,
        value,
      };
      templateObj.name = data.dimension;
      templateObj.type = data.type;
      regelStufen[position] = templateObj;
      arrRuleOutputById[selectedId] = regelStufen;
      console.log('SEL#02', regelStufen);
      this.setState({
        arrRuleOutputById,
        regelStufen,
        madeSelection,
        arrSelection,
        selectedNodeKey: value,
        position,
      });
    }
  }

  selectButtonTemplate(option) {
    switch (option.value){
      case "VOID":
        return <i className='pi pi-block'></i>
      case "DOCUMENTARY":
        return <i className='pi pi-tag'></i>
      default:
        return <i className='pi pi-tags'></i>
    }
  } 

  render() {
    // 'Überlagerte Werte' not for Land-User in Bund Tables
    const {
      mounted,
      deactivateSectetSelect,
      data_html,
      visible,
      visible1,
      dialogueVisible,
      calcDialogueVisible,
      saveTableVisible,
      saveTableOverrideMessage,
      exportTableVisible,
      jobTableVisible,
      manualJobTableVisible,
      clearTableVisible,
      globalFilter,
      value,
      valueEmptyLines,
      sepQual,
      previewDeactivatedRadio,
      previewDeactivated,
      filter,
      headings,
      zeilen,
      spalte1,
      elements,
      elements1,
      elements3,
      itemInList,
      selectedId,
      selectionMode,
      hideRetrievalButton,
      arrRulesById,
      showRuleSelection,
      calcModeOn,
      calcModeOnById,
      rowHelperArray,
      colHelperArray,
      showAverage,
      showMedian,
      measureUnits,
      canSumUp,
      isTimeIdentifying,
      isTimeClassifying,
      isValue,
      disableCache,
      rulesMap,
      clearRules,
      outputEntry,
      regelStufenElemente,
      arrSelectedTreeNodes,
      isDialogOpen,
      hierarchySelection,
      prefixById
    } = this.state;

    const uniqueVariableTitles = new Set([].concat(...filter, ...headings, ...this.state.colArray, ...this.state.rowArray).map((merkmal) => merkmal.title))
    const tableDescription = [...uniqueVariableTitles].join(", ");

    const childS = {
      key: '',
      data: {
        name: '',
        outputType: 'VALUES',
        radioDisabled: false,
      },
    };
    const orderData = {
      root: [
        {
          key: '0',
          data: {
            name: '',
            outputType: 'VALUES',
            radioDisabled: false,
          },
        },
      ],
    };
    // const { regelStufenElemente } = this.state;
    let { arrSelection, position, madeSelection } = this.state;
    if (!arrSelection) { arrSelection = [{}]; position = 0 };
    // console.log('CHECK#', position, arrSelection);
    const outputSelectedData = arrSelection[position];
    // console.log('CHECK#5', outputSelectedData);
    const ruleData = {};
    let tab2Header = 'Ausgabe '
    if (outputEntry?.[selectedId]) {
      ruleData.name = this.multiLanguage.returnInLanguage(outputEntry[selectedId], 'de');
      ruleData.dimension = outputEntry[selectedId].name;
      ruleData.type = outputEntry[selectedId].type;
      const topRule = {
        key: undefined,
        data: ruleData,
      };
      if (ruleData) tab2Header = tab2Header + ruleData?.dimension;
      // Referenzregeln: baseVariables[0] / targetVariable
      if (outputEntry[selectedId].type === 'REFERENCE') {
        const baseVar = outputEntry[selectedId].baseVariableReferences[0].shortDescription.langText[0].text;
        // const targVar = outputEntry.shortDescription.langText[0].text;
        orderData.root[0].data.name = this.multiLanguage.returnInLanguage(outputEntry[selectedId].targetVariableReference, 'de');
        orderData.root[0].data.dimension = outputEntry[selectedId].targetVariable;
        orderData.root[0].data.type = outputEntry[selectedId].type;
        if(itemInList === outputEntry[selectedId].baseVariables[0]) {
          orderData.root[0].children = [];
          orderData.root[0].children[0] = childS;
          orderData.root[0].children[0].key = '0-0';
          orderData.root[0].children[0].data.name = baseVar;
          orderData.root[0].children[0].data.dimension = outputEntry[selectedId].baseVariables[0];
          orderData.root[0].children[0].data.type = outputEntry[selectedId].type;
          orderData.root[0].children[0].data.radioDisabled = true;
        }
      } else if (outputEntry[selectedId].type === 'HIERARCHY') {
        // Hierarchieregeln: hierarchyLevels/ / /name
        const { hierarchyLevels } = outputEntry[selectedId];
        const result = {
          key: '0',
          data: {
            name: this.multiLanguage.returnInLanguage(hierarchyLevels[0].targetVariableReferences, 'de'),
            dimension: hierarchyLevels[0].targetVariable,
            type: hierarchyLevels[0].type,
            outputType: 'VALUES',
            radioDisabled: false,
          },
          children: [],
        };
        let current = result;
        let i;
        let key;
        if(itemInList !== hierarchyLevels[0].targetVariable)
          for (i = 1; i < hierarchyLevels.length; i += 1) {
            key = `${current.key}-${0}`;
            const next = {
              key,
              data: {
                name: this.multiLanguage.returnInLanguage(hierarchyLevels[i].targetVariableReferences, 'de'),
                dimension: hierarchyLevels[i].targetVariable,
                type: hierarchyLevels[i].type,
                outputType: 'VALUES',
                radioDisabled: false,
              },
              children: [],
            };
            current.children.push(next);
            if (i === hierarchyLevels.length - 1) {
              topRule.key = `${current.key}-0-0`;
              topRule.data.radioDisabled = true;
              topRule.data.outputType = 'VALUES';
              topRule.data.name = this.multiLanguage.returnInLanguage(hierarchyLevels[i].baseVariableReferences, 'de');
              next.children = [topRule];
            }
            current = next;
            if(itemInList === hierarchyLevels[i].targetVariable) break;
          }
        orderData.root[0] = result;
      }
    }
    const expandedKeys = [];
    expandedKeys[0] = true;
    const {
      // visible,
      outputType,
    } = this.state;
    // const { selectOutputVisible } = this.props;

    const showTable = mounted && !previewDeactivated && data_html !== '';
    // determine rows/columns to display
    let someRowFilled = false;
    for (let r = 0; r < rowHelperArray.length; r += 1) {
      if (this.state[rowHelperArray[r]].length > 0) someRowFilled = true;
    }
    const showRows = (zeilen.length > 0);
    let someColFilled = false;
    for (let r = 0; r < colHelperArray.length; r += 1) {
      if (this.state[colHelperArray[r]].length > 0) someColFilled = true;
    }
    const showCols = (spalte1.length > 0);
    // Test für Wert-Merkmale
    let elementsW = this.state.elements.REGION_CLASSIFYING.concat(
      this.state.elements.SUBJECT_CLASSIFYING,
    );
    elementsW = elementsW.sort((a, b) => ((a.text > b.text) ? 1 : -1));
    // Ende test
    // Original:
    let wertmerkmale = elements.VALUE.map((entry) => ({
      label: `${entry.name} - ${entry.inhalt}`,
      value: entry.name,
    }));
    wertmerkmale = wertmerkmale.filter((item) => item.value !== 'VZAE');
    // log('E3LIST#1', wertmerkmale);
    const { arrRuleById, arrRuleCharById } = this.state;
    const userGroup = sessionStorage.getItem('group');
    const evaluationRegional = sessionStorage.getItem('evaluationRegional');
    let cannotSwitchToSecret = ((userGroup !== 'StBa' && evaluationRegional === 'Bund')
      || deactivateSectetSelect === true);
    if (userGroup === 'StBA') cannotSwitchToSecret = false;
    const tableRendered = JsonHelper.deepCopy(this.state.tableRendered);
    let subject = this.state.elements.SUBJECT_CLASSIFYING;
    let regional = this.state.elements.REGION_CLASSIFYING;
    subject = subject.sort((a, b) => ((a.text > b.text) ? 1 : -1));
    regional = regional.sort((a, b) => ((a.text > b.text) ? 1 : -1));
    const elements2Merged = this.mergeElements2();
    let showList = arrRuleCharById?.[selectedId] ? this.ruleVariablesToshowListItems(arrRuleCharById?.[selectedId]) : this.ruleVariablesToshowListItems(this.state?.auspraegungenMap?.[itemInList]);
    /* let showList = this.ruleVariablesToshowListItems(arrRuleCharById[selectedId]) 
    if (showList.length === 0) showList = this.ruleVariablesToshowListItems(this.state.auspraegungenMap[itemInList]); */
    //console.log("setRule2", this.reduceShowList(showList, ""))
    
    // log('SHOWLIST#', showList);
    // if (itemInListType === 'TIME_IDENTIFYING') showList = intersection;
    let showRuleList = this.displayRulesEmpty;;
    if(rulesMap[itemInList])showRuleList = showRuleList.concat(rulesMap[itemInList]);
    console.log("showRuleList", showRuleList)
    let arrDisplayById = '';
    let arrBMMById = '';
    let arrNameById = '';

    // Hole Tabellenname falls gespeicherte Tabelle
    const { testTableName } = this.state;
    let tableName = this.props.location.state ? this.props.location.state.loadedTable.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].name : '';
    if (testTableName) tableName = testTableName;
    const tableHeader = tableName ? (<h3>{tableName}</h3>) : undefined;
    let hasClassificationKey = false;
    if (this.state.auspraegungenMap[itemInList]) {
      if (this.state.auspraegungenMap[itemInList][0]) {
        if (this.state.auspraegungenMap[itemInList][0].classificationKey !== null) {
          hasClassificationKey = true;
        }
      }
    }

    // Sortierrichtung der Ausprägung Icon und Popup
    let arrDirectionById = this.state.arrDirectionById[selectedId];
    if (!arrDirectionById) arrDirectionById = 'up';
    let directionIcon = 'pi-md-expand-less';
    let directionTitle = 'aufsteigend';
    if (arrDirectionById === 'down') {
      directionIcon = 'pi-md-expand-more';
      directionTitle = 'absteigend';
    }

    // Filter
    let { display } = this;
    if (!hasClassificationKey) {
      display = display.slice(0, 3);
    }
    if (this.state.arrDisplayById[selectedId]) arrDisplayById = 'KN';
    arrDisplayById = this.state.arrDisplayById[selectedId];
    if (!arrDisplayById) arrDisplayById = 'KN';
    arrBMMById = this.state.arrBMMById[selectedId];
    arrNameById = this.state.arrNameById?.[selectedId];
    if (!arrNameById) arrNameById = '';

    // Regeln
    let selectedRule = arrRuleById[selectedId];
    if (!selectedRule) selectedRule = '';
    let listRules = [];
    if (arrRulesById) {
      if (arrRulesById[selectedId]) listRules = arrRulesById[selectedId];
    }

    // Sortierung der Ausprägungen
    let { sorting } = this;
    if (!hasClassificationKey) {
      sorting = sorting.slice(0, 2);
    }
    let arrSortingById = this.state.arrSortingById[selectedId];
    if (!arrSortingById) arrSortingById = 'FS';

    // filtern
    let arrFiltersById = arrSelectedTreeNodes?.[selectedId] ? arrSelectedTreeNodes?.[selectedId] : this.filtersToTreeSelectionKeys(this.state.arrFiltersById?.[selectedId] || [])
    //if(!arrFiltersById) arrFiltersById = sho
    /*  if(arrSelectedRuleNodes[selectedId]) {
      arrFiltersById = arrSelectedRuleNodes[selectedId]
      console.log("setRule 3", arrFiltersById, arrSelectedRuleNodes?.[selectedId])
    }
    else {
      if(this.state.arrRuleCharById[selectedId]) {
        arrFiltersById = this.filtersToTreeSelectionKeys(this.state.arrRuleCharById?.[selectedId] || [])
        arrSelectedRuleNodes[selectedId] = arrFiltersById
        console.log("setRule 33", arrFiltersById, this.state.arrRuleCharById?.[selectedId])
      }
      else {
        arrFiltersById = this.filtersToTreeSelectionKeys(this.state.arrFiltersById?.[selectedId] || [])
        arrSelectedRuleNodes[selectedId] = arrFiltersById
        console.log("setRule 333", arrFiltersById, this.state.arrRuleCharById?.[selectedId])
      }
      this.setState({arrSelectedRuleNodes})
      
    } */

    //const treeSelectionKeys = arrFiltersById.length > 0 ? this.reduceShowList(arrFiltersById, "") : this.state.arrFiltersById?.[selectedId]
    
    //if (!arrFiltersById) arrFiltersById = this.filtersToTreeSelectionKeys(this.state.arrFiltersById?.[selectedId] || [])//showList;
    if (showList && isTimeIdentifying) {
      showList.sort((a, b) => b.inhalt - a.inhalt);
    }
    const arrSumUpById = this.state.arrSumUpById[selectedId];
    const arrCalcUpById = this.state.arrCalcUpById[selectedId];
    const header = (
      <div className="table-header">
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText value={globalFilter} type="search" onChange={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Ausprägungen filtern" />
        </span>
      </div>
    );

    // Overlay for filtering MM
    const {
      overlayFilter, overlayHasFilter,
      overlayId, overlayFilteredList,
      intersection, selectedContainer,
    } = this.state;
    let dspValue = elements.VALUE;
    let dspValue1 = elements1.VALUE;
    let dspElements2Merged = elements2Merged;
    let dspValue3 = elements3.VALUE; // für Durchschnitt
    let dspSubject = subject;
    let dspRegional = regional;
    const [, , filter2,
      filter3, filter4, filter5, filter6, filter7] = overlayFilteredList;
    if (overlayFilteredList[2]) dspValue = filter2;
    if (overlayFilteredList[3]) dspValue1 = filter3;
    if (overlayFilteredList[4]) dspElements2Merged = filter4;
    if (overlayFilteredList[5]) dspSubject = filter5;
    if (overlayFilteredList[6]) dspValue3 = filter6;
    if (overlayFilteredList[7]) dspRegional = filter7;

    const hideDeleteButton = !this.showDeleteButton();
    const noIntersection = (Array.isArray(intersection) && intersection.length === 0);
    const hideRetrievalButtonNew = !this.showRetrievalButton()
      || hideRetrievalButton || noIntersection;
    const hideSaveButton = (
      filter.length === 0 && headings.length === 0
      && zeilen.length === 0 && spalte1.length === 0) || noIntersection;
    // const hideSaveButton = hideRetrievalButtonNew;
    const role = sessionStorage.getItem('role');
    // const userGroup = sessionStorage.getItem('group');
    const isMinistry = (userGroup.indexOf('Ministerium') !== -1);
    const internalSelectedValue = ((role === 'INTERNAL_USER' || isMinistry) && value === false);
    const selection = sessionStorage.getItem('evaluationRegional');
    const group = (sessionStorage.getItem('group'));
    let strRegion = 'Bund';
    if (group.indexOf('StLA') > -1) {
      strRegion = 'Land';
    }
    const ownRights = selection === strRegion;
    const hideExportButton = !this.hasTableLoaded() || (internalSelectedValue && !ownRights);
    const sumUpSelectItems = [
      { label: '▲', value: 'o' },
      { label: 'Insgesamt', value: 'i' },
      { label: 'Zusammen', value: 'z' },
    ];
    let sumUpButtons = (
      <div className='p-col-12' style={{display: "flex"}}>
        <div style={{ textAlign: 'center', fontSize: 'large', color: '#898989', padding: "0 0.5rem 0 0" }} title="Summe">
          ∑
        </div>
          <SelectButton
            disabled={!canSumUp}
            value={arrSumUpById}
            options={sumUpSelectItems}
            onChange={(e) => this.setSumUp(e)}
            multiple
          />
      </div>
    );
    if (isTimeIdentifying || isTimeClassifying || isValue) sumUpButtons = undefined;
    const calcUpSelectItems = [
      { label: 'Median', value: 'm' },
    ];
    const calcUpSelectItems1 = [
      { label: 'Arith. Mittel', value: 'am' },
    ];
    const items = [
      {
        label: 'Werteabruf',
        disabled: hideRetrievalButtonNew,
        icon: 'pi pi-md-check',
        command: async () => await this.renderTable(),
      },
      {
        label: 'Batch-Werteabruf',
        disabled: hideRetrievalButtonNew,
        icon: 'pi-md-play-arrow',
        command: async () => {this.setState({manualJobTableVisible: true})}
      },
      {
        label: 'Tabelle speichern',
        icon: 'pi pi-md-save',
        disabled: hideSaveButton, // 1756
        command: () => { this.showSaveTable(); },
      },
      {
        label: 'Tabelle exportieren',
        icon: 'pi pi-md-file-download',
        disabled: hideExportButton,
        command: () => { this.showExportTable(); },
      },
      {
        label: 'Klassifikation bilden',
        icon: 'pi pi-md-hdr-strong',
        disabled: true,
        command: () => { this.createClassification(); },
      },
      {
        label: 'Wert-Merkmal bilden',
        icon: 'pi pi-md-more',
        disabled: false,
        command: () => { this.showDialogue(); },
      },
      {
        label: 'Berechnung durchführen',
        icon: 'pi pi-md-dialpad ',
        disabled: false,
        command: () => { this.showCalcDialogue(); },
      },
      {
        icon: 'pi pi-md-delete',
        disabled: hideDeleteButton,
        command: () => { this.showClearDialogue(); },
      },
      {
        icon: 'pi pi-md-zoom-out-map',
        command: () => { maximizeTable(true); },
      },
    ];

    // let elementsDataNew = sessionStorage.getItem('evaluationStatistics').split(',');
    let { selectedStatistics } = this.state;
    const dspSelectedStatistics = selectedStatistics;
    const selectedStatistics2 = selectedStatistics;
    selectedStatistics = [];
    if (this.state.selectedStatistics) {
      const tmp3 = JsonHelper.deepCopy(this.state.selectedStatistics);
      selectedStatistics = this.state.selectedStatistics.map((entry) => (
        { label: entry.name, value: entry.name }));
    }
    const isTime = isTimeIdentifying || isTimeClassifying;
    let showRules;
    if (showRuleList.length === 2 && !showRuleList[1]) {
      showRules = showRuleList[1]; // empty default has 2 values && second is undefined
    } else {
      showRules = true;
    }
    const showSorting = !(selectedContainer === 'filter' && isTime);
    const showDisplaySelection = (!isTime);
    // listRules = this.displayRulesEmpty.concat(listRules);
    const isVzae = (itemInList === 'VZAE');

    const objAverageMedianRel = (
      <>
        <div className="p-col-12" />
        {!isVzae
          ? (
            <>
              <div className="p-col-1" style={{ textAlign: 'center', fontSize: 'large', color: '#898989' }} title="Rechenoperation">
                ❖
              </div>
              <div className="p-col-5">
                <SelectButton
                  disabled={selectionMode !== 'none' || !showMedian[selectedId]}
                  value={arrCalcUpById}
                  options={calcUpSelectItems}
                  onChange={(e) => this.setCalcUp(e)}
                />
              </div>
              <div className="p-col-5">
                <SelectButton
                  disabled={selectionMode !== 'none' || !showAverage[selectedId]}
                  value={arrCalcUpById}
                  options={calcUpSelectItems1}
                  onChange={(e) => this.setCalcUp(e)}
                />
              </div>
            </>
          )
          : undefined}
        <div className="p-col-12">
          <DropdownLabeled
            disabled={(selectionMode !== 'none' || !calcModeOnById[selectedId]) && !isVzae}
            style={{ width: '100%' }}
            id="line"
            label="Bezugsmerkmal"
            name="line"
            options={wertmerkmale}
            value={arrBMMById}
            onChange={(e) => this.setBMM(e)}
            autoWidth={false}
            tooltipOptions={{ event: 'focus' }}
          />
        </div>
        <div className="p-col-2">
          <InputText
            id="Prefix"
            name="Prefix"
            disabled={(selectionMode !== 'none' || !calcModeOnById[selectedId]) && !isVzae}
            style={{ width: '100%' }}
            value={prefixById[selectedId]}
            maxLength="255"
            onChange={(e) => this.handlePrefixChange(e)}
            //onKeyDown={(e) => this.setState({prefix: e.target.value})}
            //tooltip="Geben Sie hier den Beschreibungstext ein."
            //tooltipOptions={{ event: 'focus' }}
          />
        </div>
        <div className="p-col-10">
          <InputText
            id="Name"
            name="Name"
            disabled={(selectionMode !== 'none' || !calcModeOnById[selectedId]) && !isVzae}
            style={{ width: '100%' }}
            value={arrNameById}
            maxLength="255"
            onChange={(e) => this.handleNameChange(e)}
            onKeyDown={(e) => this.handleNameKeyDown(e)}
            tooltip="Geben Sie hier den Beschreibungstext ein."
            tooltipOptions={{ event: 'focus' }}
          />
        </div>
      </>
    );
    const visibilityVisible = {
      width: '300px',
      visibility: 'visible',
    };
    const visibilityHidden = {
      width: '300px',
      visibility: 'hidden',
    };
    const visibilityOverview = visibilityVisible;

    const ret = (
      <DndProvider backend={HTML5Backend}>
          <Growl ref={(el) => { this.growl = el; }} />
          <Dialog
            header="Aktualisiere Ansicht..."
            closable={false}
            closeOnEscape={false}
            visible={visible}
            modal
            onHide={() => this.setState({ visible: false })}
          >
            <div style={{ textAlign: 'center' }}><ProgressSpinner /></div>
          </Dialog>
          <ValueDialog
            header="Wert-Merkmal bilden"
            closeOnEscape
            visible={dialogueVisible}
            modal
            onHide={() => this.setState({ dialogueVisible: false })}
            closeDialogue={this.closeDialogue.bind(this)}
            selectedStatistics={selectedStatistics}
            elements={elements}
            measureUnits={measureUnits}
          />
          <CalcDialog
            header="Berechnung durchführen"
            closeOnEscape
            visible={calcDialogueVisible}
            modal
            onHide={() => this.setState({ calcDialogueVisible: false })}
            closeDialogue={this.closeDialogue.bind(this)}
            selectedStatistics={selectedStatistics}
            selectedStatistics2={selectedStatistics2}
            elements={elements}
            measureUnits={measureUnits}
            prepareElements={this.prepareElements.bind(this)}
          />
          <SaveTableDialog
            saveTableVisible={saveTableVisible}
            saveTableOverrideMessage={saveTableOverrideMessage}
            onHideSaveTable={this.onHideSaveTable.bind(this)}
            saveTable={this.saveTable.bind(this)}
            overrideTable={this.overrideTable.bind(this)}
            abortOverride={this.abortOverride.bind(this)}
            tableName={tableName}
            tableDescription={tableDescription}
          />
          <ExportTableDialog
            exportTableVisible={exportTableVisible}
            onHideExportTable={this.onHideExportTable.bind(this)}
            exportTable={this.exportTable.bind(this)}
          />
          <JobTableDialog
            jobTableVisible={jobTableVisible}
            onHideJobTable={this.onHideJobTable.bind(this)}
            jobTable={this.jobTable.bind(this)}
          />
          <JobTableDialog
            jobTableVisible={manualJobTableVisible}
            onHideJobTable={this.onHideManualJobTable.bind(this)}
            jobTable={this.manualJobTable.bind(this)}
            manual={true}
          />
          <ClearTableDialog
            clearTableVisible={clearTableVisible}
            onHideClearTable={this.onHideClearTable.bind(this)}
            clearTable={this.clearTable.bind(this)}
          />

          <OverlayPanel
            ref={(el) => { this.overlaySearch = el; }}
            onHide={(e) => this.setValuesOnHide2(e)}
          >
            <div>
              <InputText
                id="InputSearchOverlay"
                value={overlayFilter[overlayId]}
                placeholder="Merkmale filtern"
                type="text"
                style={{ color: '#757575', backgroundColor: '#F5F5F5' }}
                onChange={(e) => this.handleChange(e)}
                onKeyDown={(e) => this.handleKeyDown(e)}
              />
            &nbsp;
              <i id="emptyInputText"
                style={{ color: '#757575', verticalAlign: 'bottom' }}
                className="pi pi-md-cancel"
                onClick={(e) => this.clearInput(e)}
              />
            </div>
          </OverlayPanel>

        <Dialog 
          visible={isDialogOpen}
          style={{width: '50vw'}}
          onHide={() => null}
          closable={false}
          closeOnEscape={false}
          contentStyle={{maxHeight: "80vh", overflowY: showAverage[selectedId] ? undefined : "auto"}}
          modal
          key={`${this.state.selectedId}-${isDialogOpen}`} //Workaround für ADBHSSTAT-2811 (Re-Render vom Dialog erzwingen)
        >
        <div
              className="p-grid"
             // style={visibilityOverview}
            >
              {sumUpButtons}
              {showSorting
                ? (
                  <>
                    <div className="p-col-12">
                    <div className="p-inputgroup">
                      <DropdownLabeled
                        containerStyle={{ width: "100%" }}
                        style={{ width: '100%' }}
                        disabled={selectionMode === 'none' || isTime}
                        id="lineSort"
                        label="Sortierung der Ausprägungen"
                        name="lineSort"
                        options={sorting}
                        value={arrSortingById}
                        onChange={(e) => this.setSorting(e)}
                        autoWidth={false}
                        tooltipOptions={{ event: 'focus' }}
                      />
                   {/*  </div>
                    <div className="p-col-6"> */}
                      <Button
                        icon={directionIcon}
                        onClick={() => this.setDirection()}
                        disabled={selectionMode === 'none'}
                        title={directionTitle}
                      />
                      </div>
                    </div>
                  </>
                ) : undefined}
              {showDisplaySelection
                ? (
                  <>
                    <div className="p-col-12">
                      <DropdownLabeled
                        disabled={selectionMode === 'none'}
                        style={{ width: '100%' }}
                        id="lineDsp"
                        label="Anzeige der Ausprägungen"
                        name="lineDsp"
                        options={display}
                        value={arrDisplayById}
                        onChange={(e) => this.setDisplay(e)}
                        autoWidth={false}
                        tooltipOptions={{ event: 'focus' }}
                      />
                    </div>
                  </>
                ) : undefined}
              {isVzae
                ? (
                  <>
                    <div className="p-col-12">
                      <DropdownLabeled
                        disabled={(selectionMode !== 'none' || !calcModeOnById[selectedId]) && !isVzae}
                        style={{ width: '100%' }}
                        id="lineBez"
                        label="Bezugsmerkmal"
                        name="lineBez"
                        options={wertmerkmale}
                        value={arrBMMById}
                        onChange={(e) => this.setBMM(e)}
                        autoWidth={false}
                        tooltipOptions={{ event: 'focus' }}
                      />
                    </div>
                    <div className="p-col-12">
                      <InputText
                        id="Name2"
                        name="Name2"
                        disabled={(selectionMode !== 'none' || !calcModeOnById[selectedId]) && !isVzae}
                        style={{ width: '100%' }}
                        value={arrNameById}
                        maxLength="255"
                        onChange={(e) => this.handleNameChange(e)}
                        onKeyDown={(e) => this.handleNameKeyDown(e)}
                        tooltip="Geben Sie hier den Beschreibungstext ein."
                        tooltipOptions={{ event: 'focus' }}
                      />
                    </div>
                  </>
                ) : undefined}
              {showRules === true && showRuleSelection
                ? (
                  <>
                    <div className="p-col-12">
                      <DropdownLabeled
                        title="Regeln"
                        disabled={selectionMode === 'none' || this.state.isLoadingRule}
                        style={{ width: '100%' }}
                        id="rule"
                        label="Regeln"
                        name="rule"
                        options={showRuleList}
                        value={selectedRule}
                        onChange={(e) => this.setRule(e)}
                        autoWidth={false}
                        tooltipOptions={{ event: 'focus' }}
                      />
                    </div>
                  </>
                ) : undefined}
    {/* <div className="p-col-12"> */}
         
                  <div className="p-col-12">
                    {selectionMode === 'multiple' &&
                    <ToggleButton disabled={this.state.isLoadingRule} onLabel="alle Ausprägungen auswählen" offLabel="alle Ausprägungen abwählen" onIcon="pi pi-md-check-box" offIcon="pi pi-md-check-box-outline-blank"
                                checked={!((this.state.arrFiltersById?.[selectedId] || []).length > 0)} onChange={() => {
                                  
                                  
                                  const {arrFiltersById, auspraegungenMap, arrRuleCharById, arrSelectedTreeNodes} = this.state;
                                  if((arrFiltersById?.[selectedId] || []).length > 0) {
                                    delete arrFiltersById[selectedId]
                                    delete arrSelectedTreeNodes[selectedId]
                                  }
                                  else {
                                  arrFiltersById[selectedId] = (arrRuleCharById?.[selectedId] || [] ).length > 0 ? arrRuleCharById[selectedId] : auspraegungenMap[itemInList]
                                  arrSelectedTreeNodes[selectedId] = this.filtersToTreeSelectionKeys(arrFiltersById?.[selectedId] || [])
                                  }
                                  this.setState({arrFiltersById, arrSelectedTreeNodes})
                                  }} />
                                }
                  </div>
                  {this.state.isLoadingRule ?
                          <div  style={{ display: "flex", alignItems: "center",  justifyContent: "center",  height: "240px", width: "100%" }}>
                          <ProgressSpinner/>
                          </div>
                          :
                          <>
                  <div className="p-col-12">
                    {selectionMode === 'none'
                      ? undefined
                      : (
                        <Tree
                          value={showList}
                          selectionMode={ selectionMode === 'multiple' ? "checkbox" : "single" }
                          selectionKeys={ selectionMode === 'multiple' ? arrFiltersById : Object.keys(arrFiltersById)[0]}
                          onSelectionChange={(e) => this.setValues(e)}
                          style={{ overflow: "hidden", height: "240px", width: "100%", display: "flex", flexDirection: "column" }}
                          filter
                        />
                      )}
                  </div>

                      {hierarchySelection?.[selectedId] && <div className="p-col-12">
                        <TreeTable
                          value={orderData.root}
                          //expandedKeys={expandedKeys}
                          selectionMode="single"
                          selectionKeys={this.state.selectedNodeKey}
                        >
                          <Column field="name" header="Name" expander></Column>
                          <Column header="Ausgabe" body={(row) => {
                           return <SelectButton 
                                    value={hierarchySelection[selectedId][row.data.dimension]} 
                                    options={[{label: "keine", value: ["VOID"]}, {label: "Text", value: ["DOCUMENTARY"]}, {label: "Text/Werte", value:["DOCUMENTARY", "VALUES"]}]} // <i className='pi pi-md-block'/> <i className='pi pi-md-label'/> <i className='pi pi-md-done'/>
                                    onChange={(e) => {                                      
                                      if(e.value) {
                                        const { hierarchySelection } = this.state;
                                        hierarchySelection[selectedId][row.data.dimension] = e.value
                                        this.setState({hierarchySelection})
                                      }
                                    }}
                                    tooltip={""}
                                    />
                          }
                            
                          } />
                        </TreeTable>
                      </div>}
                  </>
    }
              {showAverage[selectedId] ? objAverageMedianRel : undefined}
            </div>
            <div className="p-col-12" style={{display: "flex", justifyContent: "flex-end"}}>
              <Button disabled={this.state.isLoadingRule} className="p-button-success" label="Anwenden" icon="pi pi-check" onClick={() => {
                if(this.state.arrFiltersById?.[selectedId]?.length > 0 || selectionMode === 'none')
                  this.setValuesOnHide2()
                else
                  this.growl.show({
                    life: 5000,
                    severity: 'info',
                    summary: 'Hinweis',
                    detail: 'Es muss mindestens eine Ausprägung ausgewählt sein.',
                  });
                }} />
             
            </div>
        </Dialog>
          <div className='p-grid p-align-stretch' style={{overflow: "hidden", flexWrap: 'unset'}}>
            <div className='p-col' style={{display: "flex", flexDirection: "column"}}>
              <div className="card">
                <span style={{ color: 'rgb(153, 153, 153)', fontSize: '12px' }}>Statistiken</span>
                <DataView
                  value={dspSelectedStatistics}
                  layout="grid"
                  itemTemplate={this.itemTemplate}
                />
              </div>
              <div style={{ overflowY: 'scroll' }}>
                <div style={{ width: '220px' }}>
                  {elements.TIME_IDENTIFYING.length > 0 ? (
                    <DataContainer
                      header="Zeitidentifizierende Merkmale"
                      id={1}
                      overlayId={0}
                      overlayHasFilter={overlayHasFilter}
                      list={elements.TIME_IDENTIFYING}
                    />
                  ) : ''}
                </div>
                <div style={{ width: '220px' }}>
                  {elements.TIME_CLASSIFYING.length > 0 ? (
                    <DataContainer
                      header="Zeitklassifizierende Merkmale"
                      id={2}
                      overlayId={1}
                      overlayHasFilter={overlayHasFilter}
                      list={elements.TIME_CLASSIFYING}
                    />
                  ) : ''}
                </div>
                <div style={{ width: '220px' }}>
                  {elements.VALUE.length > 0 ? (
                    <DataContainer
                      showSearchOverlay={this.showSearchOverlay}
                      clearInput={this.clearInput}
                      header="Wert-Merkmale"
                      id={3}
                      overlayId={2}
                      overlayHasFilter={overlayHasFilter}
                      list={dspValue}
                    />
                  ) : ''}
                </div>
                <div style={{ width: '220px' }}>
                  {elements1.VALUE.length > 0 ? (
                    <DataContainer
                      showSearchOverlay={this.showSearchOverlay}
                      clearInput={this.clearInput}
                      header="Erstellte Wert-Merkmale"
                      id={5}
                      overlayId={3}
                      overlayHasFilter={overlayHasFilter}
                      list={dspValue1}
                    />
                  ) : ''}
                </div>
                <div style={{ width: '220px' }}>
                  {elements3.VALUE.length > 0 ? (
                    <DataContainer
                      showSearchOverlay={this.showSearchOverlay}
                      clearInput={this.clearInput}
                      header="Wert-Merkmale zur Durchschnitts-/Medianberechnung"
                      id={7}
                      overlayId={6}
                      overlayHasFilter={overlayHasFilter}
                      list={dspValue3}
                    />
                  ) : ''}
                </div>
                <div style={{ width: '220px' }}>
                  {elements3.VALUE.length > 0 ? (
                    <DataContainer
                      showSearchOverlay={this.showSearchOverlay}
                      clearInput={this.clearInput}
                      header="Durch Regeln abgeleitete Statistik-Merkmale"
                      id={6}
                      overlayId={4}
                      overlayHasFilter={overlayHasFilter}
                      list={dspElements2Merged}
                    />
                  ) : ''}
                </div>
                <div style={{ width: '220px' }}>
                  {regional.length > 0 ? (
                    <DataContainer
                      showSearchOverlay={this.showSearchOverlay}
                      clearInput={this.clearInput}
                      header="Regionalmerkmale"
                      id={11}
                      overlayId={7}
                      overlayHasFilter={overlayHasFilter}
                      list={dspRegional}
                    />
                  ) : ''}
                </div>
                <div style={{ width: '220px' }}>
                  {subject.length > 0 ? (
                    <DataContainer
                      showSearchOverlay={this.showSearchOverlay}
                      clearInput={this.clearInput}
                      header="sachlich-klassif. Merkmale"
                      id={4}
                      overlayId={5}
                      overlayHasFilter={overlayHasFilter}
                      list={dspSubject}
                    />
                  ) : ''}
                </div>
              </div>
            </div>
            <div className='p-col' style={{flex: "0 1 100%", overflow: "hidden", display: "flex"}}>
              <div style={{overflow: "hidden", display: "flex", flexDirection: "column", width: "100%"}}>
                <div>
                  <Menubar model={items}  />
                  <div>
                    <ul style={{
                      padding: '6px 3px 3px 3px',
                      listStyle: 'none',
                      background: 'white',
                      border: '1px solid #d8d8d8',
                      borderRadius: '0px 3px 0px 3px',
                    }}>
                      <li key="lineSel" style={{ display: 'inline-block', width: '18em' }}>
                        <InputSwitch
                          checked={valueEmptyLines}
                          onChange={(e) => this.hideEmptyLines(e.value)}
                        />
                      &nbsp;Leerzeilen/-spalten ausblenden
                      </li>
                      <li key="previewSel" style={{ display: 'inline-block', width: '18em' }}>
                        <InputSwitch
                          checked={previewDeactivatedRadio}
                          onChange={(e) => this.hidePreview(e.value)}
                        />
                      &nbsp;Tabellenvorschau deaktivieren
                      </li>
                      <li key="previewSel" style={{ display: 'inline-block', width: '18em' }}>
                        <InputSwitch
                          checked={sepQual}
                          onChange={(e) => this.toggleQuality(e.value)}
                        />
                      &nbsp;mit Qualitätskennzeichen
                      </li>
                      <li key="valSel" style={{ display: 'inline-block', width: '18em' }}>
                        <InputSwitch
                          disabled={cannotSwitchToSecret}
                          checked={value}
                          onChange={(e) => this.checkSecretValues(e.value)}
                        />
                      &nbsp;Überlagerte Werte
                      </li>
                    </ul>
                  </div>
                  <div>
                    <Recycler
                      id={9999}
                      list={[]}
                      containerName="recycler"
                      header="Papierkorb"
                    />
                  </div>
                </div>
                <div style={{overflow: "scroll", height: "100%"}}>
                    <table>
                      <tbody>
                        <tr>
                          <td id="td_filterzeilen" width="10%" valign="top" rowSpan="2">
                            <div style={{ width: '240px' }}>
                              <Container
                                id={8}
                                list={filter}
                                containerName="filter"
                                pushCard={this.pushCard.bind(this)}
                                removeCard={this.removeCard.bind(this)}
                                moveCard={this.moveCard.bind(this)}
                                showOverlay={this.showOverlay.bind(this)}
                                makeNestedList={this.makeNestedList.bind(this)}
                                header="Vorbedingungen/Filter"
                                popup=""
                              />
                            </div>
                            <div style={{ width: '240px', marginBottom: this.state.rowArray[0].length > 0 ? '-30px' : '0px' }}>
                              <HeadingsContainer
                                id={9}
                                list={headings}
                                containerName="headings"
                                pushCard={this.pushCard.bind(this)}
                                removeCard={this.removeCard.bind(this)}
                                moveCard={this.moveCard.bind(this)}
                                showOverlay={this.showOverlay.bind(this)}
                                makeNestedList={this.makeNestedList.bind(this)}
                                header="Zwischenüberschrift"
                                popup=""
                              />
                            </div>
                            {this.renderRowArray()}
                          </td>
                          <td id="td_spalten" valign="top" colSpan="2" style={{ display: 'flex', marginLeft: this.state.colArray[0].length > 0 ? '-30px' : '30px' }}>
                            {this.renderColArray()}
                          </td>
                        </tr>
                        <tr>
                          <td id="td_tabelle" height="600px" width="20px" valign="top" colSpan="2">
                            <div id="pivotTableDiv">
                              <div width="100%" id="implodeExpand" style={{ textAlign: 'right', visibility: 'hidden' }}>
                                <Button icon="pi-md-crop-free" onClick={() => maximizeTable(false)} />
                              </div>
                              {tableHeader}
                              {mounted && !previewDeactivated
                                ? (
                                  <div id="results">
                                    <DestatisTableRenderer2
                                      {...tableRendered}
                                      data_html={data_html}
                                      disableCache={true}
                                    />
                                  </div>
                                )
                                : (
                                  <Dialog
                                    header="Auswertungsoberfläche wird geladen..."
                                    closable={false}
                                    closeOnEscape={false}
                                    visible={visible1}
                                    modal
                                    onHide={() => this.setState({ visible: false })}
                                  >
                                    <div style={{ textAlign: 'center' }}><ProgressSpinner /></div>
                                  </Dialog>
                                )}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                </div>
              </div>
            </div>
          </div>
      </DndProvider >
    );
    return ret;
  }
}
